{
  "accessibility": {
    "closeModal": "Modal schließen",
    "useSetting": "Verwenden Sie die Einstellung",
    "srOnly": {
      "close": "Schließen",
      "loading": "Wird geladen…"
    }
  },
  "account": {
    "salesResources": {
      "title": "Vertriebsressourcen",
      "searchDocuments": "Dateien durchsuchen",
      "minimalRating": "Minimale Bewertung",
      "maxRating": "Maximale Bewertung"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Aktivieren Sie die erneute Abrechnung für diesen Kunden, um bis zu 10-fache Gewinne aus der Nutzung von Telefon, E-Mails, Automatisierungen usw. zu erzielen.",
      "enableRebilling": "Neuberechnung aktivieren",
      "servicesActivateAfterPayment": "Die Neuberechnungsdienste werden aktiviert, nachdem der Kunde eine Zahlungsmethode hinzugefügt hat. Bis dahin ist der Zugriff des Kunden auf das Konto eingeschränkt.",
      "cannotModifyOnHold": "Die Neuberechnungseinstellungen können nicht geändert werden, da dieses Unterkonto bereits mit einem ausstehenden SaaS-Tarif verknüpft ist. Neuberechnungsaufschläge werden entsprechend dem Tarif konfiguriert, wenn der Kunde eine Zahlungsmethode hinzufügt.",
      "rebillingSettings": "Einstellungen für die Neuberechnung"
    }
  },
  "affiliates": {
    "aboutMe": "Über mich",
    "error": {
      "unableToSend": "E-Mail konnte nicht gesendet werden"
    },
    "industriesServed": "Bediente Branchen",
    "sendAMessage": "Eine Nachricht senden",
    "sendMessageIntro": "Senden Sie eine Nachricht, um sich diesem Berater vorzustellen. Geben Sie Details zu Ihrer Person und den von Ihnen gewünschten Dienstleistungen an.",
    "socialSites": "Soziale Medien",
    "success": {
      "emailSent": "E-Mail erfolgreich versendet"
    },
    "validationErrors": {
      "validEmail": "Bitte geben Sie eine gültige E-Mail-Adresse an.",
      "validMessage": "Bitte geben Sie eine gültige Nachricht ein.",
      "validName": "Bitte geben Sie einen gültigen Namen an."
    },
    "yearsInBusiness": "Jahre im Unternehmen",
    "yourEmail": "Ihre E-Mail-Adresse",
    "yourName": "Ihr Name",
    "paymentDetailsAccessMessage": " Dieser Abschnitt für Ausschüttungsdetails ist nur für den Agenturansicht Eigentümer Via <strong>Agenturinhaber</strong> zugänglich und bearbeitbar. Falls Sie Unterstützung benötigen, kontaktieren Sie bitte Ihren <strong>Agenturansicht Eigentümer ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Partner-Abzeichen",
    "photoAlt": "Partnerfoto",
    "defaultCompany": "Kein Unternehmen",
    "moreServices": "+ {count} weitere Services"
  },
  "agency": {
    "saas": {
      "saasMode": "SaaS-Modus",
      "pendingPaymentInformation": "Anstehende Zahlungsinformationen",
      "customerId": "Kunden-ID",
      "noPaymentMethods": "Es scheint, dass keine Zahlungsmethoden hinzugefügt wurden! Bitte fügen Sie eine Zahlungsmethode hinzu, um den SaaS-Modus zu aktivieren.",
      "enableSaasDescription": "Aktivieren Sie SaaS an diesem Standort, um Abonnements zu erstellen und die Nutzung von Telefon und E-Mail erneut abzurechnen.",
      "missingEmailAddress": "Die E-Mail-Adresse des Kontos fehlt, bitte fügen Sie zuerst die Details hinzu.",
      "toConvertToSaaS": "Um dieses Konto in SaaS umzuwandeln, müssen Sie zuerst einen Standortadministrator hinzufügen und es dann erneut versuchen.",
      "newUser": "Neuen Benutzer erstellen",
      "stripeCustomerConnected": "Stripe-Kunde wurde erfolgreich verbunden!",
      "requestClientPaymentDetails": "Zahlungsdetails des Kunden anfordern",
      "saasLocationDescription": "Standorte im SaaS-Modus erfordern die Kreditkarte Ihres Kunden, um zu funktionieren. Sie können eine Anfrage per E-Mail, SMS oder durch Teilen einer URL stellen.",
      "selectSpace": "Feld auswählen, um fortzufahren",
      "spaceDescription": "Der hier ausgewählte Speicherplatz wird verwendet, um die Informationen dieses Kunden zu speichern, deren Zahlungen zu verarbeiten und deren Abonnements zu verwalten.",
      "stripe": "Stripe",
      "freeCreditsDescription": "Wenn sich ein Benutzer anmeldet, können Sie ihm kostenlose Credits für die Nutzung von E-Mail- und Telefoniediensten anbieten.",
      "thatAboutMinsInCalls": "Das entspricht ungefähr {count} Textnachrichten oder {count1} Minuten in Anrufen",
      "subscriptionSettings": "Abo-Einstellungen",
      "toUpgradeOrCancelPlan": "Zum Upgrade oder Kündigen des Plans",
      "allowClientUpgrade": "Dem Kunden (Unterkonto) ein Upgrade auf einen höheren Tarif ermöglichen.",
      "addNewPlanFeatures": "Fügen Sie beim Upgrade neue Planfunktionen hinzu.",
      "upgradeFeatureDescription": "Nach dem Upgrade auf einen höheren Zeitplan erhalten die Unterkonten Zugang zu den zusätzlichen Funktionen im neuen Zeitplan. Zugang zu den zusätzlichen Funktionen im neuen Plan.",
      "allowClientCancel": "Dem Kunden (Unterkonto) erlauben, sein Abonnement zu kündigen.",
      "snapshotDescription": "Der ausgewählte Schnappschuss wird automatisch zum neu erstellten SaaS-Standort hinzugefügt",
      "ownSnapshots": "Eigene Schnappschüsse",
      "selectAndContinue": "Wählen Sie aus und fahren Sie fort"
    },
    "advancedSettings": {
      "controlLocationSettings": "Standort-Einstellungen verwalten",
      "disableAddSmtp": "Deaktivieren Sie die Schaltfläche „E-Mail-Service hinzufügen“ in den E-Mail-Service-Steuerelementen des Unterkontos",
      "disableAddSmtpDescription": "Beschränken Sie Unterkonto-Benutzer darauf, ihren eigenen E-Mail-Anbieter hinzuzufügen",
      "enableReVerification": "Erneute Verifizierung für 90 Tage speichern",
      "lcEmailNotEnabled": "Für den Standort ist LeadConnector nicht als Standard-E-Mail-Anbieter festgelegt",
      "onlyVisibleForAgency": "Sie können diese Einstellung nur für die Agenturansicht aktiviert sehen",
      "reVerificationDescription": "Jeder E-Mail-Verifizierungsstatus wird nach 90 Tagen widerrufen (schützen Sie Ihren Ruf und stellen Sie die maximale Zustellbarkeit im Postfach sicher)",
      "account": {
        "accountDetails": "Kontodetails",
        "advancedEmailSettings": "Erweiterte E-Mail-Einstellungen",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA-konform",
        "smsEmailLimits": "SMS-/E-Mail-Limits",
        "socialProfiles": "Social-Media-Profile",
        "subscribed": "Abonniert"
      },
      "activityTracking": {
        "history": "Verlauf"
      },
      "addAccount": {
        "accountInfo": "Kontoinformationen",
        "accountSnapshots": "Konto-Schnappschüsse",
        "businessNiche": "Geschäftsbereich",
        "chooseBusinessNiche": "Wählen Sie einen Geschäftsbereich aus …",
        "pickSnapshot": "Bitte wählen Sie einen Schnappschuss aus",
        "selectSnapshot": "Schnappschuss auswählen",
        "title": "Unterkonto hinzufügen",
        "accountInfo1": "Kontoinformationen"
      },
      "addBalance": {
        "addBalanceToWallet": "Guthaben zum Wallet hinzufügen",
        "addMoneyToWallet": "Geld zum Wallet hinzufügen",
        "balanceAddedSuccessfully": "Guthaben erfolgreich hinzugefügt!",
        "cardWillBeCharged": "Karte mit der Endnummer {cardNumber} wird belastet",
        "complimentaryCredits": "Kostenlose Gutschriften ({credits})",
        "creditsRemovedByAgency": "Credits von der Agentur entfernt",
        "currentBalance": "Aktueller Kontostand",
        "customerCCWillNotBeCharged": "Die Kreditkarte des Kunden wird nicht belastet",
        "moneyWillBeAddedToWallet": "Geld wird dem Wallet hinzugefügt",
        "pleaseProvideAmountBetween": "Bitte geben Sie einen Betrag zwischen {min} und {max}an.",
        "processing": "Verarbeitung",
        "removeBalance": "Guthaben entfernen",
        "transactionSuccessful": "Transaktion erfolgreich",
        "walletBalance": "Wallet-Guthaben ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Wird hinzugefügt …",
        "cardDetails": "Kartendetails",
        "cardSuccessfullyAdded": "Karte wurde hinzugefügt",
        "errorWhileAddingCard": "Fehler beim Hinzufügen der neuen Karte!",
        "maximumCardUpdateLimitReached": "Maximales Limit für Kartenaktualisierungen erreicht",
        "rateLimitMessage": "Es scheint, als hätten Sie die zulässige Höchstanzahl an Versuchen zum Hinzufügen von Karten für heute erreicht. Bitte versuchen Sie es in 24 Stunden erneut."
      },
      "aiProductRebilling": {
        "funnel": " Funnel",
        "images": " Bilder,",
        "per1000Words": " /1.000 Wörter, ",
        "perFunnel": " /Funnel",
        "perImage": " / Bild,",
        "pleaseCheckSupport": "Bitte überprüfen Sie unser",
        "ratesMayDiffer": "Die Preise können je nach Region variieren. Die angezeigten Berechnungen basieren auf den Tarifen für das Vereinigte Königreich,",
        "ratesMayDifferUS": "Die Preise können je nach Region variieren. Die Berechnungen werden gemäß den Twilio-Tarifen für die USA angezeigt. Bitte überprüfen Sie Twilio für weitere Details.",
        "pleaseCheckTwilioRates": "Ausgehende SMS für die USA/Kanada werden mit 0,0079 $ pro Segment berechnet. Eingehende SMS mit 0,0075 $/Segment.",
        "words": " Wörter, "
      },
      "api": {
        "advancedFunctionalityNote": "Hinweis zur erweiterten Funktionalität",
        "agencyApiKeys": "Agentur API-Schlüssel",
        "apiAccess": {
          "partOfAdvancedApi": "Dies ist Teil der erweiterten API, die im Pro Plan verfügbar ist.",
          "toUpgrade": ", um ein Upgrade vorzunehmen."
        },
        "createNew": "Neu erstellen",
        "developerCouncilInfo": "Details zum Developer Council",
        "noAccess": "Sie haben keinen Zugriff auf diesen Bereich.",
        "securityAlert": "Sicherheitswarnmeldung",
        "table": {
          "fetchingKeys": "Unternehmensschlüssel werden abgerufen …",
          "noKeysYet": "Sie haben noch keine API-Schlüssel.",
          "toCreateFirstKeys": "um Ihre ersten API-Schlüssel zu erstellen."
        },
        "zapierNote": "Zapier-Notiz"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Möglichkeit, Google Kalender zum „Hinzufügen zu“ und „Konfliktkalender“ auszuwählen, um die Verfügbarkeit jedes Nutzers zu überprüfen",
        "abilityToAllocateRoundRobin": "Möglichkeit, Termine im Rotationsverfahren zuzuweisen",
        "abilityToChooseSpecificUser": "Möglichkeit, einen bestimmten Benutzer für den Termin auszuwählen",
        "adminAbilitySeeEveryUser": "Admin – Möglichkeit, die Kalendertermine aller Benutzer einzusehen",
        "adminAbilityViewAllCalendar": "Admin – Möglichkeit, die Kalendertermine aller Benutzer einzusehen",
        "adminsCanDeleteIntegrations": "Administratoren können alle gewünschten Integrationen löschen, aber Benutzer können nur ihre eigenen löschen",
        "adminsCanSeeAllIntegrations": "Administratoren können alle Integrationen sehen, unabhängig davon, wer sie erstellt hat, aber Benutzer können nur die Integrationen sehen, die sie selbst erstellt haben",
        "contactDetailAppointments": "Kontaktdetails > Termine (Neu)",
        "conversationsScheduleAppointment": "Konversationen > Termin planen (Neu)",
        "essentialConsiderations": "Wichtige Überlegungen",
        "funnelsWebsitesCalendar": "Funnels/Websites > Kalender (Neu)",
        "helpReorientTriggers": "Während des Anrufs werden wir dabei helfen, die Trigger an die neue Kalendereinstellung anzupassen",
        "iAgreeMessage": "Falls Sie mit den oben genannten Änderungen einverstanden sind, klicken Sie bitte auf „Ich stimme zu“, um den Kalender (Beta) an diesem Standort zu nutzen",
        "integrationNew": "Integration (Neu)",
        "loseAbilityToViewEdit": "Benutzer der neuen Version verlieren die Möglichkeit, Termine, die in der vorherigen Version erstellt wurden, über das Modal mit den Opportunity-Informationen anzusehen/zu bearbeiten. Sie können diese Aktionen jedoch weiterhin auf der Seite „Termine“ durchführen",
        "newOldTriggersCoexist": "Die neuen und alten Auslöser werden nebeneinander bestehen",
        "nonAdminAbilityViewPersonal": "Nicht-Administratoren – Möglichkeit, nur ihre persönlichen Termine anzusehen (Zugewiesene Daten/Kalenderzuordnung unter GRUPPENMANAGEMENT hat keine Auswirkungen)",
        "nonAdminViewPersonalOnly": "Nicht-Administrator – Möglichkeit, nur die eigenen Termine anzusehen",
        "notAtMoment": "Zur Zeit nicht. Aber wir bemühen uns sehr, diese Option so schnell wie möglich für Mobilgeräte verfügbar zu machen.",
        "oldAppointmentsCanBeViewed": "Die alten Termine können auf der Terminseite über einen Umschalter problemlos eingesehen werden.",
        "oldAppointmentsDisplayed": "Alte Termine werden neben den neuen Terminen in derselben Terminliste angezeigt",
        "oldCalendarVersionAppointments": "Alte Kalenderversion + Alte Termine",
        "onlyNewCalendarWidget": "Nur das neue Kalender-Widget kann hinzugefügt werden",
        "opportunityAddAppointment": "Opportunity > Termin hinzufügen (Neu)",
        "profilePageAdmin": "Profilseite für Admin (Neu)",
        "profilePageAllUsers": "Profilseite (Alle Benutzer)",
        "providesAllOptions": "Stellt alle Optionen (Gruppen + Dienste) bereit, die zur Konfiguration des neuen Kalenders erforderlich sind",
        "reintegratingConnectionsRequired": "Es kann erforderlich sein, alle Verbindungen erneut zu integrieren, sobald die Kalender-Beta für einen Standort aktiviert wird",
        "roundRobinHighlight": "Die Möglichkeit, Termine zwischen verschiedenen Gruppen von Agenten im Rotationsverfahren zuzuweisen, ist das Haupthighlight dieses Updates.",
        "schedulingCalendarAppointments": "Terminplanung > Kalender/Termine (Neue Filter + Umschalter, um zwischen neuen und alten Terminen zu wechseln)",
        "settingsCalendarBeta": "Einstellungen > Kalender (Beta)",
        "surfacingFirstTime": "Wird zum ersten Mal gezeigt",
        "teamManagementAdminOnly": "Gruppenmanagement (nur für Administratoren verfügbar)",
        "toggleOffNewVersion": "Deaktiviert (Neue Version)",
        "toggleOnOldVersion": "Aktiviert (alte Version)",
        "whatChangesWithNewVersion": "Welche Änderungen bringt die neue Version des Kalenders mit sich?",
        "whatDoesCalendarEntail": "Was umfasst der Kalender (Private Beta)?",
        "whatHappensToOldAppointments": "Was geschieht nach der Umstellung mit unseren alten Terminen?",
        "whatWillWeSeeMobile": "Was werden wir während der Beta-Phase in der mobilen Anwendung sehen?",
        "willOldAppointmentsBeFactored": "Werden alte Termine bei der Bestimmung der Verfügbarkeit für neue Termine berücksichtigt?",
        "willOldCalendarUrlsWork": "Werden unsere alten Kalender-URLs nach der Umstellung weiterhin funktionieren?",
        "willWeGetNewVersionMobile": "Werden wir die neue Version während der Beta-Phase auf Mobilgeräten nutzen können?",
        "yesOldSettingsPageContinues": "Ja. Tatsächlich wird die alte Einstellungsseite weiterhin bestehen, und somit bleibt Ihre Möglichkeit, dort Änderungen vorzunehmen, unverändert. Das alte Kalender-Widget und das neue Kalender-Widget werden unabhängig voneinander funktionieren, aber gleichzeitig kontinuierlich synchronisiert sein, um eine präzise Bestimmung Ihrer Verfügbarkeit über beide Systeme hinweg sicherzustellen. Um Verwirrung zu vermeiden, empfehlen wir Ihnen dringend, die neuen URLs wann immer möglich zu verwenden, damit Sie nicht gezwungen sind, zwei separate URLs für dieselben Benutzergruppen zu überwachen.",
        "yesSyncOnGoogleCalendar": "Ja, da die Einweg-Synchronisierung aktiviert ist, stellt Google Kalender sicher, dass nicht verfügbare Zeitfenster blockiert werden."
      },
      "companyPlansModal": {
        "billedAnnually": "Jährlich abgerechnet",
        "billedMonthly": "Monatlich abgerechnet",
        "changePlanFor": "Plan ändern für {locationName}",
        "notAuthorized": "Sie sind nicht berechtigt, diese Aktion auszuführen. Dies kann nur von Agentur-Benutzern/-Admins oder Standort-Admins durchgeführt werden.",
        "payAnnually": "Jährliche Zahlung",
        "payMonthly": "Monatliche Zahlung"
      },
      "locationBillingHistory": {
        "billingHistory": "Abrechnungsverlauf",
        "cardNo": "Kartennummer",
        "errorWhileFetchingInvoices": "Fehler beim Abrufen von Rechnungen. Klicken Sie hier, um es erneut zu versuchen",
        "invoiceDescription": "Rechnungsbeschreibung",
        "invoiceNo": "Rechnungsnummer",
        "noInvoices": "Keine Rechnungen",
        "refunded": "Erstattet",
        "succeeded": "erfolgreich",
        "view": "ANZEIGEN"
      },
      "locationWallet": {
        "autoRechargeWith": "Automatisch aufladen mit",
        "balance": "Guthaben:",
        "credits": "Gutschriften",
        "seeTransactions": "Transaktionen anzeigen",
        "whenBalanceLowerThan": "wenn Guthaben niedriger als"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Bitte überprüfen Sie Ihren E-Mail-Posteingang ({emails}).",
        "csvSentMessage": "Wir werden Ihnen eine CSV-Datei per E-Mail senden. Normalerweise dauert dies sieben bis zehn Minuten.",
        "enterEmailAddress": "E-Mail-Adresse eingeben",
        "exportAndSendCsv": "CSV exportieren und senden",
        "exportTransactions": "Transaktionen exportieren",
        "itUsuallyArrives": "Normalerweise dauert dies zehn Minuten.",
        "useCommasToSeparate": "Verwenden Sie Kommas, um mehrere E-Mail-Adressen zu trennen."
      },
      "modifySubscription": {
        "cancelClientDescription": "Kündigen Sie das Abonnement Ihres Kunden und schließen Sie das Konto",
        "cancelDescription": "Kündigen Sie Ihr Abonnement und schließen Sie das Konto",
        "cancelImmediately": "Sofort stornieren",
        "cancelNow": "Jetzt kündigen",
        "cancelSubscription": "Abonnement kündigen",
        "changedYourMind": "Haben Sie Ihre Meinung geändert?",
        "changedYourMindClient": "Sie können das Abonnement Ihres Kunden reaktivieren",
        "changedYourMindYou": "Sie können Ihr Abonnement reaktivieren",
        "confirmByTyping": "Bestätigen Sie den Vorgang, indem Sie unten {text} eingeben",
        "confirmCancellation": "Kündigung bestätigen",
        "modifySubscription": "Abonnement ändern",
        "modifyYourSubscription": "Ändern Sie Ihr Abonnement",
        "resumeSubscription": "Abonnement reaktivieren",
        "subscriptionWillBeCancelledOn": "Dadurch wird die Kündigung Ihres Abonnements für den {date} eingeplant. Sie können das Abonnement jederzeit fortsetzen, indem Sie die geplante Kündigung annullieren.",
        "subscriptionWillBeCancelledOnClient": "Dadurch wird die Kündigung des Abonnements Ihres Kunden für den {date} eingeplant. Sie und Ihre Kunden können das Abonnement jederzeit fortsetzen, indem Sie die geplante Kündigung annullieren.",
        "subscriptionWillBeCancelledOnDate": "Ihr Abonnement wird am {date} gekündigt.",
        "subscriptionWillBeCancelledOnDateClient": "Das Abonnement Ihres Kunden wird am {date} gekündigt.",
        "subscriptionWillBeResumed": "Ihr Abonnement wird reaktiviert und die Abrechnung erfolgt wieder regulär.",
        "subscriptionWillBeResumedClient": "Das Abonnement Ihres Kunden wird reaktiviert und die Abrechnung erfolgt wieder regulär.",
        "upgradeDescription": "Zu einem höheren Abonnementplan wechseln",
        "weAreGladYouStaying": "Wir freuen uns, dass Sie bleiben!",
        "nextBillingDate": "Nächstes Abrechnungsdatum: {date}",
        "cancelImmediatelyTitle": "Möchten Sie das Abonnement wirklich sofort kündigen?",
        "cancelNowDescription": "Ihr Abonnement ist für die Kündigung am {date} vorgesehen. Wenn Sie sich jetzt entscheiden zu kündigen, wird Ihr Konto, einschließlich aller ausgehenden Aktivitäten wie geplante Nachrichten und E-Mails, sofort gestoppt.",
        "cancelNowDescriptionClient": "Das Abonnement Ihres Kunden ist für die Kündigung am {date} vorgesehen. Wenn Sie sich jetzt entscheiden zu kündigen, wird das Konto Ihres Kunden, einschließlich aller ausgehenden Aktivitäten wie geplante Nachrichten und E-Mails, sofort gestoppt.",
        "modifyDescription": "Sie können Ihr Abonnement {action}",
        "modifyDescriptionClient": "Sie können das Abonnement Ihres Kunden {action} verwalten."
      },
      "noPaymentMethodWarning": {
        "addNow": "Jetzt hinzufügen",
        "youNeedToEnterCardInfo": "Sie müssen Ihre Karteninformationen eingeben.",
        "youNeedToEnterClientCardInfo": "Sie müssen die Karteninformationen Ihres Kunden eingeben."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Die Gebühren basieren auf Token. Die unten angegebenen Wortzahlen sind Schätzungen, die Ihnen helfen sollen, die Nutzung zu verstehen. Die tatsächlichen Gebühren können davon abweichen.",
        "examplePricingGpt4oMini": "Preisbeispiel – GPT-4o mini",
        "for750kWords": "(für 750.000 Wörter) ",
        "gpt4oMini": " GPT-4o mini ",
        "input": "Eingabe",
        "or": "oder ",
        "output": "Ausgabe",
        "perImage": " / Bild",
        "perResultSelection": " / Ergebnisauswahl",
        "ratesMayDifferUK": "Die Preise können je nach Region variieren. Die angezeigten Berechnungen basieren auf den Tarifen für das Vereinigte Königreich, bitte überprüfen Sie unsere",
        "ratesMayDifferUS": "Die Preise können je nach Region und Art der Nummer variieren. Berechnungen gemäß den Twilio-Tarifen für die USA,",
        "pleaseCheckSupport": "Bitte überprüfen Sie unser",
        "resultSelection": " Ergebnisauswahl",
        "supportDoc": "Support-Dokumentation",
        "forMoreDetails": "für weitere Einzelheiten",
        "words": " Wörter"
      },
      "removePaymentMethod": {
        "endingIn": "Endet in *{cardNo}",
        "no": "Nein",
        "removeCard": "Karte entfernen?",
        "removing": "Wird entfernt …",
        "yesRemove": "Ja, entfernen"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Zahlungsdetails des Kunden anfordern",
        "saasLocationDescription": "Ein SaaS-Abonnement für diesen Standort einrichten",
        "selectSpace": "Bereich auswählen",
        "spaceDescription": "Wählen Sie aus, wo die Abrechnung für diesen Standort eingerichtet werden soll"
      },
      "saasEnableProducts": {
        "disable": "Deaktivieren",
        "enableDisableProducts": "Produkte aktivieren/deaktivieren",
        "feature": "Funktion",
        "unsavedChanges": "Nicht gespeicherte Änderungen"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "Die nächste Abrechnung für diesen Kunden scheint in der Vergangenheit zu liegen. Das passiert, wenn das Stripe-Konto Ihrer Agentur nicht richtig funktioniert. Bitte melden Sie sich beim Stripe-Konto Ihrer Agentur an, um das Problem zu beheben.",
        "copiedText": "kopierter Text:",
        "couldNotCopy": "Async: Text konnte nicht kopiert werden: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Nächstes Abrechnungsdatum: ",
        "plan": "Plan",
        "pleaseContactAgency": "Bitte kontaktieren Sie die Agentur, um Ihr Abonnement zu aktivieren.",
        "stripeSubscriptionId": "Stripe-Abonnement-ID:",
        "subscriptionPlans": "Abonnementpläne",
        "subscriptionWillBeCancelledOn": "Ihr Abonnement wird am {date} gekündigt",
        "subscriptionWillBeCancelledOnClient": "Das Abonnement Ihres Kunden wird am {date} gekündigt",
        "toModifyClientSubscription": "um das Abonnement Ihres Kunden zu ändern",
        "toModifyYourSubscription": "um Ihr Abonnement zu ändern",
        "whatsappNumberSubscription": "Abonnement für WhatsApp-Nummer",
        "yourBillingDatePast": "Ihr nächstes Abrechnungsdatum scheint in der Vergangenheit zu liegen. Bitte wenden Sie sich an {email}, um dies zu beheben. Unterdessen wird alles wie gewohnt weitergehen."
      },
      "salesResources": {
        "certifiedUser": "Zertifizierter Benutzer",
        "clearFilter": "Filter zurücksetzen",
        "dateRange": "Datumsbereich"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "Sie werden {amount} $/Monat zahlen, {interval} in Rechnung gestellt",
        "planUpgradeFailed": "Ihr Plan konnte nicht heraufgestuft werden!",
        "planUpgraded": "Ihr Plan wurde heraufgestuft!",
        "retryUpgrade": "Upgrade erneut versuchen",
        "upgradeFailed": "Ihr Plan-Upgrade ist fehlgeschlagen. Bitte versuchen Sie es erneut",
        "upgradedSuccessfully": "Sie haben Ihren Plan {oldPlan} auf {newPlan} aktualisiert"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "als monatliche Gebühr von {amount}/Monat abgerechnet",
        "billedAsYearlyCharge": "als jährliche Gebühr von {amount}/Jahr abgerechnet",
        "upgradeFrom": "Upgrade von",
        "whatYouWillGet": "Sie erhalten:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Saldo nach Transaktion:",
        "callDuration": "Anrufdauer:",
        "callSid": "Anruf-SID:",
        "charge": "Gebühr:",
        "contact": "Kontakt:",
        "contactName": "Name des Kontakts:",
        "contactPhone": "Rufnummer des Kontakts:",
        "credit": "Gutschrift:",
        "creditsAfterTransaction": "Gutschrift nach Transaktion:",
        "dateSent": "Gesendet am",
        "deleted": "<Deleted>",
        "discount": "Rabatt:",
        "eventId": "Event-ID:",
        "from": "Von:",
        "noContactFound": "Kein Kontakt gefunden",
        "noOfSegments": "Anzahl der Segmente:",
        "openContactPage": "Kontaktseite öffnen",
        "openConversation": "Konversation öffnen",
        "openEvent": "Event öffnen",
        "originalCharge": "Ursprüngliche Gebühr:",
        "received": "Empfangen",
        "smsSid": "SMS-SID:",
        "timeBilled": "Abgerechnete Zeit:",
        "timeOfCall": "Zeit des Anrufs",
        "transactionDetails": "Transaktionsdetails –",
        "transactionId": "Transaktions-ID:",
        "type": "Typ:",
        "segments": "Segmente"
      },
      "calendarSettings": {
        "meetings": "Besprechungen",
        "services": "Dienste",
        "hideCalendarWarning": "Falls Sie das Kalender-Modul vollständig ausblenden möchten, tun Sie dies in den Unterkonto-Einstellungen > Meine Mitarbeiter > Rollen und Berechtigungen.",
        "calendarSettingsUpdated": "Kalendereinstellungen wurden aktualisiert",
        "meetingDescription": "Aktivieren Sie diese Option, um Unterkonten die Nutzung der Funktion „Besprechungen“ zu ermöglichen, die für die Verwaltung von Vertriebskalendern, Onboarding-Anrufen, Round-Robin-Planung, Teamzusammenarbeit, Kursbuchungen, Interviews und mehr konzipiert ist. Ideal für Unternehmen, die flexible und kollaborative Terminplanungswerkzeuge benötigen.",
        "serviceDescription": "Aktivieren Sie die Dienste, um Unterkonten Zugriff auf eine vollständige Buchungslösung für dienstleistungsbasierte Unternehmen zu gewähren. Dies umfasst die Erstellung von Buchungsseiten mit mehreren Diensten, die Verwaltung von Ressourcen, die Handhabung mehrerer Standorte, die Einstellung mitarbeiterspezifischer Preise, das Hinzufügen von Servicevarianten oder Plusleistungen und mehr."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Kopiert!",
      "copyApiKey": "API Key kopieren",
      "createApiKey": "API Key erzeugen",
      "deleteAllKeys": "Alle Keys löschen",
      "nameRequired": "Das Namensfeld ist erforderlich.",
      "somethingWentWrong": "Entschuldigung! Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
      "updatedSuccessfully": "Erfolgreich aktualisiert"
    },
    "billing": {
      "accountPaused": "Ihr Konto {name} wurde pausiert.",
      "accountProvisioned": "Ihr Konto wird bereitgestellt.",
      "activateSubAccount": "Unterkonto aktivieren",
      "activeServices": "Aktive Dienste",
      "addNewCard": "Neue Karte hinzufügen",
      "addNewService": "Neuen Dienst hinzufügen",
      "addPaymentMethod": "fügen Sie eine Zahlungsmethode hinzu,",
      "alertIcon": "alertIcon",
      "approve": "Genehmigen",
      "authenticateCardMessage": "Zur zusätzlichen Sicherheit müssen Sie Ihre Kartendaten erneut authentifizieren.",
      "badActorWarning": "Falls Sie der Meinung sind, dass dieses Unterkonto von einem Betrüger erstellt wurde, empfehlen wir Ihnen, dieses Unterkonto zu löschen und das entsprechende Abonnement zu kündigen.",
      "callUs": "Rufen Sie uns an",
      "cancelAndDelete": "Abonnement stornieren und Unterkonto löschen",
      "completeFormNextStep": "Bitte das Formular im nächsten Schritt ausfüllen",
      "congratulations": "🎉 Herzlichen Glückwunsch! 🎉",
      "contactAgency": "Bitte wenden Sie sich an Ihre Agentur, um dieses Problem zu beheben",
      "contactThroughEmailOrPhone": "Sie können uns zur Lösung dieses Anliegens entweder per E-Mail oder telefonisch kontaktieren",
      "dataSafe": "Alle Ihre Daten sind sicher und alle Automatisierungen, Webseiten usw. werden nach erfolgreicher Zahlung wieder funktionieren.",
      "declineSubAccount": "Unterkonto ablehnen",
      "deleteRecommendation": "Es wird empfohlen, dieses Unterkonto zu löschen. Sie können dies auch später auf der Seite „Unterkonten“ > „Kunden verwalten“ tun.",
      "emailUsAt": "Senden Sie uns eine E-Mail an",
      "moveToDashboard": "Zum Dashboard wechseln",
      "noPaymentMethods": "Anscheinend wurden keine Zahlungsmethoden hinzugefügt. Bitte",
      "paymentMethod": "Zahlungsmethode",
      "paymentMethodUpdated": "Ihre Zahlungsmethode wurde aktualisiert",
      "paymentNotCompleted": "Sie sehen diese Nachricht, weil die Zahlung nicht abgeschlossen wurde.",
      "proceedToNextStep": "Weiter zum nächsten Schritt",
      "questionMark": "?",
      "reachOutMessage": "Bei Fragen können Sie sich jederzeit gerne an uns wenden.",
      "reactivateBillingFor": "Reaktivierung der Abrechnung für {location}",
      "retryPayment": "Zahlung erneut versuchen",
      "secureSystemMessage": "Wir sind zu einem sichereren Abrechnungssystem gewechselt.",
      "setupMessage": "Jemand wird sich bei Ihnen melden, um die Konfiguration des Kontos vorzunehmen. Normalerweise dauert dies 12–24 Stunden.",
      "signout": "Abmelden",
      "subAccountId": "Unterkonto-ID:",
      "successfullyInitiated": "{product} wurde erfolgreich gestartet",
      "systemError": "Ein Systemfehler liegt vor",
      "toReactivate": "um das Konto zu reaktivieren",
      "userImage": "userImage",
      "verificationSkipped": "Die E-Mail- und Telefonverifizierung wird für dieses Unterkonto übersprungen, und der Kunde kann darauf zugreifen.",
      "verifyAccount": "Konto überprüfen",
      "verifyAfterAttempt": "Sie können dieses Konto nach mindestens einem Verifizierungsversuch durch den Unterkontoadministrator verifizieren",
      "verifySubAccount": "Überprüfen Sie das Unterkonto",
      "recommendedPlans": "Empfohlene Pläne",
      "buildYourOwnPlan": "ERSTELLEN SIE IHREN EIGENEN PLAN",
      "resetToDefaults": "Auf Standardeinstellungen zurücksetzen",
      "paymentMethodChange": "Wenn Sie die Zahlungsmethode ändern müssen",
      "approveSubAccount": "Unterkonto genehmigen",
      "approveSubAccountDescription": "Das Unterkonto wird wiederhergestellt, und die Administratoren des Unterkontos können darauf zugreifen und es nutzen.",
      "productInitiated": "Produkt gestartet"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "cancelKeep": "Abbrechen, behalten",
      "confirmDeletionInstructions": "Bestätigen Sie die Löschung, indem Sie {word} unten eingeben:",
      "enterConfirm": "Geben Sie {word} ein, um neu zu generieren",
      "message": "Dieser Standort-API Key wird gelöscht.",
      "title": "Standort-API Key löschen?",
      "yesDelete": "Ja, löschen"
    },
    "generalDetails": {
      "noPermission": "Sie haben keine Berechtigung, das Dokument hochzuladen. Überprüfen Sie Ihre Berechtigungen mit Ihrem Agency Admin.",
      "relatedContacts": "Verwandte Kontakte ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Sind Sie sicher, dass Sie alle Standort-API Keys löschen möchten?",
      "deleteAllConfirmTitle": "Möchten Sie alle Standort-API Keys löschen?",
      "deleteConfirmMessage": "Dadurch wird der API Key für den Standort: {location} gelöscht. Möchten Sie fortfahren?",
      "deleteAgencyApiKeyConfirmMessage": "Dadurch wird der API-Schlüssel gelöscht. Möchten Sie fortfahren?",
      "fetchingLocations": "Standorte werden abgerufen …",
      "maxApiKeysMessage": "Sie können maximal 5 API-Schlüssel besitzen.",
      "noLocationsFound": "Kein Standort gefunden",
      "old": "Alt",
      "proPlanRequiredMessage": "Dies ist Teil der erweiterten API, die im Pro Plan verfügbar ist.",
      "searchLocation": "Suchen Sie nach einem Standort",
      "title": "Standort-API Key"
    },
    "locationCard": {
      "deletionScheduledMessage": "Dieses Unterkonto wird am {date} gelöscht, falls Sie Ihre Meinung geändert haben  –",
      "emailUsageNotRebilled": "Die E-Mail-Nutzung wird nicht erneut in Rechnung gestellt",
      "emailUsageRebilled": "Die E-Mail-Nutzung wird Ihrem Kunden erneut in Rechnung gestellt",
      "listings": "Listings",
      "manageClient": "Kunden verwalten",
      "paymentPending": "Zahlung ausstehend",
      "remainingWalletBalance": "Verbleibendes Wallet-Guthaben dieses SaaS-Standorts",
      "requestPaymentAgain": "Zahlung erneut anfordern",
      "saasModeActivated": "SaaS-Modus ist aktiviert",
      "saasModeNotActivated": "SaaS-Modus ist nicht aktiviert",
      "saasSubscriptionNotEnabled": "SaaS-Abonnement ist nicht aktiviert",
      "saasSubscriptionRunning": "SaaS-Abonnement läuft",
      "social": "Soziale Medien",
      "switchToSaaS": "Wechseln Sie zu SaaS",
      "switchToSubAccount": "Zu Unterkonto wechseln",
      "telephoneUsageNotBilled": "Die Telefonnutzung wird nicht in Rechnung gestellt",
      "telephoneUsageRebilled": "Die Telefonnutzung wird Ihrem Kunden erneut in Rechnung gestellt",
      "wordpressActive": "WordPress aktiv",
      "wordpressInactive": "WordPress inaktiv",
      "wordpressNotSoldYet": "WordPress noch nicht verkauft",
      "wordpressSaleSuccessful": "WordPress-Verkauf erfolgreich abgeschlossen",
      "yextActive": "Yext aktiv",
      "yextInactive": "Yext inaktiv",
      "yextNotSoldYet": "Yext noch nicht verkauft",
      "yextSaleSuccessful": "Yext-Verkauf erfolgreich",
      "reviews": "Bewertungen"
    },
    "messageUsage": {
      "acceptTnc": "Bitte die AGB akzeptieren",
      "cannotPerformAction": "Diese Aktion kann nicht ausgeführt werden. Bitte wenden Sie sich an den Support.",
      "currentLimit": "Aktuelles Limit",
      "days": "Tag(e)",
      "failedToUpdate": "Die Nachrichtennutzung konnte nicht aktualisiert werden",
      "helpCentre": "Hilfe-Seite",
      "increaseLimitFurther": "Limit weiter erhöhen",
      "increaseLimitNow": "Limit jetzt erhöhen",
      "lessThanUsage": "Der aktuelle Verbrauch beträgt {usage} und der ausgewählte Verbrauch ist geringer als der aktuelle Verbrauch.",
      "lessThanUsageModal": "Der aktuelle Verbrauch beträgt {usage}; das Limit darf nicht unter dem aktuellen Verbrauch liegen",
      "limitAlreadyUnlocked": "Limit ist bereits freigeschaltet",
      "limitReached": "Limit erreicht",
      "limitUpdatedFrom": "{type}-Limit wurde von {old} auf {new} aktualisiert",
      "lookingForSmsLimit": "Auf der Suche nach SMS-Limit?",
      "minLimitShould": "Das niedrigste Limit sollte {limit} betragen",
      "newLimit": "Neues {type}-Limit",
      "perDay": "/ Tag",
      "sameLimit": "Ausgewähltes Limit ist dasselbe wie das aktuelle Limit!",
      "smsLimitLocation": "SMS-Limit ist jetzt auf Standortebene verfügbar",
      "smsLimitSettingsInfo": "Sie können diese Einstellungen jetzt unter „Nachrichtenlimit“ in „Erweiterte Einstellungen“ finden",
      "timesInLast30Days": "Zeiten in den letzten 30 Tagen",
      "todaysUsage": "Heutige Nutzung",
      "typePerDay": "{type} / Tag",
      "updateLimit": "Limit aktualisieren",
      "updateLimitFor": "Aktualisierung des {type}-Limits für {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Aktiver {type}",
      "contactSource": "Kontaktquelle",
      "customer": "Kunde",
      "noPastCampaignsWorkflows": "Keine Vergangenheit {type}",
      "pastCampaignsWorkflows": "Vergangener {type}"
    },
    "settings": {
      "affiliateSettings": "Einstellungen für Affiliates",
      "agencyBilling": "Agenturansicht Abrechnung",
      "agencyTeamManagement": "Agentur-Gruppenmanagement",
      "apiKeys": "API Keys",
      "compliance": "Einhaltung",
      "customMenuLink": "Benutzerdefinierte Menü-Links",
      "launchpadSettings": "Launchpad-Einstellungen",
      "phoneSystemTwilio": "Telefonsystem – Twilio",
      "smtpService": "SMTP Service",
      "userSettings": "Benutzereinstellungen",
      "agencySettings": "Agentur-Einstellungen",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Fehler beim Erstellen des Schnappschusses",
      "pickAnAccount": "Sie müssen ein Konto auswählen.",
      "snapshotName": "Schnappschussname",
      "snapshotNameRequired": "Sie müssen dem Schnappschuss einen Namen geben."
    },
    "socialDetails": {
      "blogRss": "Blog RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "Google Places ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "Instagram URL",
      "linkedInUrl": "LinkedIn URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pintrest URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Anfrage per SMS",
    "iAlreadyHaveACustomer": "Ich habe bereits einen Kunden",
    "noAccountFound": "Kein Konto gefunden!",
    "thisIs": "Dies ist",
    "pleaseEnterValueBetween0To30Days": "Bitte geben Sie einen Wert zwischen 0 und 30 Tagen ein",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Sie können diesen Plänen eine einmalige Einrichtungsgebühr hinzufügen",
    "doNotDeleteStripeProductsWarning": "Bitte <span style=\"font-weight: bold;\">löschen Sie diese Produkte nicht</span> in Ihrem Stripe-Konto",
    "opportunityStats": "Opportunity-Statistiken",
    "createNewSnapshot": "Neuen Schnappschuss erstellen",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Agentur-Dashboard sichtbar für",
      "onlyMe": "Nur für mich",
      "allAgencyAdmins": "Alle Agentur-Administratoren",
      "stripeConnect": "Wird demnächst nicht mehr verfügbar sein. Zu Stripe Connect wechseln",
      "recommendStripe": "Wir empfehlen aus Sicherheitsgründen die Verwendung von Stripe Connect",
      "switchToStripeConnect": "Zu Stripe Connect wechseln",
      "highLevelAccess": "HighLevel wird Zugriff auf Ihre Daten haben und kann Zahlungen und Kunden in Ihrem Namen erstellen",
      "stripeAccountWarning": "Sobald das Stripe-Konto verbunden ist, kann es später nicht mehr geändert werden. Es wird empfohlen, ein neues Stripe-Konto speziell für HighLevel-Einnahmen zu verwenden.",
      "connectToStripeAccount": "Verbinden Sie sich mit Ihrem Stripe-Konto",
      "unverified": "Das mit dieser Agentur verbundene Stripe-Konto ist nicht verifiziert und kann keine Zahlungen einziehen. Bitte schließen Sie die Verifizierung ab, indem Sie sich in Ihr Stripe-Konto einloggen.",
      "loginToStripe": "Melden Sie sich bei Stripe an",
      "connectedAccount": "Verbundenes Konto",
      "verified": "VERIFIZIERT",
      "totalPendingBalance": "Gesamter ausstehender Saldo",
      "disconnectStripe": "Stripe trennen",
      "removeSaasPlanConfigurations": "Alle SaaS-Plan-Konfigurationen entfernen?",
      "haveSaasPlans": "Sie haben SaaS-Pläne im Stripe-Konto erstellt!",
      "disconnectWarning": "Falls Sie es trennen, gehen alle SaaS-Pläne verloren und Sie müssen diese erneut erstellen.",
      "acknowledgeDisconnect": "Ich bestätige, dass alle meine SaaS-Pläne verloren gehen und ich diese erneut erstellen muss.",
      "disconnect": "Trennen"
    },
    "zoomSuccess": {
      "title": "Ich hoffe, Sie hatten eine großartige Erfahrung!",
      "message": "Vielen Dank, dass Sie am Anruf teilgenommen haben. Wir freuen uns darauf, Sie wieder bei uns begrüßen zu dürfen!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Ihr Spezialist für Probeabos",
      "successSpecialist": "Ihr Erfolgsspezialist",
      "supportSpecialist": "Ihr Supportspezialist",
      "jumpOnZoomCall": "Nehmen Sie an einem Zoom-Call mit mir teil, um Ihren Kick-off-Call zu beginnen.",
      "jumpOnChat": "Starten Sie einen Chat mit mir, um Hilfe zu erhalten",
      "joinVideoCallNow": "Treten Sie jetzt dem Video-Call bei",
      "whatToExpect": "Was können Sie erwarten?",
      "helpArticles": "Hilfeartikel",
      "changelog": "Änderungsprotokoll",
      "ideasBoard": "Ideenboard"
    },
    "saasDashboard": {
      "title": "SaaS-Dashboard",
      "plansAndPricing": "Pläne und Preise"
    },
    "listAccounts": {
      "newInterfaceAvailable": "Für diese Seite steht jetzt eine übersichtlichere und schnellere Konsole zur Verfügung. Probieren Sie es aus!",
      "enableInLabs": "In Labs aktivieren",
      "pendingTransferRequests": "Sie haben ausstehende Anträge zur Übertragung von Unterkonten.",
      "otherAgenciesRequested": "Andere Agenturen haben die Übertragung von Unterkonten auf Sie beantragt.",
      "reviewRequests": "Anfragen überprüfen",
      "clientList": "Kundenliste (Unterkonten)",
      "subAccountTransfers": "Übertragungen von Unterkonten"
    },
    "implementationModal": {
      "title": "Ihre HighLevel Video Call Erfahrung beginnt gleich!",
      "videoCall": "Videoanruf",
      "whatsNext": "Was kommt als Nächstes?",
      "enteringLobby": "Sie werden unsere Lobby zusammen mit anderen Highlevelers wie Ihnen betreten!",
      "successConcierge": "Unser Success-Concierge wird Sie begrüßen und mit dem nächsten verfügbaren Berater für eine 1:1-Sitzung verbinden.",
      "haveReady": "Bitte halten Sie Folgendes bereit",
      "stableInternet": "Stabile Internetverbindung.",
      "videoNameMatches": "Ihr Videoname stimmt mit Ihrem HighLevel-Benutzernamen überein.",
      "estimatedDuration": "Geschätzte Sitzungsdauer",
      "firstVisit": "Erster Besuch: HighLevel Onboarding-Sitzung: (45-60 Minuten).",
      "returning": "Rückkehr: Fortgesetzte Implementierungseinrichtungsunterstützung (15-25 Min.).",
      "meetingBegins": "Ihr Meeting wird automatisch in <span class=\"text-[#155EEF]\">{ countdown } Sekunden</span> beginnen.  Oder Sie können sofort beitreten, indem Sie auf die Schaltfläche unten klicken:",
      "joinNow": "Jetzt beitreten"
    },
    "gdpr": {
      "logo": "GDPR-Logo",
      "dataProtection": "Datenschutz und GDPR",
      "introduction": "Einführung",
      "intro1": "HighLevel verpflichtet sich, die Privatsphäre unserer Benutzer und ihrer Kunden zu schützen. Wir beobachten kontinuierlich Entwicklungen im Datenschutzrecht, um Ihnen die Sicherheit zu gewährleisten, der Sie sich bei der Nutzung unserer Plattform sicher sein können.",
      "intro2": "Diese Seite soll erklären, was die Regeln sind, wie sie auf Ihre Nutzung der HighLevel-Plattform angewendet werden und welche Schritte wir unternommen haben, um die Vorschriften einzuhalten.",
      "intro3": " Sie sollten dieses Dokument in Verbindung mit unserer Datenschutzrichtlinie prüfen und bei Bedarf weiterer Informationen oder Beratung einen spezialisierten Rechtsberater kontaktieren.",
      "gdprRegulation": "Datenschutz-Grundverordnung (GDPR)",
      "regulation1": "Die Verordnung (EU) 2016/679, besser bekannt als die Datenschutz-Grundverordnung (DSGVO), ist eine EU-Verordnung, die darauf abzielt, Datenschutz- und Privatsphäre-Gesetze in der gesamten EU zu harmonisieren. \"Die Bestimmungen der DSGVO gelten überall dort, wo personenbezogene Daten einer EU-betroffenen Person involviert sind.\"",
      "regulation2": "Die DSGVO konzentriert sich darauf, Einzelpersonen mehr Kontrolle darüber zu geben, wie ihre Daten von Unternehmen genutzt werden, und die Erfassung und Verarbeitung von Daten transparenter zu gestalten.",
      "regulation3": "Die DSGVO wurde direkt nach dem Ende der Brexit-Übergangsphase in das britische Recht übernommen, was bedeutet, dass britische Unternehmen weiterhin die Bestimmungen der 'UK GDPR' einhalten müssen.",
      "basicConcepts": "Grundlegende GDPR-Konzepte",
      "controllerAndProcessor": "Bediener und Auftragsverarbeiter",
      "controllerProcessorObligation": "Die DSGVO erlegt einer Person verschiedene Verpflichtungen auf, je nachdem, ob sie Verantwortlicher oder Auftragsverarbeiter personenbezogener Daten ist.",
      "controllerDefinition": " Ein Controller ist eine Entität, die entscheidet, personenbezogene Daten zu verarbeiten, und Entscheidungen bezüglich der Verarbeitungsgrundlage und der anzuwendenden Methoden trifft. Verantwortliche Stellen haben bestimmte Verpflichtungen in Bezug auf personenbezogene Daten, mit denen Sie sich vertraut machen sollten, bevor Sie personenbezogene Daten von Ihren Kunden erfassen.",
      "processorDefinition": "Ein Auftragsverarbeiter ist eine Stelle, die Daten für und im Auftrag eines Verantwortlichen verarbeitet. Sie treffen keine eigenständigen Entscheidungen bezüglich der Daten oder deren Verarbeitung, da sie diese ausschließlich im Auftrag des Verantwortlichen verarbeiten und allen Weisungen des Verantwortlichen Folge leisten müssen.",
      "youAreController": "Wenn Sie den HighLevel-Service nutzen, sind Sie ein Bediener. Sie haben die Kontrolle über die Daten, die Sie in das HighLevel-System hochladen, was Sie mit diesen Daten tun und warum. Als Ergebnis sind Sie dafür verantwortlich, sicherzustellen, dass Sie über eine Rechtsgrundlage verfügen, um die Daten zu verarbeiten, und dass Sie die Daten nicht länger als erforderlich aufbewahren.",
      "highlevelIsProcessor": "Sie sollten sicherstellen, dass Sie Ihre Verpflichtungen als Verantwortlicher verstehen und Ihre eigenen Systeme und Richtlinien aktualisieren, um die rechtmäßige Übermittlung personenbezogener Daten an HighLevel zu ermöglichen. HighLevel ist ein Datenverarbeiter. Wir speichern und verwalten über die HighLevel-Plattform die Daten, die Sie gemäß Ihren Anweisungen gesammelt haben. Wir werden niemals personenbezogene Daten, die Sie in das HighLevel-System hochgeladen haben, für unsere eigenen Zwecke oder ohne Ihre Anweisung verwenden.",
      "legalBasisForProcessing": "Rechtsgrundlage für die Verarbeitung",
      "legalBasisRequirement": "Personenbezogene Daten dürfen nur dann erfasst und verarbeitet werden, wenn eine Rechtsgrundlage dafür vorliegt. Die zulässigen Rechtsgrundlagen sind in der DSGVO dargelegt.",
      "processorReliesOnCustomers": "Als Verarbeiter verlässt sich HighLevel darauf, dass unsere Kunden die korrekte Rechtsgrundlage auswählen, unter der sie personenbezogene Daten erheben und verarbeiten werden, und die entsprechenden Hinweise und Einwilligungen einholen. Bevor Sie den HighLevel-Service nutzen, sollten Sie sich die Zeit nehmen, um zu ermitteln, welche rechtliche Grundlage für Sie verfügbar sein könnte, und personenbezogene Daten nur in dem Umfang erheben und speichern, der für die Durchführung dieser Grundlage erforderlich ist. Sie sollten die Grundlage, auf der Sie personenbezogene Daten erhoben haben, nicht ohne triftigen Grund ändern. Daher ist es wichtig, die Anforderungen der verschiedenen Grundlagen zu verstehen und sicherzustellen, dass Sie von Anfang an die richtige auswählen.",
      "dataSubjectAccessRights": "Berechtigungen des Datensubjekts",
      "dataSubjectRights": "Die DSGVO gewährt betroffenen Personen (d. h. Ihren Kunden) bestimmte Rechte in Bezug auf ihre personenbezogenen Daten, einschließlich des Rechts auf Zugriff, Berichtigung und/oder Löschung aller sie betreffenden Daten.",
      "highlevelEasySystems": "HighLevel hat benutzerfreundliche Systeme eingerichtet, mit denen Sie uns informieren können, falls Sie eine solche Anfrage von einer betroffenen Person erhalten, und mit denen wir Sie informieren können, falls wir eine solche Anfrage erhalten. Wir werden sicherstellen, dass diese Anfragen gemäß Ihren Anweisungen unmittelbar bearbeitet werden. Sie sollten sich mit den Verpflichtungen vertraut machen, die Ihnen auferlegt werden, einschließlich derjenigen, die sich auf personenbezogene Daten beziehen, die Sie auf Ihren eigenen Systemen oder in anderen Diensten als HighLevel speichern.",
      "transfersToUSA": "Übermittlung von Daten in die USA",
      "transfersRestrictions": "Personenbezogene Daten dürfen nur unter bestimmten Umständen außerhalb des EWR übermittelt werden. Wir verwenden die Standardvertragsklauseln als Teil unserer Datenverarbeitungsvereinbarung, die wir mit allen unseren Kunden unterzeichnen.",
      "dataSecurity": "Datensicherheit",
      "securitySafeguards": "Wir haben starke Sicherheitsvorkehrungen und -maßnahmen implementiert, um sicherzustellen, dass alle von uns gespeicherten personenbezogenen Daten sicher aufbewahrt werden. Wir testen unsere Produkte regelmäßig auf Fehler und Sicherheitslücken.",
      "backupSystems": "Wir stellen sicher, dass wir regelmäßige Backup-Systeme implementiert haben und verfügen über Systeme und Prozesse zur Datenwiederherstellung und Datenintegrität, um das Risiko der Beschädigung oder des Verlusts personenbezogener Daten zu minimieren.",
      "stepsForCompliance": "Schritte, die wir unternommen haben, um die GDPR-Konformität zu gewährleisten",
      "dutyAsProcessor": "Wir nehmen unsere Aufgaben als Datenverarbeiter sehr ernst. Wir haben eine Reihe von Verfahren eingeführt und eine Anzahl Maßnahmen ergriffen, um sicherzustellen, dass wir die DSGVO einhalten und dass Sie uns die von Ihnen gesammelten personenbezogenen Daten rechtmäßig senden können, zum Beispiel:",
      "standardContractualClauses": "Unsere Vereinbarung zur Datenverarbeitung verwendet die Standardvertragsklauseln, um sicherzustellen, dass Sie personenbezogene Daten rechtmäßig an uns in die USA übermitteln können.",
      "detectBreaches": "Wir können Datenschutzverletzungen frühzeitig erkennen und unsere Kunden umgehend informieren.",
      "dealWithAccessRequests": "Wir sind in der Lage, Anfragen auf Auskunft und Löschung zu bearbeiten und stellen sicher, dass wir Sie informieren, wenn eine betroffene Person eine solche Anfrage an uns gestellt hat.",
      "assessedDocumented": "Wir haben die personenbezogenen Daten, die wir in Ihrem Auftrag verarbeitet haben, bewertet und dokumentiert.",
      "assessedSecurity": "Wir haben unsere Sicherheit geprüft und diese bei Bedarf verbessert, um sicherzustellen, dass sie dem Grad des Risikos entspricht, dem wir im Zusammenhang mit einer Datenschutzverletzung ausgesetzt sind.",
      "dataProcessingAgreement": "Datenverarbeitungsvereinbarung",
      "dateUpdated": "Datum der Aktualisierung: 1. April 2023",
      "downloadAgreement": "Downloadvertrag",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Haben Sie noch Fragen?"
    },
    "sendGridSettings": {
      "title": "SendGrid-Einstellungen",
      "settingsForLocations": "SendGrid-Einstellungen für Standorte",
      "sendGrid": "SendGrid",
      "last12Months": "Letzte 12 Jahre",
      "totalSent": "Summe gesendet",
      "opens": "Öffnet",
      "clicks": "Klicks",
      "bounces": "Bounces"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Launchpad für alle meine Standorte deaktivieren.",
      "description1": "Launchpad ist eine durchdachte Landingpage, die nachweislich die Kundenzufriedenheit und -bindung durch eine verstärkte Produktnutzung erhöht. ",
      "description2": "Die Anbindung von GMB, FB, Webchat-Plugin und die Nutzung der mobilen App haben sich als großartige Eigenschaften erwiesen, die die Kunden über einen längeren Zeitraum behalten.",
      "confirmDisable": "Möchten Sie Launchpad wirklich deaktivieren?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "Dies ist Ihr Affiliate-Link. Verwenden Sie diesen Link, um Personen, die Sie kennen, die Anmeldung zu ermöglichen, und Sie erhalten lebenslang 40 % ihrer monatlichen wiederkehrenden Einnahmen.",
      "appendToUrls": "Fügen Sie dies an das Ende Ihrer URLs an:",
      "needToSignUp": "Möchten Sie sich registrieren?",
      "goToUrl": "Rufen Sie die URL auf:",
      "andSignUpUsing": "und registrieren Sie sich via der E-Mail-Adresse",
      "asYourEmailAddress": "als Ihre E-Mail-Adresse für FirstPromoter.",
      "pageSettings": "Seiteneinstellungen",
      "facebookPixelId": "Facebook-Pixel-ID",
      "pixelId": "Pixel ID"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "Ab dem 17. Juni 2024 wird die Erweiterte Kontosicherheit standardmäßig automatisch auf Ihrem Konto aktiviert. Zu den verbesserten Sicherheitsfunktionen gehören:",
      "discontinuationOfAutoGeneration": "Einstellung der automatischen Generierung von Standort-API-Schlüsseln",
      "exclusionOfApiKeysInLocationCrudApis": "Ausschluss von API-Keys in Standort-CRUD-APIs",
      "optOutLink": "Um sich von dieser Änderung abzumelden, deaktivieren Sie bitte die erweiterte Kontosicherheit in <a href=\"/settings/company\">Einstellungen &gt; Unternehmen</a>",
      "advancedFunctionalityNote": "Diese API ist für erweiterte Funktionalität. Unser Support-Team ist nicht in der Lage, direkte Unterstützung bei der API-Konfiguration zu bieten.",
      "developerCouncilInfo": "Wir bieten einen Developer Council an, der einmal im Monat zu Sprechstunden zusammenkommt (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) und einen Developer Community Slack-Kanal, auf dem Sie Unterstützung von der Community und unserem API-Team erhalten können. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "Um Zapier zu verwenden, müssen Sie den Location-API-Schlüssel für den spezifischen Standort verwenden. Sie können dies aus der Liste unten abrufen oder indem Sie über den Umschalter im linken Menü in das Konto wechseln.",
      "partOfAdvancedApi": "Dies ist Teil der erweiterten API, die im Pro Plan verfügbar ist.",
      "upgradeMessage": "Dies ist Teil der erweiterten API, die im Pro Plan verfügbar ist. <a>Hier klicken</a>, um zu aktualisieren."
    },
    "accountMap": {
      "addAccountManually": "Konto manuell hinzufügen"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Einstellungen als Gruppen."
    },
    "accountDetails": {
      "basicDetails": "Grundlegende Details",
      "saas": "SaaS",
      "rebilling": "Neuabrechnung",
      "marketplaceApps": "Marktplatz-Apps",
      "advancedEmailSettings": "Erweiterte Einstellungen",
      "calendarSettings": "Kalendereinstellungen"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Standort-Einstellungen verwalten",
      "disableAddEmailService": "Deaktivieren Sie die Schaltfläche „E-Mail-Service hinzufügen\" in den E-Mail-Service-Einstellungen des Unterkontos",
      "disableAddSmtp": "Deaktivieren Sie die Schaltfläche „E-Mail-Service hinzufügen“ in den E-Mail-Service-Steuerelementen des Unterkontos",
      "restrictSubAccountEmailProvider": "Beschränken Sie Unterkonto-Benutzer darauf, ihren eigenen E-Mail-Anbieter hinzuzufügen",
      "disableAddSmtpDescription": "Beschränken Sie Unterkonto-Benutzer darauf, ihren eigenen E-Mail-Anbieter hinzuzufügen",
      "enableReVerification": "Aktivieren Sie die erneute Verifizierung für 90 Tage",
      "locationNoLeadConnector": "Für den Standort ist LeadConnector nicht als Standard-E-Mail-Anbieter festgelegt",
      "lcEmailNotEnabled": "Für den Standort ist LeadConnector nicht als Standard-E-Mail-Anbieter festgelegt",
      "onlyForAgency": "Sie können diese Einstellung nur für die Agenturansicht aktiviert sehen",
      "onlyVisibleForAgency": "Sie können diese Einstellungen nur für die Agenturansicht aktiviert sehen.",
      "reVerificationDescription": "Jeder E-Mail-Verifizierungsstatus wird nach 90 Tagen widerrufen (schützen Sie Ihren Ruf und stellen Sie die maximale Zustellbarkeit im Postfach sicher)"
    }
  },
  "attributes": {
    "addAttribute": "Attribut hinzufügen",
    "attributeName": "Attributname",
    "enterAttributeName": "Attributname eingeben",
    "number": "Zahl",
    "selectAttributeType": "Attributtyp auswählen"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Zusätzliche Metadaten",
      "title": "Hinzugefügte/aktualisierte Felder"
    }
  },
  "bulkActions": {
    "additionalDetails": "Weitere Details",
    "allOnGivenDate": "Alle am angegebenen Tag",
    "attempted": "Versucht",
    "batchQuantity": "Chargenmenge",
    "bulkActionProcessing": "Massedaten Aktion Laden",
    "bulkActionTitle": "Massedatenaktion",
    "campaignRequired": "Kampagne ist erforderlich",
    "currentStatus": "Aktueller Status",
    "delayBetweenBatches": "Timeout zwischen Chargen",
    "dispatchMode": "Senden Modus: {mode}",
    "editBatchQuantity": "Chargenmenge bearbeiten",
    "emailStats": "E-Mail-Statistiken",
    "enterBatchSprintLimit": "Bitte geben Sie ein Batch-Sprint-Limit ein",
    "hideStats": "Statistiken ausblenden",
    "mode": "Modus",
    "nextProcessingOn": "Nächste Verarbeitung am",
    "noStatsFound": "Keine Statistiken gefunden",
    "parentBulkActionID": "Übergeordnete Massendaten-Aktion-ID",
    "pleaseEnterQuantity": "Bitte geben Sie eine Menge ein",
    "processAllAsSoonAsPossible": "Bearbeiten Sie alles schnellstmöglich",
    "processAllOnGivenDate": "Alle an dem bestimmten Tag durch die Pipeline verarbeiten",
    "processDuring": "Während der Verarbeitung",
    "processGraduallyDrip": "Schrittweise verarbeiten (Drip)",
    "processingAllowedOn": "Verarbeitung zulässig am",
    "restoredBulkActionId": "Wiederhergestellte Massedaten-Aktion-id",
    "revert": "Rückgängig machen",
    "revertedBulkActionId": "Rückgängig gemachte Massenaktions-ID:",
    "saveChanges": "Änderungen speichern",
    "scheduledStart": "Geplanter Start",
    "showErrorLog": "Fehlerprotokoll anzeigen",
    "showImported": "Importierte anzeigen",
    "showStats": "Statistiken anzeigen",
    "skipped": "Übersprungen",
    "statistics": "Statistiken",
    "statuses": {
      "complete": "Vollständig",
      "next-drip": "Nächste Drip",
      "notStarted": "Nicht begonnen",
      "processing": "Verarbeitung",
      "queueing": "Anstehend",
      "reading": "Lesen",
      "resumed": "Wiederaufgenommen",
      "reverted": "rückgängig gemacht",
      "waiting": "Warten"
    },
    "successful": "Erfolgreich",
    "tagsAdded": "Tags hinzugefügt",
    "tagsRemoved": "Tags entfernt",
    "tagsRestored": "Tags wiederhergestellt",
    "timeElapsed": "Verstrichene Zeit",
    "totalExported": "Gesamt exportiert",
    "totalMerge": "Gesamt zusammengeführt",
    "unknownError": "Unbekannter Fehler",
    "updateBatchQuantity": "Chargenmenge aktualisieren",
    "updated": "Aktualisiert",
    "usesDynamicList": "** Verwendet dynamische Liste",
    "workflowRequired": "Arbeitsablauf ist erforderlich"
  },
  "business": {
    "addedToCompany": "Kontakt(e) erfolgreich zum Unternehmen hinzugefügt",
    "cantAddMoreContacts": "Es können nicht mehr als 50 Kontakte gleichzeitig hinzugefügt werden",
    "cleanerUi": "Übersichtlichere UI",
    "common": {
      "addContact": "Kontakt hinzufügen",
      "internalServerError": "Internal Host Fehlgeschlagen",
      "to": "zu"
    },
    "companiesNowHave": "Unternehmen haben jetzt",
    "companyNoteLabsText": "Unternehmensnotizen ist ein Labs-Merkmal",
    "contactRemoveCompany": "Sind Sie sicher, dass Sie diesen Kontakt aus dem Unternehmen klären möchten?",
    "moreFunctionalUx": "Mehr funktionale Benutzererfahrung",
    "newCompanyUpdate": "Neues Unternehmens-Update!",
    "tabs": "Tabs",
    "tasks": {
      "assignTask": "Aufgabe zuweisen",
      "assignee": "Beauftragter",
      "deleteTask": "Aufgabe löschen",
      "editTask": "Aufgabe bearbeiten",
      "markAsComplete": "Als vollständig markieren",
      "markAsPending": "Als anhängig markieren",
      "nameAndDescription": "Name und Beschreibung",
      "noTasksAvailable": "Keine Aktivitäten verfügbar"
    },
    "visitLabs": "Labs besuchen"
  },
  "calendar": {
    "googleCalendar": "Google-Kalender",
    "noSync": "Keine Synchronisierung",
    "outlookCalendar": "Outlook-Kalender"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Frontend-Debugger umschalten"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "tabs": "Tabs",
    "showPassword": "Passwort anzeigen",
    "hidePassword": "Passwort ausblenden",
    "goToHomepage": "Zur Startseite gehen",
    "leadConnectorHqLogo": "Lead Connector HQ Logo",
    "companyLogo": "Firmenlogo",
    "countries": {
      "australia": "Australien",
      "austria": "Österreich",
      "czechRepublic": "Tschechische Republik",
      "belgium": "Belgien",
      "brazil": "Brasilien",
      "canada": "Kanada",
      "chile": "Chile",
      "denmark": "Dänemark",
      "switzerland": "Schweiz",
      "germany": "Deutschland",
      "estonia": "Estland",
      "spain": "Spanien",
      "finland": "Finnland",
      "france": "Frankreich",
      "uk": "UK",
      "hongKong": "Hongkong",
      "hungary": "Ungarn",
      "ireland": "Irland",
      "italy": "Italien",
      "japan": "Japan",
      "kenya": "Kenia",
      "lithuania": "Litauen",
      "mexico": "Mexiko",
      "netherlands": "Niederlande",
      "newZealand": "Neuseeland",
      "norway": "Norwegen",
      "philippines": "Philippinen",
      "puertoRico": "Puerto Rico",
      "poland": "Polen",
      "portugal": "Portugal",
      "sweden": "Schweden",
      "singapore": "Singapur",
      "unitedStates": "Vereinigte Staaten",
      "vietnam": "Vietnam",
      "southAfrica": "Südafrika"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "EU",
      "in": "IN",
      "na": "NA",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND (Nicht stören)",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "Umsatzsteuer",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "Mastercard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "&quot; frameborder=&quot;0&quot; scrolling=&quot;auto&quot; width=&quot;100%&quot; height=&quot;500&quot;&gt;</iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Nummernpool bearbeiten – <strong>{name}</strong>",
      "displayphonenumber": "Telefonnummer anzeigen",
      "js_heap_memory": "JS Heap-Speicher",
      "vuex_store_modules": "Vuex Store-Module",
      "vuex_store_size": "Vuex-Store-Größe",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "file-image",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}beispiel.de",
      "httpexamplecom": "https://beispieldomain.de",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com oder utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "<strong>SHAKEN/STIR</strong>-Verifizierung für Ihr Unterkonto ist abgeschlossen. Schaffen Sie Vertrauen bei Ihren Kunden durch verifizierte Anrufe.",
      "mp3wavfile": "MP3-/WAV-Datei",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Schritt {currentStep} von {totalSteps}",
    "loadMore": "Weitere laden",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "Ein Segment entspricht einer SMS mit 160 Zeichen. Klicken Sie auf das Symbol, um mehr über die Preisgestaltung zu erfahren.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "Ein Segment entspricht einer SMS mit 160 Zeichen. Klicken Sie auf das Symbol, um mehr über die Preisgestaltung zu erfahren.",
    "_email": "/ email",
    "_ip": "/ IP",
    "_min": " /Min.",
    "_of_total": "% des Gesamtwerts",
    "_please_add_a_payment_method_for": "! Bitte Zahlungsmethode hinzufügen für ",
    "_segment": " / Segment",
    "_used": "% verwendet",
    "a_new_twilio_account_needs_to_be_created_before_we": "Bevor wir mit der Neuberechnung beginnen können, muss ein neues Twilio-Konto erstellt werden",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "Ein Unterkonto kann bis zu 10 benutzerdefinierte Objekte haben. Falls das Limit überschritten wird, werden keine benutzerdefinierten Objekte aus diesem Schnappschuss erstellt.",
    "a_twilio_account_is_already_setup_for_this_location": "Für diesen Standort wurde bereits ein Twilio-Konto eingerichtet",
    "accountName": "Kontoname",
    "account_sid": "Account SID:",
    "action": "Aktion",
    "actions": "Aktionen",
    "activate": "Aktivieren",
    "active": "Aktiv",
    "active_listeners": "Aktive Zuhörer",
    "active_subscriptions": "Aktive Abonnements",
    "ad_manager": " Anzeigen-Manager",
    "add": "Hinzufügen",
    "addAction": "Aktion hinzufügen",
    "add_eliza": "Eliza hinzufügen",
    "add_image": "Bild hinzufügen",
    "add_payment_method": "Zahlungsmethode hinzufügen",
    "add_to_account": "Zum Konto hinzufügen",
    "add_user_icon": "Benutzersymbol hinzufügen",
    "add_your_first_email": "Fügen Sie Ihre erste E-Mail-Adresse hinzu.",
    "address": "Adresse",
    "adwords_reporting": "AdWords-Berichterstattung",
    "affiliate_manager": "Affiliate-Manager",
    "agency": "Agentur",
    "agency_logo": "Agentur-Logo",
    "agency_settings": "Agentur-Einstellungen",
    "agent_reporting": "Agentenberichterstattung",
    "ai_employee": " AI-Mitarbeiter ",
    "all": "Alle",
    "allow_subaccounts_to_cancel_their_subscription": "Ermöglichen Sie Unterkonten, ihr Abonnement zu kündigen",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Ermöglichen Sie Unterkonten, auf einen höheren Plan zu wechseln",
    "allowed_format": "Zulässiges Format:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Ankündigungen – klicken Sie, um in einem neuen Tab zu öffnen",
    "answers": "Antworten",
    "app_name": "App-Name",
    "appointments": "Termine",
    "apps": " Apps",
    "ask_ai": "AI fragen",
    "ask_anything": "Stellen Sie eine Frage …",
    "assigned_to_another_user": "(Einem anderen Benutzer zugewiesen)",
    "at_least_one_location_is_required": "Mindestens ein Standort ist erforderlich",
    "attach_snapshot": "Schnappschuss anhängen",
    "attribution_reporting": "Attribution-Berichterstattung",
    "authorized_representative": "Bevollmächtigter Vertreter",
    "automation_type": "Automatisierungstyp",
    "available_hours": "Verfügbare Stunden",
    "avg_memoryinstance": "Durchschnittlicher Speicher/Instanz",
    "back": "Zurück",
    "base_url": "Basis-URL",
    "between_10_kb_and_5_mb": " Zwischen 10 KB und 5 MB",
    "birthday_sms": "Geburtstags-SMS",
    "birthday_sms_with_image": "Geburtstags-SMS mit Bild",
    "blogging": "Bloggen",
    "bounced": "Unzustellbar",
    "bulk_requests": "Massendatenanfragen",
    "business_email": "Geschäftliche E-Mail-Adresse",
    "business_hours_configurations": "Konfiguration der Geschäftszeiten",
    "business_industry": "Unternehmensbranche",
    "business_information": "Unternehmensdetails",
    "business_logo": "Unternehmenslogo",
    "business_niche": "Geschäftsbereich",
    "business_phone": "Unternehmensrufnummer",
    "business_physical_address": "Geschäftsadresse",
    "business_regions_of_operations": "Geschäftsregionen",
    "business_registration_id_type": "Unternehmensregistrierungs-ID-Typ",
    "business_registration_number": "Unternehmensregisternummer",
    "business_type": "Unternehmensart",
    "business_website": "Unternehmenswebsite",
    "busy": "Beschäftigt",
    "buttons": {
      "cancel": "Abbrechen",
      "confirm": "Bestätigen",
      "deleteAll": "Alle löschen",
      "view": "Ansicht",
      "close": "Schließen",
      "previous": "Zurück",
      "next": "Weiter",
      "clear": "Löschen",
      "save": "Speichern",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "reset": "Zurücksetzen",
      "refresh": "Aktualisieren",
      "nextLoading": "Nächste...",
      "copied": "Kopiert",
      "notNow": "Nicht jetzt",
      "send": "Senden",
      "send1": "Senden",
      "download": "Herunterladen",
      "sendNow": "Jetzt senden",
      "saved": "Gespeichert",
      "back": "Zurück",
      "update": "Aktualisieren",
      "add": "Hinzufügen",
      "submit": "Absenden",
      "submitting": "Wird übermittelt",
      "done": "Erledigt",
      "manageUsers": "Benutzer verwalten",
      "no": "Nein",
      "yes": "Ja"
    },
    "calendar": "Kalender",
    "calendar_groups": "Kalendergruppen",
    "call": "Anruf",
    "call_reporting": "Anrufberichterstattung",
    "call_tracking_is_disabled": "Anrufverfolgung ist deaktiviert",
    "call_voicemail_settings": "Anruf- und Voicemail-Einstellungen",
    "calls": " Anrufe",
    "campaign": "Kampagne",
    "campaigns": "Kampagnen",
    "cancel": " Stornieren ",
    "cancel_subscription": "Abonnement kündigen",
    "cancelled": "Abgesagt",
    "certificates": "Zertifikate",
    "change": "Ändern",
    "changed_data": "Geänderte Daten",
    "charge": " Gebühr",
    "charged_to_customer": "Dem Kunden in Rechnung gestellt",
    "chat": "Chat",
    "chat_user": "Chat-Benutzer",
    "chat_widget_icon": "Chat-Widget-Icon",
    "chats_will_be_saved_for_2_days": "Chats werden für 2 Tage gespeichert",
    "check": "Häkchen",
    "check_number_validity_before_first_sms_block_incom": "Überprüfen Sie die Gültigkeit der Nummer vor der ersten SMS, blockieren Sie eingehende Spam-Anrufe und recherchieren Sie die Namen unbekannter Anrufer, bevor Sie einen Anruf annehmen. Es fallen zusätzliche Gebühren an",
    "cinque_terre": "Cinque Terre",
    "city": "Stadt",
    "clear_history": "Verlauf löschen",
    "click_here": "Hier klicken",
    "click_on_create_new_snapshot_to_add_one": " Klicken Sie auf „Neuen Schnappschuss erstellen“, um einen hinzuzufügen.",
    "click_to_access_the_highlevel_welcome_course": "Klicken Sie hier, um auf den HighLevel-Willkommenskurs zuzugreifen",
    "click_to_upgrade": "Zum Upgraden hier klicken",
    "clicked": "Geklickt",
    "clio": "Clio",
    "cloning": "Klonung erfolgt",
    "close_debugger": "Debugger schließen",
    "close_whatsapp_template_creator": "WhatsApp-Vorlagenersteller schließen",
    "collection": "Sammlung",
    "columns": "Spalte",
    "coming_soon": "Demnächst verfügbar",
    "company_email_": "Firmen-E-Mail-Adresse (",
    "complete_component_data": "Vollständige Komponentendaten",
    "complete_event_data": "Vollständige Ereignisdaten",
    "complete_query_data": "Vollständige Abfragedaten",
    "completed": "Abgeschlossen",
    "complimentary_credits": "Kostenfreie Gutschriften",
    "component": "Komponente",
    "component_name": "Komponentenname",
    "component_type": "Komponententyp",
    "components": " Komponenten",
    "condition": "Status",
    "confirm": "BESTÄTIGEN",
    "confirmation_message": "Bestätigungsnachricht",
    "confirmed": "Bestätigt",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Kontaktieren Sie einen zertifizierten Administrator – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
    "connect_with_us_start_live_chat": "Verbinden Sie sich mit uns – starten Sie den Live-Chat",
    "connect_your_stripe_account": "Verbinden Sie Ihr Stripe-Konto ",
    "connect_zoom": "Mit Zoom verbinden",
    "consider_leaving_it_blank_should_you_choose_to_use": "Sie können dieses Feld leer lassen, wenn Sie den vorkonfigurierten Meetingort verwenden möchten",
    "contact": "Kontakt",
    "contact_support": "Support kontaktieren",
    "contact_us_call_highlevel_at_18887324197": "Kontaktieren Sie uns – rufen Sie HighLevel an unter +1(888)732-4197.",
    "contacts": "Kontakte",
    "content_ai": "Content AI",
    "controls": "Steuerelemente",
    "conversations": "Konversationen",
    "copied": "Kopiert",
    "cost_borne_by_you": " von Ihnen getragene Kosten",
    "count": "Anzahl",
    "country": "Land",
    "createNewFolder": "Neuen Ordner erstellen",
    "credit_balance": "KREDITGUTHABEN",
    "current_location_id": "Aktuelle Standort-ID",
    "custom": "Benutzerdefiniert",
    "custom_email": "Benutzerdefinierte E-Mail",
    "custom_niche": "Benutzerdefinierter Geschäftsbereich",
    "customer_notifications": "Kundenbenachrichtigungen",
    "customize": "Anpassen",
    "customize_chat_widget": "Chat-Widget anpassen",
    "dashboard_stats": "Dashboard-Statistiken",
    "data_keys": "Daten-Schlüssel",
    "date": "Datum",
    "days": "Tage",
    "dedicated_ip": "Feste IP ",
    "default": "Standard",
    "default_snapshots": "Standard-Schnappschüsse",
    "delete": "Löschen",
    "deleted": "gelöscht",
    "delivered": "Zugestellt",
    "description": "Beschreibung",
    "details": "Details",
    "disable_gbp_messaging_not_recommended": "GBP-Messaging deaktivieren (nicht empfohlen)",
    "disable_tracking": "Tracking deaktivieren",
    "disabled": "Deaktiviert",
    "dismiss": "Ablehnen",
    "display_name": "Anzeigename",
    "do_not_delete": "nicht löschen",
    "do_something": "TUN SIE ETWAS",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Möchten Sie denselben behalten oder einen neuen erstellen?",
    "download_application_icon": "Symbol für den Anwendungsdownload",
    "draft": "Entwurf",
    "dropdown_icon": "Drop-down-Symbol",
    "duplicate": "Duplikat",
    "duration": "Dauer",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza-Umgehungs-Tag (optional)",
    "eliza_is_required": "Eliza ist erforderlich.",
    "eliza_service": "Eliza-Dienst",
    "email": "E-Mail",
    "email_resell_settings": "E-Mail-Wiederverkaufseinstellungen",
    "email_sending": "E-Mail-Versand",
    "email_signature": "E-Mail-Signatur",
    "enable": "Aktivieren",
    "enable_beta": " Beta aktivieren",
    "enable_company_automation": "Unternehmensautomatisierung aktivieren",
    "enable_disable_deprecated_features": "Veraltete Funktionen aktivieren/deaktivieren",
    "enable_gbp_call_tracking": " GBP-Anrufverfolgung aktivieren ",
    "enable_gbp_messaging": "GBP-Nachrichten aktivieren",
    "enable_signature_on_all_outgoing_messages": "Aktivieren Sie die Signatur für alle ausgehenden Nachrichten",
    "enabled": "Aktiviert",
    "notEnabled": "Nicht aktiviert",
    "enter_a_logical_name": "Geben Sie einen logischen Namen ein",
    "enter_the_exact_business_address_as_it_appears_in_": "Geben Sie die genaue Geschäftsadresse so ein, wie sie im EIN-Eintrag vermerkt ist.",
    "enter_the_exact_legal_business_name_as_registered_": "Geben Sie den genauen rechtlichen Firmennamen ein, wie er beim EIN registriert ist.",
    "enter_the_full_street_address_as_it_appears_in_the": "Geben Sie die vollständige Straßenadresse so ein, wie sie im EIN-Eintrag vermerkt ist.",
    "enter_user_email": "E-Mail-Adresse des Nutzers eingeben",
    "enter_user_phone_number": "Rufnummer des Nutzers eingeben",
    "enter_your_business_registration_id_type": "Geben Sie Ihren Unternehmensregistrierungs-ID-Typ ein",
    "enter_your_business_vertical_eg_travel": "Geben Sie Ihren Geschäftsbereich ein (z. B. Reisebranche)",
    "error_code": "Fehlercode",
    "error_code_chart": "Fehlercodetabelle",
    "error_while_copying_api_key": "Fehler beim Kopieren des API-Schlüssels!",
    "event": "Event",
    "event_bus_listeners": "Event-Bus-Listener",
    "events": " Events",
    "everything_in": "Alles in ",
    "exact": "Genau",
    "execute_this_action_if_the_current_time_falls_in_t": "Führen Sie diese Aktion aus, wenn die aktuelle Zeit in dieses Zeitfenster fällt. Warten Sie andernfalls bis zum nächsten Zeitfenster, um diese Aktion auszuführen.",
    "extension": "Erweiterung",
    "facebook": "Facebook",
    "facebook_ads": "Facebook-Anzeigen",
    "facebook_ads_reporting": "Facebook-Werbeanzeigen-Berichterstattung",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Facebook-Kampagnen",
    "facebook_icon": "Facebook-Symbol",
    "facebook_page": "Facebook-Seite",
    "feature_image": "Titelbild",
    "features": "Merkmale:",
    "feedback": "Feedback: ",
    "file_path": "Dokumentpfad",
    "firestore_listeners": "Firestore-Listener",
    "forms": "Formulare",
    "free": "Frei",
    "fri": "Fr",
    "friendly_business_name": "Üblicher Unternehmensname",
    "from": " von ",
    "funnels": "Funnels",
    "gbp_call_tracking": "GBP-Anrufverfolgung",
    "gbp_configuration": "GBP-Konfiguration",
    "general": "Allgemein",
    "general_information": "Allgemeine Details",
    "generating_link_please_wait": "Link wird generiert, bitte warten Sie …",
    "google_ads_adgroups": "Google Ads Anzeigengruppen",
    "google_ads_ads": "Google Ads-Anzeigen",
    "google_ads_campaigns": "Google Ads-Kampagnen",
    "google_ads_keywords": "Google Ads Keywords",
    "google_business_messaging": "Google-Unternehmensnachrichten",
    "google_business_profile": "Google-Unternehmensprofil",
    "google_my_business_icon": "Google My Business-Symbol",
    "hello": "Hallo ",
    "here": "hier",
    "hhmm_a": "hh:mm",
    "hi": "Hallo ",
    "hide": "Ausblenden",
    "highlevel_events_click_to_open_in_new_tab": "HighLevel Events – zum Öffnen in neuem Tab hier klicken",
    "how_can_i_help_you_today": "Wie kann ich Ihnen heute helfen?",
    "how_did_the_call_go": "Wie verlief der Anruf?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "Wie berechne ich meine E-Mail-Kosten? Klicken Sie auf das Symbol, um mehr zu erfahren",
    "how_does_it_work": "So funktioniert's",
    "htmlElement": "HTML-Element (TODO):",
    "html_element_todo": "HTML-Element (TODO): ",
    "id": "ID: ",
    "if": "Wenn",
    "if_activated_the_sender_information_will_be_automa": "Falls diese Option aktiviert ist, werden die Absenderinformationen automatisch zur ersten SMS-Nachricht aller Massennachrichten hinzugefügt, um Ihre Compliance-Anforderungen zu erfüllen und die Zustellraten zu erhöhen.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "Falls diese Option aktiviert ist, fügen wir Abmeldelinks in die Fußzeilen Ihrer E-Mails ein, sodass sich die Empfänger vom Erhalt abmelden können, ohne die E-Mail als Beschwerde/Spam zu markieren.",
    "ignore_this_update": "Dieses Update ignorieren",
    "image": "Bild",
    "image_turned_on": "Bild aktiviert",
    "imported_date": "Importdatum",
    "imported_snapshots": "Importierte Schnappschüsse",
    "inbound": "Eingehend",
    "inbound_number": "Eingehende Nummer",
    "incoming_call_timeout": "Timeout für eingehende Anrufe",
    "instance_id": "Instanz-ID",
    "instances": "Instanzen: ",
    "instructions_mentioned_in_this_page": "Anweisungen auf dieser Seite",
    "internal": "Internal",
    "intro_message": "Einleitungsnachricht",
    "intro_question": "Einleitungsfrage",
    "invalid": "Ungültig",
    "invoicing": "Rechnungsstellung",
    "is_scheduled_for_deletion_on": " ist zur Löschung vorgesehen am ",
    "job_position": "Stellenbezeichnung",
    "job_title": "Berufsbezeichnung",
    "join_our_facebook_group_click_to_open_in_new_tab": "Treten Sie unserer Facebook-Gruppe bei – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
    "jpg_or_png": " JPG oder PNG ",
    "just_one_sec": "Einen Moment bitte …",
    "key_sizes": "Schlüsselgrößen",
    "label": "Label",
    "labels": {
      "sortDirection": "Filterrichtung",
      "tableStyling": "Tabellen-Styling",
      "loadingMore": "Mehr wird geladen …",
      "loading": "Wird geladen…",
      "filter": "Filter",
      "search": "Suchen...",
      "sortBy": "Sortieren nach",
      "perPage": "Pro Seite",
      "date": "Datum",
      "time": "Zeit",
      "readMore": "Weiterlesen",
      "day": "Tag",
      "slot": "Zeitfenster",
      "template": "Vorlage",
      "city": "Stadt",
      "country": "Land",
      "state": "Status",
      "customerName": "Kundenname",
      "friendlyName": "Friendly Name",
      "required": "* erforderlich",
      "addressLine1": "Anschrift Zeile 1",
      "addressLine2": "Anschrift Zeile 2",
      "postalCode": "Postleitzahl",
      "searchUsers": "Benutzer suchen",
      "unknown": "Unbekannt",
      "businessName": "Geschäftsname"
    },
    "last_updated": "Zuletzt aktualisiert",
    "launchpad_icon": "Launchpad-Symbol",
    "lead": "Lead",
    "leadconnector": "LeadConnector",
    "learn_how": "(So geht's)",
    "legal_business_name": "Gesetzlicher Firmenname",
    "limit_updated_from": " Limit wurde aktualisiert von ",
    "listeners": " Listener",
    "loading_your_conversation_history": "Ihr Gesprächsverlauf wird geladen …",
    "location": "Ort",
    "locations": " Standorte",
    "logical_name": "Logischer Name",
    "logical_name_is_required": "Logischer Name ist erforderlich.",
    "logo": "Logo",
    "mailgun": "Mailgun",
    "making_calls": "Anrufe tätigen",
    "manage_custom_email": "Benutzerdefinierte E-Mail-Adressen verwalten",
    "marketing": "Marketing",
    "maximize": "Vergrößern",
    "me_": "Ich (",
    "member_since": "Mitglied seit",
    "membership": "Mitgliedschaft",
    "memory_analysis": "Speicheranalyse",
    "memory_api_not_available": "Memory-API nicht verfügbar",
    "message": "Nachricht",
    "minimize": "Verkleinern",
    "minimum_must_be": " Mindestens erforderlich ",
    "miscellaneous_charges": "Verschiedene Gebühren",
    "missed_call_text_back": "SMS-Versand bei verpassten Anrufen",
    "missed_text_back_call_message": "SMS-Text bei verpassten Anrufen",
    "model": "Modell",
    "module": "Modul",
    "modules": " Module",
    "mon": "Mo",
    "month": "/Monat",
    "monthly": "monatlich",
    "more_emails_in_thread": " Weitere E-Mails im Thread",
    "mount_count": "Mount Count",
    "mount_time": "Montagezeit",
    "moved_to_calendar_settings": "In Kalendereinstellungen verschoben",
    "multiple_locations_using_same_twilio_account": "Mehrere Standorte verwenden dasselbe Twilio-Konto",
    "must_be_in_range_of_0": " Muss liegen im Bereich von 0–",
    "must_be_less_than_monthly_plan_12": " Muss weniger als das 12-fache des Monatsplans betragen ",
    "my_business_is": "Mein Unternehmen ist ",
    "my_snapshots": "Meine Schnappschüsse",
    "name": "Name",
    "name_of_other_registration_id_type": "Name des sonstigen Registrierungs-ID-Typs",
    "newFolder": "Neuer Ordner",
    "new_task_update": "Neue Aufgabenaktualisierung!",
    "next": "Nächste",
    "no_answer": "Keine Antwort",
    "no_bigger_than_25mb": "nicht größer als 2,5 MB",
    "no_customer_selected": "Kein Kunde ausgewählt",
    "no_error_data_found": "Keine Fehlerdaten gefunden",
    "no_payment_method_available": "Keine Zahlungsmethode verfügbar",
    "no_provider_found": "Kein Anbieter gefunden",
    "no_snapshots_found": "Keine Schnappschüsse gefunden!",
    "noshow": "Nicht erschienen",
    "not": "Nicht",
    "not_now": "Nicht jetzt",
    "not_saved": "Nicht gespeichert",
    "notes": "Notizen",
    "notifications": "Benachrichtigungen",
    "now": "Jetzt",
    "numbers_and": " Nummer(n) und ",
    "objective": "Zielsetzung:",
    "of": "von",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Onboarding-Video-Tutorials – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
    "online_listings": "Online-Einträge",
    "only_assigned_data": "Nur zugewiesene Daten",
    "open_performance_debugger": "Open Performance Debugger",
    "opened": "Geöffnet",
    "opportunities": "Interessenten",
    "options": {
      "ascending": "Aufsteigend",
      "descending": "Absteigend",
      "none": "-- Keine --"
    },
    "or_drag_and_drop": "oder ziehen und hier ablegen",
    "outbound": "Ausgehend",
    "pagination": "Seitenumbruch",
    "pass_body_content_here": " Geben Sie hier den Text-Inhalt ein ",
    "password": "Kennwort",
    "paused": "Pausiert",
    "payment_links": "Zahlungslinks",
    "payment_methods": "Zahlungsmethoden",
    "payment_refund": "Zahlungserstattung",
    "payment_settings_navigation": "Navigation der Zahlungseinstellungen",
    "payments": "Zahlungen",
    "payments_integration": "Zahlungsintegration",
    "pending": "Anhängig",
    "per_page": "Pro Seite",
    "percentage": "Prozentsatz",
    "permanently_delete_this_email": "Löschen Sie diese E-Mail dauerhaft",
    "personal_logo": "Persönliches Logo",
    "phone": "Telefon",
    "phone_number_with_country_code": "Rufnummer (mit Ländervorwahl)",
    "pick_a_niche": "Geschäftsbereich auswählen",
    "pick_a_snapshot": "Schnappschuss auswählen",
    "pick_business_industry": "Wählen Sie Branche aus",
    "pick_business_registration_id_type": "Unternehmensregistrierungs-ID-Typ auswählen",
    "pick_business_type": "Unternehmensart auswählen",
    "pick_job_position": "Stellenbezeichnung auswählen",
    "plans_pricing": "Pläne und Preise",
    "please_enter_a_value_greater_than_20": "Bitte geben Sie einen Wert ein, der größer als 20 ist.",
    "pm": "PM",
    "points": "Punkte",
    "postalzip_code": "Postleitzahl",
    "previous": "Vorherige",
    "privacy_policy_url": "URL der Datenschutzrichtlinie",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "Die URL der Datenschutzrichtlinie wird in Ihren Google-Agenten-Informationen angezeigt.",
    "process_your_payment": "Zahlung verarbeiten",
    "profile_picture": "Profilbild",
    "profit": "Gewinn",
    "prospecting": " Ausschau halten ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Stellen Sie den neuen Konten vorgefertigte Schnappschüsse zur Verfügung.",
    "queries": " Abfragen",
    "questions": "Fragen",
    "quick_actions_icon": "Symbol für Schnellmaßnahmen",
    "re_generate_key": "Schlüssel neu generieren",
    "read_only": "Schreibgeschützt",
    "receipts_settings": "Belegeinstellungen",
    "receiving_calls": "Anrufe empfangen",
    "recent_events": "Neueste Ereignisse",
    "recommended": "Empfohlen",
    "recommended_resolution": "Empfohlene Auflösung:",
    "reconnect": "Erneut verbinden ",
    "record_payment": "Zahlung aufzeichnen",
    "registered": " registriert.",
    "renameFolder": "Ordner umbenennen",
    "replied": "Geantwortet",
    "representative_email": "E-Mail-Adresse eines Vertreters",
    "resell_settings": " Wiederverkaufseinstellungen",
    "reset": "Zurücksetzen",
    "resolve_now": "Jetzt beheben",
    "resource_counts": "Ressourcenanzahl",
    "restore": "Wiederherstellen",
    "results": "Ergebnisse",
    "reviews": "Bewertungen",
    "rollover_unused_credits_to_next_month": "Übertragen Sie nicht verbrauchte Guthaben auf den nächsten Monat",
    "row": " Zeile",
    "runNow": "Jetzt ausführen",
    "sample_data": "(Beispieldaten)",
    "sat": "Sa",
    "save": "Speichern",
    "save_missed_call_text_settings": "Einstellungen für verpasste Anruftexte speichern",
    "save_staging_url": "Staging-URL speichern",
    "saved": "Gespeichert",
    "saving": "Wird gespeichert …",
    "search": "Suchen",
    "search_active_apps": "Aktive Apps durchsuchen...",
    "search_components": "Komponenten durchsuchen …",
    "search_customer": "Kunden suchen",
    "search_email": "E-Mail durchsuchen",
    "search_history": "Suchhistorie...",
    "search_icon": "Suchsymbol",
    "search_listeners": "Listener werden gesucht …",
    "search_modules": "Module durchsuchen …",
    "search_queries": "Suchanfragen …",
    "see_this_review_on_gbp": "Diese Bewertung auf GBP ansehen ",
    "segments": " Segmente",
    "select": "Auswählen",
    "select_a_snapshot": "Schnappschuss auswählen",
    "monetary": "MONETÄR",
    "pleaseSelectAValue": "Bitte wählen Sie einen Wert aus",
    "select_account": "Konto auswählen",
    "select_an_account": "Konto auswählen",
    "select_eliza_bypass_tag": "Eliza-Umgehungs-Tag auswählen",
    "select_phone_number": "Rufnummer auswählen",
    "select_send_to_eliza_tag": "„An Eliza senden“-Tag auswählen",
    "select_snapshot": " Schnappschuss auswählen",
    "select_upto": "Wählen Sie bis zu ",
    "selected": "Ausgewählt: ",
    "send": "Senden",
    "send_to_eliza_tag_optional": "An Eliza-Tag senden (optional) ",
    "seo": " SEO ",
    "settings": "Einstellungen",
    "setup_pending": "Einrichtung ausstehend",
    "share": "teilen",
    "shared_snapshots": "Freigegebene Schnappschüsse",
    "shared_type": "Freigabeart",
    "shipping_and_delivery": "Versand und Lieferung",
    "shipping_origin": "Versandursprung",
    "show": "Anzeigen",
    "showed": "Erschienen",
    "signin_with_single_signon": "Anmelden mit Single Sign-on",
    "size": "Größe",
    "sms_message_sent_to_customer": "SMS-Nachricht an Kunden gesendet",
    "snapshot_date": "Schnappschuss-Datum",
    "snapshot_name": "Schnappschuss-Name",
    "social_planner": "Social-Media-Planung",
    "sortBy": "Sortieren nach",
    "sortOptions": {
      "createdDate": "Erstellungsdatum"
    },
    "source": "Quelle",
    "sources": "Quellen:",
    "spent": "Ausgegeben",
    "staging_url_settings_for_db_event": "Staging-URL-Konfiguration (für Db-Event)",
    "state": "Land",
    "state_prov_region_": "Bundesland/Provinz/Region *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "Kalifornien",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District Of Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "North Carolina",
      "north_dakota": "North Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "South Carolina",
      "south_dakota": "South Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "Keine Datensätze gefunden",
      "noEntriesToShow": "Keine Einträge zum Anzeigen",
      "unsuccessful": "Fehlgeschlagen",
      "pending": "Anhängig",
      "noUsersFound": "Keine Benutzer gefunden"
    },
    "status": "Status",
    "stop_delete_operation": "Löschvorgang stoppen",
    "street_address": "Anschrift",
    "street_address_as_it_appears_in_the_ein_listing": "Straße und Hausnummer, wie sie in der EIN-Auflistung erscheint.",
    "stripe_icon": "Stripe-Symbol",
    "stripe_integration": "Stripe-Integration",
    "stripe_secret_key": "Stripe Secret Key",
    "subscriptions": "Abonnements",
    "sun": "So",
    "surveys": "Umfragen",
    "suspend_subaccount_when_their_saas_subscription_fa": "Setzen Sie das Unterkonto aus, wenn dessen SaaS-Abonnement fehlschlägt.",
    "switchAccount": "Konto wechseln",
    "switch_off_sections_below_to_disable": "Schalten Sie die untenstehenden Abschnitte aus, um sie zu deaktivieren",
    "tags": "Schlüsselwörter",
    "tax_settings": "Steuereinstellungen",
    "team_management": "Gruppenmanagement",
    "team_notifications": "Team-Benachrichtigungen",
    "template": "Vorlage",
    "terms_and_conditions": "Bedingungen und Konditionen",
    "test_mobile_no": "Test-Mobilrufnummer",
    "text_messages": "Textnachrichten",
    "the_proposed_size_is_350px_180px": "Die vorgeschlagene Größe beträgt 350x180 px",
    "the_proposed_size_is_512512px": "Die vorgeschlagene Größe ist 512x512 px",
    "the_selected_language_will_be_used_by_the_system_a": "Die ausgewählte Sprache wird vom System als Standardsprache verwendet.",
    "the_welcome_message_automatically_appears_after_a_": "Die Willkommensnachricht erscheint automatisch, nachdem ein Benutzer eine neue Konversation beginnt.",
    "these_are_margins_that_are_billed_to_your_clients_": "Dies sind Aufschläge, die Ihren Kunden in Rechnung gestellt werden, zusätzlich zu den ",
    "this_data_will_be_used_for_future_compliance_regis": "Diese Daten werden für zukünftige Compliance-Registrierungen verwendet.",
    "this_is_my_twilio_use_same": "Dies ist mein Twilio, verwenden Sie dasselbe",
    "this_is_visible_to_both_agency_and_location": "Dies ist sowohl für die Agentur als auch für den Standort sichtbar",
    "this_name_will_be_visible_to_leads_chatting_with_y": "Dieser Name wird für Leads sichtbar sein, die mit Ihrem Unternehmen chatten",
    "this_setting_is_applicable_with_only_team_calendar": "Diese Einstellung ist nur für Teamkalender anwendbar.",
    "this_stripe_customer_is_already_connected_to_anoth": "Dieser Stripe-Kunde ist bereits mit einem anderen Unterkonto verbunden.",
    "thu": "Do",
    "tiktok": "TikTok",
    "time_signed": " Zeitpunkt der Unterzeichnung: ",
    "time_zone_": "Zeitzone *",
    "timestamp": "Zeitstempel",
    "title": "Titel",
    "to_resolve_this_problem_follow_the": "Um dieses Problem zu beheben, folgen Sie den ",
    "token": "Token:",
    "total": "Gesamt: ",
    "trigger_link": "Trigger-Link",
    "triggers": "Auslöser",
    "tue": "Di",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilio-Einrichtung steht aus",
    "type": "Typ",
    "type_campaign_objective": "Kampagnenziel eingeben",
    "type_message": "Nachricht eingeben",
    "unsavedChangesWarning": "Ihre Änderungen werden nicht gespeichert. Möchten Sie wirklich abbrechen?",
    "unsaved_changes": "Nicht gespeicherte Änderungen",
    "unsubscribed": "Abgemeldet",
    "unsuccessful": "Fehlgeschlagen",
    "update_business_profile_details": "Unternehmensprofildetails aktualisieren",
    "update_is_inprogress_visit_integrations_page_to_fi": "Das Update ist in Bearbeitung. Besuchen Sie die Integrationsseite, um mehr zu erfahren.",
    "update_url": "URL aktualisieren",
    "updated_date": "Aktualisierungsdatum",
    "updates": " Aktualisierungen",
    "updating": "Wird aktualisiert...",
    "upgrade_to_agency_pro": "Upgrade auf Agentur Pro ",
    "upload": "Upload",
    "upload_a_file": "Datei hochladen",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Verwenden Sie dies für die Zapier- und API-Integration.",
    "user_email": "Benutzer-E-Mail",
    "user_permissions": "Benutzerberechtigungen",
    "user_role": "Benutzerrolle",
    "user_type": "Benutzertyp",
    "valid": "Gültig",
    "verification_status": "Überprüfungsstatus",
    "verify": "Überprüfen",
    "verify_email_using_otp": "E-Mail-Adresse per OTP bestätigen",
    "view_less": " Weniger anzeigen ",
    "visiblehidden": "Sichtbar/Versteckt",
    "visit_our_help_center_click_to_open_in_new_tab": "Besuchen Sie unsere Hilfeseiten – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
    "voicemail": "Voicemail",
    "wave_integration": "Wave-Integration",
    "we_have_found_some_errors_in_your_contact_fields_c": "Wir haben (einen) Fehler in Ihren Kontaktfeldern gefunden. Klicken Sie auf den Ordner, um diese(n) anzuzeigen und zu lösen.",
    "websites": "Webseiten",
    "wed": "Mi",
    "welcome_message": "Willkommensnachricht",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "WhatsApp-Icon",
    "when": "Wenn",
    "when_selected_calls_will_be_routed_to_your_mobile_": "Wenn diese Option ausgewählt ist, werden Anrufe an Ihre mobile App weitergeleitet. (Unterstützt auf iOS und Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "Wenn diese Option ausgewählt ist, werden Anrufe an Ihre Web-App weitergeleitet.",
    "which_business_do_you_want_to_link_to_this_locatio": "Welches Unternehmen möchten Sie mit diesem Standort verknüpfen?",
    "widget_code": "Widget-Code",
    "will_give_you_about": " werde Ihnen ungefähr geben",
    "wordpress": "WordPress",
    "wordpress_icon": "WordPress-Icon",
    "workflows": "Workflows",
    "xero_integration": "Xero-Integration",
    "you_need_to_complete_few_easy_steps_to_delete_this": "Mit ein paar einfachen Schritten können Sie diesen Standort löschen",
    "you_are_not_authorized_to_perform_this_action_only": "Sie sind nicht berechtigt, diese Aktion auszuführen. Nur Administratoren der Agentur können Unterkonten löschen.",
    "your_email_cost": "Ihre E-Mail-Kosten",
    "your_facebook_page_has_been_integrated_however_the": "Ihre Facebook-Seite wurde erfolgreich integriert. Die folgenden Funktionen sind jedoch nicht aktiviert, da LeadConnector nicht über die erforderlichen Berechtigungen verfügt: ",
    "your_outlook_connection_has_expired_please_disconn": "Ihre Outlook-Verbindung ist abgelaufen. Bitte trennen Sie die Verbindung mit dem Konto und stellen Sie sie dann erneut her.",
    "zip_code": "Postleitzahl",
    "zoom_connected_please_close_this_modal": "Zoom wurde verbunden; bitte schließen Sie dieses Fenster",
    "hidden": "Versteckt",
    "messageDetails": "Nachrichten-Info",
    "openOptions": "Optionen öffnen",
    "progress": "Fortschritt",
    "close": "Schließen",
    "loading": "Laden",
    "fullName": "Vollständiger Name",
    "languages": "Sprachen",
    "phoneNumber": "Telefonnummer",
    "phoneNumberWithCountry": "Rufnummer (mit Ländervorwahl)",
    "sendMessage": "Nachricht senden",
    "services": "Services",
    "servicesProvided": "Bereitgestellte Dienstleistungen",
    "pleaseProvideAValid": "Bitte geben Sie eine gültige Rufnummer an.",
    "copy": "Kopieren",
    "editApiKey": "API-Schlüssel bearbeiten",
    "confirmPay": "Bestätigen und bezahlen",
    "contactUs": "Kontaktieren Sie uns",
    "decline": "Ablehnen",
    "deleteSubaccount": "Unterkonto löschen",
    "disabled1": "deaktiviert",
    "purchaseSummary": "Kaufzusammenfassung",
    "subscriptionPlan": "Abonnementplan",
    "businessName": "Name des Unternehmens",
    "chooseOne": "Wählen Sie eine Option …",
    "stateProvRegion": "Bundesland/Provinz/Region",
    "streetAddress": "Straße und Hausnummer",
    "timeZone": "Zeitzone",
    "website": "Website",
    "zipPostalCode": "Postleitzahl",
    "apiKey": "API-Schlüssel",
    "createdAt": "Erstellt am",
    "deleteAllLocationApi": "Alle Standort-API-Schlüssel löschen",
    "deleteApiKey": "API-Schlüssel löschen",
    "generatedBy": "Erstellt von",
    "lastUsedAt": "Zuletzt verwendet um",
    "pageNavigation": "Seitennavigation",
    "somethingWentWrong": "Etwas ist schiefgelaufen!",
    "clickHere": "Hier klicken",
    "emailRebillingActive": "E-Mail-Neuberechnung aktiv",
    "saasSubscriptionActive": "SaaS-Abonnement aktiv",
    "scheduledForDeletion": "Zur Löschung vorgesehen",
    "twilioRebillingActive": "Twilio-Neuberechnung aktiv",
    "iAcknowledgeThisIs": "Ich bestätige, dass dies ein gültiges Unterkonto ist und dass ich den Anwendungsfall für den Versand von mehr als {limit} {type}/Tag überprüft habe",
    "iAcknowledgeThisIs1": "Ich bestätige, dass dies ein gültiges Unterkonto ist und dass ich den Anwendungsfall für den Versand überprüft habe. Daher möchte ich das tägliche SMS-Limit anpassen",
    "emailSentByLocation": "Bisher heute nach Standort versendete E-Mails.",
    "goToSmsLimit": "Gehen Sie zu den SMS-Limit-Einstellungen",
    "toIncreaseTheLimit": "Wenn Sie das Limit weiter erhöhen möchten, wenden Sie sich an das Support-Team.",
    "newLimitOfLimit": "Das neue Limit von {limit} ist ungültig. Bitte geben Sie einen Wert zwischen {min} und {max} ein",
    "typeLimitUpdatedSuccessfully": "{type}-Limit wurde aktualisiert",
    "locationsCurrentLimitIs": "Das aktuelle Limit des Standorts beträgt {current}. Sie können das Limit von hier aus nur von {min} bis {max} aktualisieren. Für jede Limitaktualisierung über {maxAllowed} wenden Sie sich bitte an das Support-Team.",
    "notNow": "Nicht jetzt",
    "smsSentByLocation": "Bisher heute nach Standort gesendete SMS.",
    "youHaveSuccessfullyUpdated": "Sie haben das Limit aktualisiert",
    "willAutoUnlockIn": "Wird automatisch entsperrt in",
    "contactType": "Kontakttyp",
    "createdBy": "Erstellt von:",
    "createdOn": "Erstellt am:",
    "dateOfBirth": "Geburtsdatum",
    "emailAddress": "E-Mail-Adresse",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "twilioLookupMarkedThis": "Twilio Lookup hat diese Rufnummer als ungültig markiert.",
    "twilioLookupStatedThis": "Twilio Lookup hat festgestellt, dass es sich hierbei um eine {type}-Nummer handelt, daher werden darüber keine SMS empfangen.",
    "accountSnapshot": "Konto-Schnappschuss",
    "auditLogs": "Audit-Protokolle",
    "account": "Konto",
    "selectAccount": "Konto auswählen",
    "facebookUrl": "Facebook-URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "Twitter-URL",
    "youtubeUrl": "YouTube-URL",
    "text": "Text",
    "allTagsLinkedTo": "Alle mit den ausgewählten Kontakten verknüpften Tags sollten entfernt werden",
    "automation": "Automatisierung",
    "bulkOperation": "Massenbearbeitung",
    "campaign1": "Kampagne",
    "created": "Erstellt",
    "dateTime": "Datum und Uhrzeit",
    "description1": "Beschreibung",
    "drip": "Drip",
    "edit": "Bearbeiten",
    "someStatsAreNot": "Einige Statistiken sind bei einem SMTP-Provider nicht verfügbar. Die Genauigkeit der Statistiken hängt von der Domain des Empfängers ab.",
    "error": "Fehler",
    "from1": "Von",
    "immediately": "Sofort",
    "pause": "Pause",
    "processed": "Verarbeitet",
    "queued": "In der Warteschlange",
    "restored": "Wiederhergestellt",
    "resume": "Wiederaufnahme",
    "sent": "Gesendet",
    "scheduled": "Geplant",
    "success": "Erfolg",
    "templateName": "Vorlagenname",
    "total1": "Gesamt",
    "totalAttempted": "Gesamtversuche",
    "user": "Benutzer",
    "viewDetails": "Details anzeigen",
    "workflow": "Arbeitsablauf",
    "company": "Unternehmen",
    "note": "Notiz",
    "perPage": "pro Seite",
    "showing": "Anzeigen",
    "task": "Aufgabe",
    "tasks": "Aufgaben",
    "customFields": "Benutzerdefinierte Felder",
    "dueDate": "Fälligkeitsdatum",
    "tryNow": "Jetzt ausprobieren!",
    "archive": "Archiv",
    "markAsRead": "Als gelesen markieren",
    "markAsUnread": "Als ungelesen markieren",
    "youNeedToAdd": "Sie müssen einen Kalender hinzufügen, um Termine einzuplanen.",
    "additionalNotes": "Zusätzliche Anmerkungen",
    "appointmentStatus": "Terminstatus",
    "appointmentTitle": "Titel des Termins",
    "contactName": "Kontaktname",
    "contactTimezoneUsedFor": "Kontaktzeitzone (für Erinnerungen verwendet)",
    "day": "Tag",
    "editAppointment": "Termin bearbeiten",
    "nameRequired": "Name erforderlich",
    "slotRequired": "Zeitfenster erforderlich",
    "teamMemberIsRequired": "Teammitglied ist erforderlich.",
    "meetingLocation": "Konferenzort",
    "pickTeamMember": "Teammitglied auswählen",
    "phoneNumbers": "Telefonnummern",
    "roundRobin": "Wechselnde Zuweisung",
    "selectCalendar": "Kalender auswählen",
    "selectTeamMember": "Teammitglied auswählen",
    "actionRequired": "Aktion erforderlich",
    "scheduleAppointment": "Termin vereinbaren",
    "considerLeavingItBlank": "Lassen Sie das Feld leer, wenn Sie den vorkonfigurierten Titel des Termins verwenden möchten",
    "assignedTo": "Zugewiesen an",
    "download": "Herunterladen",
    "loadingTranscription": "Transkription wird geladen …",
    "mute": "Stummschalten",
    "playpause": "Wiedergabe/Pause",
    "playbackSpeed": "Wiedergabegeschwindigkeit",
    "remove": "Entfernen",
    "stop": "Stopp",
    "timePlayedTotalTime": "Spielzeit: Gesamtzeit",
    "viewTranscript": "Transkript anzeigen",
    "below": "unter",
    "calls1": "Anrufe",
    "liveChat": "Live-Chat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chat-Gespräch zugewiesen",
    "youAreChoosingNot": "Wenn Sie sich dafür entscheiden, das LC-Phone-Unterkonto nicht zu löschen und zu schließen, bedeutet dies, dass Ihnen weiterhin die gesamte Nutzung in Rechnung gestellt wird, unabhängig davon, ob dem Standort Gebühren berechnet werden oder nicht.",
    "thingsAreJustGetting": "Das ist erst der Anfang. Lassen Sie uns gemeinsam herausfinden, wie GHL Ihnen beim Aufbau Ihres Unternehmens helfen kann.<br />In der Zwischenzeit können Sie nach Herzenslust weiterhin Nachrichten versenden",
    "wohooConversationsAreFlowing": "Juhu! Die Chats laufen jetzt",
    "conversationBegan": "Chat hat begonnen um",
    "fetchOlderMessages": "Ältere Nachrichten abrufen",
    "inboundDndHasBeen": "Eingehendes DND wurde für diesen Kontakt aktiviert",
    "internalComment": "Interner Kommentar",
    "confirmByTyping": "Durch Eingabe bestätigen",
    "iConfirmToDisconnect": "Ich bestätige, dass das LC-Phone-Konto für diesen Standort getrennt und geschlossen werden soll. Mir ist bewusst, dass dadurch alle Nummern und A2P-Kampagnen gelöscht werden und nicht wiederhergestellt werden können.",
    "iConfirmThatI": "Ich bestätige, dass ich dies mit meinem Kunden besprochen habe und befugt bin, diese Maßnahme zu ergreifen",
    "connect": "Verbinden",
    "disputeThisReview": "Diese Bewertung anfechten",
    "dndIsActiveFor": "DND ist für Anrufe aktiv",
    "off": "DEAKTIVIERT",
    "done": "Erledigt",
    "downloadFile": "Datei herunterladen",
    "AddAccount": "+ Konto hinzufügen",
    "attachFile": "Datei anhängen",
    "clickHereToAdd": "Klicken Sie hier, um eine hinzuzufügen.",
    "customerName": "Kundenname",
    "customerPhone": "Kundenkontaktnummer",
    "orEnterAMessage": "Oder geben Sie eine Nachricht ein",
    "fromEmail": "E-Mail-Adresse des Absenders",
    "fromName": "Absendername",
    "youDontHaveAny": "Bisher sind keine Vorlagen vorhanden.",
    "requestPayment": "Zahlung anfordern",
    "schedule": "Planen",
    "selectATemplate": "Vorlage auswählen",
    "sendNow": "Jetzt senden",
    "smtpProvidersHasSome": "SMTP-Anbieter hat einige Einschränkungen. Klicken Sie hier, um mehr zu erfahren.",
    "subject": "Betreff",
    "useATemplateSnippet": "Vorlage verwenden (Snippet)",
    "deliveredtotalDelivered": "{delivered}/{total} gesendet",
    "countMoreEmailsIn": "{count} weitere E-Mails im Thread",
    "primary": "(Primär)",
    "reply": "Antwort",
    "respond": "Antworten",
    "retry": "Wiederholen",
    "to": "An:",
    "fbCommentReplyDm": "Antwort auf einen FB-Kommentar – DM",
    "fbMessage": "FB-Nachricht",
    "theseAttachmentsMayNot": "Diese Anhänge werden möglicherweise nicht mehr unterstützt.",
    "urlCannotBeFound": "URL wurde nicht gefunden",
    "activity": "Aktivität",
    "filters": "Filter",
    "goToPost": "Zum Post gehen",
    "inboundCall": "Eingehender Anruf",
    "instagramDm": "Instagram-DM",
    "internalChat": "Interner Chat",
    "search2": "Suche erfolgt …",
    "starred": "Mit Sternchen",
    "leftAVoicemail": "Hat eine Sprachnachricht hinterlassen",
    "manual": "Handbuch",
    "mergeFields": "Felder zusammenführen",
    "addToDocuments": "Zu Dateien hinzufügen",
    "failedToAddAttachments": "Fehler beim Hinzufügen von Anhängen zu Dateien",
    "attachmentsAddedToDocuments": "Anhänge wurden erfolgreich zu Dokumenten hinzugefügt",
    "newCommentOnPagename": "Neuer Kommentar zu Beitrag auf {pageName}.",
    "outboundCall": "Ausgehender Anruf",
    "replyAsDm": "Mit DM antworten",
    "replyingAsAPrivate": "Das Antworten als private DM ist für Kommentare, die älter als 7 Tage sind, nicht verfügbar.",
    "reportFeedbackForAi": "Feedback für AI melden",
    "storyMention": "Story-Erwähnung",
    "storyReply": "Story-Antwort",
    "bulkRequest": "Massedaten-Anfrage",
    "eventsAreCurrentlyCaptured": "Events werden derzeit nur für die E-Mail-Adresse des Kontakts erfasst.",
    "failed": "Fehlgeschlagen",
    "gbpMessage": "GBP-Nachricht",
    "pageName": "Seitenname",
    "unknown": "Unbekannt",
    "typeAMessage": "Nachricht eingeben",
    "new": "Neu",
    "newAppointmentBookedBy": "Neuer Termin gebucht von",
    "customerNameRequired": "Kundenname erforderlich",
    "messageIsRequired": "Nachricht ist erforderlich",
    "pickATemplateTo": "Wählen Sie eine Vorlage zur Verwendung aus.",
    "newMessage": "Neue Nachricht",
    "newTask": "Neue Aufgabe",
    "toMakeACall": "Um einen Anruf zu tätigen, geben Sie bitte eine Rufnummer in dieses Feld ein.",
    "primary1": "Primär",
    "provider": "Provider",
    "refresh": "Aktualisieren",
    "resetPassword": "Kennwort zurücksetzen",
    "thisReviewHasAlready": "Diese Bewertung wurde bereits auf {network} veröffentlicht. Möchten Sie sie wirklich erneut veröffentlichen?",
    "seeThisReviewOn": "Diese Bewertung auf GBP ansehen",
    "reviewResponse": "Antwort prüfen",
    "searchUsers": "Benutzer suchen",
    "sendEmail": "E-Mail senden",
    "sending": "Wird gesendet …",
    "thisSubaccountHasPhonenumberco": "Dieses Unterkonto hat {phoneNumberCount} Nummern und {campaignsCount} A2P-Kampagne(n). Auch nach der Löschung dieses Kontos fallen Gebühren an, wenn das LC-Phone-Systemkonto nicht getrennt und geschlossen wird.",
    "thisSubaccountDoesNot": "Dieses Unterkonto hat keine Nummern und keine A2P-Kampagnen. Wenn Sie dieses Konto pausieren, fallen für Sie keine Gebühren an, doch wir empfehlen, die Verbindung zu trennen und das LC-Phone-Konto zu schließen.",
    "summary": "Zusammenfassung",
    "unassigned": "Nicht zugewiesen",
    "viewSubmission": "Einsendung anzeigen",
    "contactSupport": "Support kontaktieren",
    "create": "Erstellen",
    "illDoThisLater": "Ich werde das später tun",
    "enterBusinessName": "Unternehmensnamen eingeben",
    "firstNameOfThe": "Vorname des Geschäftsinhabers",
    "mobileBusinessPhone": "Mobiltelefon/Unternehmenstelefon",
    "iDontHaveA": "Ich habe keine Website",
    "clientName": "Kundenname",
    "letUsSetupYour": "Lassen Sie uns Ihr eigenes Konto oder Ihren ersten Kunden konfigurieren",
    "clientNameIsRequired": "Kundenname ist erforderlich",
    "pleaseEnterAValid": "Bitte eine gültige E-Mail-Adresse eingeben",
    "emailAddressIsRequired": "E-Mail-Adresse erforderlich",
    "firstNameIsRequired": "Vorname ist erforderlich",
    "lastNameIsRequired": "Nachname ist erforderlich",
    "phoneNumberIsRequired": "Rufnummer ist erforderlich",
    "copyOfName": "Kopie von {name}",
    "goToDashboard": "Zum Dashboard wechseln",
    "permissionsNotEnabled": "Berechtigungen nicht aktiviert!",
    "createAndSellCustom": "Erstellen und verkaufen Sie benutzerdefinierte Produkte mit Print-on-Demand-Dropshipping",
    "viewApp": "App anzeigen",
    "seamlessFulfillmentRealtimeShi": "Nahtlose Auftragsabwicklung und Live-Versandtarife für Ihre E-Commerce-Shops",
    "learnMore": "Mehr erfahren",
    "activateFormMapping": "Formularzuordnung aktivieren",
    "avatarName": "Avatar-Name",
    "formFields": "Formularfelder",
    "formName": "Formularname",
    "mapFields": "Felder zuordnen",
    "update": "Aktualisierung",
    "pauseSubaccount": "Unterkonto pausieren",
    "pausing": "Wird pausiert …",
    "subaccount": "Unterkonto",
    "howItWorks": "So funktioniert's",
    "uponCompletingThisAction": "Nach Abschluss dieser Aktion wird die Überweisungsanfrage an die empfangende Agentur ({relNo}) zugestellt. Das Unterkonto wird sofort übertragen, nachdem es dort angenommen wurde. Bitte beachten Sie, dass diese Aktion unwiderruflich ist.",
    "ejectSubaccount": "Unterkonto entfernen",
    "newAgencyCreationMail": "E-Mail zur Erstellung einer neuen Agentur wurde an den ausgewählten Benutzer gesendet. Der Benutzer kann eine neue Agentur erstellen, indem er auf den in der E-Mail gesendeten Link klickt.",
    "unableToTransferSubaccount": "Unterkonto kann nicht an diese Agentur übertragen werden.",
    "nominateAccountOwnerFor": "Kontoinhaber für das neue Konto benennen",
    "pleaseConfirmOwnershipWill": "Bitte bestätigen Sie, dass die Eigentümerschaft übertragen wird an",
    "scheduledDate": "Geplantes Datum",
    "thisDateIsBased": "Dieses Datum basiert auf der Zeitzone dieses Unternehmens: {timezone}",
    "campaignName": "Kampagnenname",
    "copyCampaign": "Kampagne kopieren",
    "endTime": "Endzeit",
    "event10xEmail4": "Event: 10X Email 4 (Listing Distribution) ",
    "10xEmail1Reviews": "10X Email 1 (Reviews)",
    "fromAddress": "Absenderadresse",
    "leadValue": "Lead-Wert",
    "option1": "Option 1",
    "option2": "Option 2",
    "option3": "Option 3",
    "preview": "Vorschau",
    "selectCampaign": "Kampagne auswählen",
    "startTime": "Startzeit",
    "time": "Zeit",
    "users": "Benutzer",
    "noRecordsFound": "Keine Datensätze gefunden",
    "pageDetail": "Seitendetails",
    "selectAll": "Alle auswählen",
    "submission": "Einsendung",
    "addProduct": "Produkt hinzufügen",
    "visitors": "Besucher",
    "By": " von",
    "conversions": "Konversionsrate ",
    "liveReviews": "Live-Bewertungen",
    "liveVisitors": "Live-Besucher",
    "pageVisits": "Seitenbesuche",
    "stream": "Stream",
    "addOneOrMore": "Fügen Sie eine oder mehrere Seiten-URLs hinzu oder kopieren Sie diese direkt aus Ihrem Webbrowser.",
    "WeWillAutomatically": " Wir verfolgen Ihre Website-Besucher automatisch in Echtzeit. ",
    "connectYourLocationsFacebook": "Verbinden Sie das Facebook-Konto Ihres Standorts",
    "connected": "Verbunden!",
    "Contains": " enthält ",
    "expression": "Ausdruck",
    "facebookAccount": "Facebook-Konto",
    "wowYouDontNeed": "Hier müssen Sie nichts konfigurieren. Sie können fortfahren.",
    "Regex": " regex ",
    "selectUrlMatchType": "Wählen Sie den URL-Übereinstimmungstyp aus",
    "Simple": " einfach ",
    "LivePreview": " Live-Vorschau",
    "seconds": "Sekunden",
    "launch": "Starten ",
    "decorativeVector1": "Dekorativer Vektor 1",
    "showingFromToTo": "Es werden {from} bis {to} von {total} Einträgen angezeigt",
    "cloneProduct": "Produkt klonen",
    "connectFacebookInstagram": "Facebook und Instagram verbinden",
    "connectPage": "Seite verbinden!",
    "everythingIn": "Alles in",
    "agentChat25": "Agenten-Chat (ca. 2–5 Min. Wartezeit)",
    "aiSupportChat": "AI-Support-Chat",
    "startChat": "Chat starten",
    "locations1": "Standorte",
    "phone1": "Rufnummer",
    "slack": "Slack",
    "segments1": "Segmente",
    "areYouSureYou": "Sind Sie sicher, dass Sie diesen Ordner löschen möchten?",
    "verified": "Verifiziert",
    "highlevelPrice": "HighLevel-Preis",
    "howDoesItWork": "Wie funktioniert das?",
    "payNow": "Jetzt bezahlen",
    "priceMustBeMore": "Der Preis muss höher oder gleich dem HighLevel-Preis sein",
    "saving2": "Wird gespeichert",
    "yourPrice": "Ihr Preis",
    "yourProfit": "Ihr Gewinn",
    "youNeedToComplete": "Zu Compliance-Zwecken müssen Sie einige einfache Schritte durchführen, um den SaaS-Modus für diesen Standort zu deaktivieren",
    "youAreNotAuthorized": "Sie sind nicht berechtigt, diese Aktion auszuführen. Dies ist nur den Administratoren der Agentur gestattet.",
    "disableSaasModeFor": "SaaS-Modus für {name} deaktivieren",
    "companyBilling": "Unternehmensabrechnung",
    "bccEmailsCommaDelimited": "BCC-E-Mail-Adressen (durch Kommas getrennt)",
    "unableToDeleteMailgun": "Mailgun-Konto kann nicht gelöscht werden. Bitte kontaktieren Sie den Support.",
    "forwardingAddress": "Weiterleitungsadresse",
    "forwardingAddressesCommaDelimi": "Weiterleitungsadressen (durch Komma getrennt)",
    "amount": "Betrag",
    "billingDate": "Rechnungsdatum",
    "debugWalletTransactionsTotal": "DEBUGGING-Wallet-Transaktionen, gesamt: {count}",
    "detailedTransactions": "Detaillierte Transaktionen",
    "transactionsOnlyAfter26th": "Nur Transaktionen nach dem 26. April 2022 werden aufgeführt und stehen für den Export zur Verfügung",
    "someRecordsMayTake": "Bei einigen Datensätzen kann es bis zu 24 Stunden dauern, bis sie hier aktualisiert werden.",
    "totalBalance": "Gesamtguthaben",
    "walletTransactions": "Wallet-Transaktionen",
    "walletTransactionsAllDate": "Wallet-Transaktionen – Alle – {date}",
    "enterMessage": "Nachricht eingeben",
    "applyThisChangeTo": "Wenden Sie diese Änderung auf alle Unterkonten an.",
    "characters": "Zeichen",
    "iConfirmThatI1": "Ich bestätige, dass ich dies mit meinem Kunden besprochen habe und seine Genehmigung habe.",
    "iConfirmThatI2": "Ich bestätige, dass ich sicherstellen werde, dass alle von diesem Konto gesendeten SMS-Nachrichten der aktuellen Richtlinie entsprechen.",
    "theContentsOfThis": "Der Inhalt dieser Nachricht wird automatisch der ersten SMS hinzugefügt, die als Massennachricht gesendet wird.",
    "iConfirmThatSms": "Ich bestätige, dass SMS-Nachrichten nur an Kontakte gesendet werden, die dem Erhalt von SMS zugestimmt haben.",
    "quickTip": "Schneller Tipp",
    "messageWillBeAppended": "Die Nachricht wird in der ersten SMS einer Konversion angehängt, wenn sie keine Abmelde-Anweisung enthält",
    "readMore": "Weiterlesen",
    "noncompliantActivityMayLead": "Bei Richtlinienverstößen kann die Nutzung der SMS- und Sprachfunktionen Ihres Kontos gesperrt werden.",
    "typeConfirmBelowTo": "Geben Sie unten „Bestätigen“ ein, um fortzufahren",
    "products": "Produkte",
    "chooseCountry": "Land auswählen …",
    "email2": "E-Mail-Adresse*",
    "firstName1": "Vorname*",
    "lastName1": "Nachname*",
    "brandDetails": "Markendetails",
    "brandName": "Markenname*",
    "useEitherLegalName": "Verwenden Sie entweder den rechtlichen Namen des Unternehmens, das die Nachrichten sendet, oder Ihren eigenen Namen, wenn diese Marke nicht mit einem Unternehmen verknüpft ist.",
    "businessIndustry": "Unternehmensbranche*",
    "chooseVertical": "Geschäftsbereich auswählen …",
    "mobileNumberForOtp": "Mobilrufnummer für die OTP-Verifizierung (mit Ländervorwahl)*",
    "pleaseProvideAMobile": "Bitte geben Sie eine Mobilrufnummer an, auf die Sie Zugriff haben, damit Sie die OTP-Verifizierung vornehmen können. Nur US-/kanadische Nummern werden akzeptiert. Sie dürfen keine CPaaS-Rufnummer verwenden, wie zum Beispiel eine, die von LeadConnector bezogen wurde. Sie können dieselbe Mobilrufnummer nicht verwenden, um mehr als 3 Einzelunternehmermarken zu registrieren. Dieses Limit wird durch TCR verwaltet.",
    "increasedDeliveryRate": "Erhöhte Zustellungsfrequenz",
    "sendUpto3000Segments": "Senden Sie bis zu 3.000 Segmente pro Tag",
    "businessDetails": "Unternehmensangaben",
    "thereWasSomeIssue": "Beim Absenden des Profils ist ein Problem aufgetreten.",
    "yourProfileSubmissionFailed": "Ihre Profileinreichung ist fehlgeschlagen.",
    "endUserConsent": "Endbenutzer-Einwilligung",
    "minLength40Characters": "Mindestlänge: 40 Zeichen. Höchstlänge: 2.048 Zeichen.",
    "closeExamples": "Beispiele schließen",
    "sampleMessage1": "Beispielnachricht #1*",
    "seeExamples": "Beispiele ansehen",
    "enterCampaignDetails": "Kampagnendetails eingeben",
    "youWillReceiveAn": "Zur Verifizierung erhalten Sie von TCR eine OTP-Nachricht auf Ihre angegebene Mobilrufnummer. Bitte antworten Sie innerhalb von 24 Stunden nach Erhalt der SMS mit „Yes\".",
    "brandNameIsRequired": "Markenname ist erforderlich.",
    "businessVerticalIsRequired": "Geschäftsbereich ist erforderlich.",
    "mobileNumberIsRequired": "Mobilrufnummer ist erforderlich.",
    "hideDetail": "Details ausblenden",
    "showDetail": "Details anzeigen",
    "people": "Volk",
    "person": "Einzelperson",
    "after": "Später",
    "before": "vor dem",
    "hour": "Stunde",
    "hours": "Stunden",
    "minute": "Minute",
    "minutes": "Minuten",
    "triggerLinksEmbeddedIn": "Angeklickte Trigger-Links (in Nachricht eingebettet) als Prozentsatz der gesendeten Nachrichten",
    "addNewEvent": "Neues Event hinzufügen",
    "addTask": "Aufgabe hinzufügen",
    "manualCall": "Manueller Anruf",
    "manualSms": "Manuelle SMS",
    "messenger": "Messenger",
    "wait": "Warten",
    "webhook": "Webhook",
    "about": "Über",
    "accessRestricted": "Zugriff eingeschränkt",
    "addPartner": "Partner hinzufügen",
    "addPartnerForm": "Partnerformular hinzufügen",
    "affiliatePortal": "Affiliate-Portal",
    "badges": "Abzeichen",
    "aBriefBio": "Eine kurze Biografie",
    "dashboard": "Dashboard",
    "experience": "Erfahrung",
    "industryServed": "Bediente Branche",
    "instagramAccount": "Instagram-Konto",
    "invoiceHistory": "Rechnungsverlauf",
    "englishGermanHindi": "Englisch, Deutsch, Hindi",
    "linkToWebsite": "Link zur Website",
    "linkedinAccount": "LinkedIn-Konto",
    "locationId": "Standort-ID",
    "partnerName": "Partnername",
    "partnerStatus": "Partnerstatus",
    "paymentDetails": "Zahlungsdetails",
    "paymentHistory": "Zahlungsverlauf",
    "profilePhoto": "Profilfoto",
    "profilePhotoUrl": "Profilfoto-URL",
    "promoterReports": "Promoter-Berichte",
    "searchPartner": "Partner suchen",
    "twitterAccount": "Twitter-Konto",
    "updatePartner": "Partner aktualisieren",
    "updatePartnerForm": "Partnerformular aktualisieren",
    "yearOfExperience": "Jahre an Erfahrung",
    "youtubeAccount": "YouTube-Konto",
    "serviceProvided": "Erbrachte Dienstleistung",
    "controlTheSubaccountSettings": "Unterkonto-Einstellungen verwalten",
    "generalInfo": "Allgemeine Informationen",
    "okay": "Okay",
    "proceed": "Fortfahren",
    "addCard": "Karte hinzufügen",
    "makeThisCardPrimary": "Diese Karte als primäre Karte festlegen",
    "nameOnCard": "Name auf der Karte",
    "chargedToCustomer": "Dem Kunden in Rechnung gestellt",
    "clientBillingPage": "Kundenabrechnungsseite",
    "companyStripeIntegrationPage": "Stripe-Integrationsseite des Unternehmens",
    "enableRebilling": "Neuberechnung aktivieren",
    "enabling": "Wird aktiviert …",
    "forMoreDetails": "um weitere Informationen zu erhalten.",
    "youreOnTheFreelancer": "Sie nutzen den Freelancer-Plan, der Ihren Aufschlag auf 1,05x begrenzt.",
    "minimumAmountShouldBe": "Der Mindestbetrag sollte zwischen ${min} und ${max} liegen",
    "beforeEnablingThisFeature1": "Bevor Sie diese Funktion aktivieren, verbinden Sie bitte Ihr Stripe-Konto auf der",
    "planToSetYour": "um Ihre Aufschläge höher anzusetzen.",
    "rebillAmount": "Neuabrechnungsbetrag",
    "supportDoc": "Support-Dokumentation",
    "10WillGiveYou": "Für 10 USD erhält man ungefähr",
    "minimumMustBeBetween": "Der Mindestwert muss zwischen 0,0001 und 0,005 liegen.",
    "sorryYouCannotRebillAtTheMarkup": "Im Freelancer-Plan können Sie den Aufschlag nicht neu abrechnen. Bitte",
    "modifyingTheseSettingsWillChange": "Wenn Sie diese Einstellungen ändern, werden sich die Kosten für Ihre Kunden in Zukunft ändern.",
    "pleaseDoNotModifyThese": "Bitte ändern Sie diese nicht, wenn Sie sich über die Auswirkungen nicht sicher sind.",
    "theseSettingsWillApply": "Diese Einstellungen gelten in Zukunft für Ihre neuen Kunden.",
    "congratulationsYourDedicatedIp": "Herzlichen Glückwunsch! Ihr Wiederverkaufswert für feste IPs wurde gespeichert.",
    "youHaveAgreedToProvide": "Sie haben zugestimmt, feste IPs direkt für ein Unterkonto bereitzustellen. Die Agentur wird die Gebühren im Namen des Unterkontos übernehmen.",
    "youHaveDiscontinuedToProvide": "Sie haben die Bereitstellung dedizierter IP-Adressen direkt an ein Unterkonto eingestellt. Die Agentur wird die Kosten für das Unterkonto nicht mehr übernehmen.",
    "oopsSomethingWentWrongAndWeCouldnt": "Wir konnten Ihre Konfiguration für den Wiederverkauf von festen IPs nicht speichern. Bitte versuchen Sie es später noch einmal.",
    "pleaseAgreeToTheTerms": "Bitte stimmen Sie den Bedingungen zu",
    "errorWhileFetchingDomains": "Fehler beim Abrufen der Domains",
    "sameStripeCustomerProfileCantBeMapped": "Dasselbe Stripe-Kundenprofil kann nicht mehr als einem Unterkonto zugeordnet werden.",
    "pleasePickADifferentStripeCustomer": "Bitte wählen Sie ein anderes Stripe-Kundenprofil aus oder nutzen Sie die Option „Teilen Sie einen Link“, damit wir ein neues Stripe-Kundenprofil für dieses Unterkonto erstellen können.",
    "clickNextToChooseAPlan": "Klicken Sie auf „Weiter“, um einen Plan auszuwählen und ein neues Abonnement zu erstellen.",
    "youDontHaveAnyActiveSubscriptions": "Sie haben keine aktiven Abonnements",
    "youCanEitherSelectAnExistingSubscription": "Sie können entweder ein bestehendes Abonnement auswählen oder im nächsten Schritt ein neues Abonnement erstellen.",
    "useCommasToSeparateMultipleEmails": "Verwenden Sie Kommas, um mehrere E-Mail-Adressen voneinander zu trennen.",
    "useCommasToSeparateMultiplePhoneNumbers": "Verwenden Sie Kommas, um mehrere Rufnummern voneinander zu trennen.",
    "noUserFoundInThisLocation": "Kein Benutzer an diesem Ort gefunden",
    "noPhoneNumberAttached": "Keine Rufnummer angehängt",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Bitte verwenden Sie den folgenden Link, um Ihre Zahlungsmethode hinzuzufügen.",
    "allowDuplicateContact": "Doppelte Kontakte zulassen",
    "allowDuplicateOpportunity": "Doppelte Opportunitys zulassen",
    "mergeFacebookContactsByName": "Facebook-Kontakte nach Namen zusammenführen",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Eingehende Nachrichten von Facebook werden nur zusammengeführt, wenn sie mit dem Namen eines bestehenden Kontakts übereinstimmen. Bei Namen muss die Groß- und Kleinschreibung beachtet werden.",
    "disableContactTimezone": "Kontaktzeitzone deaktivieren",
    "markEmailsAsInvalidDueToHardBounce": "E-Mails aufgrund eines Hard Bounce als ungültig markieren",
    "contactsEmailsWillBeMarkedAsInvalid": "Die E-Mail-Adressen des Kontakts werden automatisch als ungültig markiert, wenn sie einen Hard Bounce zurückgeben. E-Mail-Aktionen in Automatisierungen werden für Kontakte mit ungültigen E-Mail-Adressen übersprungen.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Sammeln Sie Informationen zu unbekannten Telefonnummern",
    "makeSmsCompliantByAddingAnOptOutMessage": "Erstellen Sie konforme SMS, indem Sie eine Abmelde-Nachricht hinzufügen.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "Wenn diese Option aktiviert ist, wird die Opt-out-Nachricht automatisch der ersten SMS hinzugefügt, die per Massennachricht versendet wird, um Ihre Compliance-Anforderungen zu erfüllen und die Zustellraten zu erhöhen.",
    "platformLanguage": "Plattform-Sprache",
    "outboundCommunicationLanguageForCustomValues": "Sprache für ausgehende Mitteilungen für benutzerdefinierte Werte",
    "updateInformation": "Informationen aktualisieren",
    "upgradeToTheAgency": "Nehmen Sie ein Upgrade auf Agency Pro vor",
    "yourCost": "Ihre Kosten",
    "addACalendarTo": "Fügen Sie einen Kalender hinzu, um mit der Buchung von Terminen zu beginnen.",
    "addselectAContactTo": "Kontakt hinzufügen/wählen, um Termine zu vereinbaren",
    "appointmentSlotIsNot": "Zeitfenster für den Termin wurde noch nicht ausgewählt",
    "loading1": "Wird geladen …",
    "teamMemberIsRequired1": "Teammitglied ist erforderlich",
    "currentPlan": "Aktueller Plan",
    "features1": "Funktionen",
    "upgrade": "Upgrade",
    "viewLess": "Weniger anzeigen",
    "viewMoreCount": "Mehr anzeigen (+{count})",
    "cardNumber": "Kartennummer",
    "expiryDate": "Ablaufdatum",
    "paymentMethods": "Zahlungsmethoden",
    "primaryCard": "Primäre Karte",
    "removeCurrentCard": "Aktuelle Karte entfernen",
    "AddBalance": "+ Guthaben hinzufügen",
    "complimentaryCredits": "Kostenfreie Gutschriften:",
    "expiringOnDate": "Läuft ab am {date}",
    "apiVersion": "API-Version",
    "application": "Anwendung",
    "ipAddress": "IP-Adresse",
    "related": "Verwandt",
    "request": "Anfrage",
    "yourAccountIncludingAll": "Ihr Konto, einschließlich aller ausgehenden Aktivitäten wie geplante Nachrichten und E-Mails, wird unmittelbar pausiert.",
    "yourAccountIncludingAll1": "Ihr Konto, einschließlich aller ausgehenden Aktivitäten wie geplante Nachrichten und E-Mails, wird sofort eingestellt.",
    "nextBillingDateDate": "Nächstes Abrechnungsdatum: {date}",
    "scheduledForCancellation": "Zur Stornierung vorgesehen",
    "abandoned": "Abgebrochen",
    "add1": "Hinzufügen",
    "addOpportunity": "Opportunity hinzufügen --",
    "addOpportunityName": "Opportunity-Namen hinzufügen",
    "Task": "+ Aufgabe",
    "bookupdateAppointment": "Termin buchen/aktualisieren",
    "companyName": "Unternehmensname",
    "areYouSureYou1": "Sind Sie sicher, dass Sie diese Opportunity löschen möchten?",
    "contactInfo": "Kontaktdaten",
    "editOpportunity": "Opportunity bearbeiten --",
    "enterValue": "Geben Sie einen Wert ein",
    "goToContactDetail": "Wechseln Sie zur Kontaktdetailseite",
    "leads": "Leads",
    "lost": "Verpasst",
    "nameIsRequired": "Name ist erforderlich.",
    "youreNotAllowedTo": "Sie dürfen den Kundennamen nicht ändern! Überprüfen Sie Ihre Berechtigungen beim Agentur-Admin.",
    "open": "Offen",
    "opportunity": "Opportunity",
    "opportunityAlreadyExistsIn": "Opportunity besteht bereits in dieser Pipeline",
    "opportunityInfo": "Informationen zur Opportunity",
    "opportunityName": "Name der Opportunity",
    "opportunitySource": "Quelle der Opportunity",
    "owner": "Eigentümer",
    "pipeline": "Pipeline",
    "removeOwner": "Eigentümer entfernen",
    "selectPipeline": "Pipeline auswählen",
    "selectStage": "Phase auswählen",
    "stage": "Schritt",
    "countTasks": "{count} Aufgaben",
    "won": "Gewonnen",
    "and": "und ",
    "addASubscription": "Abonnement hinzufügen",
    "noSaasPlanEnabled": "Kein SaaS-Plan aktiviert",
    "per": "je",
    "assignTo": "Zuweisen an",
    "assignedTo1": "Zugewiesen an:",
    "areYouSureYou2": "Möchten Sie diese Aufgabe wirklich löschen?",
    "due": "Fällig:",
    "dueDateIsRequired": "Fälligkeitsdatum ist erforderlich",
    "dueIn": "Fällig in",
    "dueToday": "Heute fällig",
    "late": "Überfällig",
    "notAssigned": "Nicht zugewiesen",
    "taskDescription": "Aufgabenbeschreibung",
    "taskTitle": "Aufgabentitel",
    "annually": "jährlich",
    "attachments": "Anlage(n)",
    "areYouSureYou3": "Sind Sie sicher, dass Sie diese Massendatenanfrage löschen möchten?",
    "startImmediately": "Sofort beginnen",
    "customers": "Kunde",
    "tag": "Tag",
    "pickType": "Typ auswählen",
    "whoShouldItRun": "Für wen sollte sie ausgeführt werden?",
    "addBulkRequest": "Massendatenanfrage hinzufügen",
    "editBulkRequest": "Massendatenanfrage bearbeiten",
    "scheduledDateIsRequired": "Geplantes Datum ist erforderlich",
    "newCampaignName": "Neuer Kampagnenname",
    "areYouSureYou4": "Sind Sie sicher, dass Sie diese Kampagne löschen möchten?",
    "moveToFolder": "In Ordner verschieben",
    "pleaseRename": "bitte umbenennen",
    "removeFromFolder": "Aus Ordner entfernen",
    "photoPreview": "Foto-Vorschau",
    "pleaseWait": "Bitte warten …",
    "customValues": "Benutzerdefinierte Werte",
    "whatActionShouldWe": "Welche Aktion sollen wir durchführen?",
    "entitynameName": "{entityName}-Name",
    "useLcEmail": "LC-E-Mail verwenden",
    "21Jun2018": "21. Juni 2018",
    "930Am": "9:30 Uhr",
    "Via": " via ",
    "createdTrackingNumbers": "Erstellte Tracking-Nummern",
    "iUnderstandImBuyingadding": "Ich verstehe, dass ich {count} neue Rufnummern kaufe/hinzufüge.",
    "forwardCallsTo": "Anrufe weiterleiten an",
    "numberName": "Name der Nummer",
    "numberPoolName": "Name des Nummern-Pools",
    "numberToSwap": "Nummer zum Austausch",
    "sameAsForwardingNumber": "Gleiche wie Weiterleitungsnummer",
    "callFromSource": "Anruf von [Source].",
    "callRecording": "Anrufaufzeichnung",
    "84Complete": "84 % abgeschlossen",
    "thisCallWillBe": "Dieser Anruf wird zur Qualitätssicherung aufgezeichnet.",
    "whisperMessage": "Übergabenachricht",
    "allExceptDirect": "Alle außer direkt",
    "allExceptDirectOrganic": "Alle außer direkt und organisch",
    "allSearch": "Alle Suchanfragen",
    "allVisitorsRecommended": "Alle Besucher (empfohlen)",
    "bing": "Bing",
    "direct": "Direkt",
    "visitorsWithoutAReferring": "Besucher ohne Verweiswebsite",
    "for": "für",
    "google": "Google",
    "landingPageOrUrl": "Landingpage oder URL-Parameter",
    "organic": "Organisch",
    "paid": "Bezahlt",
    "pickOneYouCan": "Wählen Sie eine Option – Sie können dies später jederzeit ändern.",
    "ppcSearch": "PPC-Suche",
    "visitorsFromGoogleBing": "Besucher von Google-, Bing- und Yahoo-PPC-Suchen",
    "referringPage": "Verweisseite",
    "visitorsFrom": "Besucher von",
    "visitorsFromGoogleAds": "Besucher von Google Ads",
    "visitorsWhoAreReferred": "Weitergeleitete Besucher von",
    "visitorsWhoLandOn": "Besucher der",
    "whichVisitorsDoYou": "Welche Besucher möchten Sie nachverfolgen?",
    "yahoo": "Yahoo",
    "17Complete": "17 % abgeschlossen",
    "callTimeoutS": "Anruf-Timeout (s)",
    "callWhisper": "Anrufübergabe",
    "disableVoicemailDetect": "Voicemail-Erkennung deaktivieren",
    "eventName": "Veranstaltungsname",
    "timeoutSeconds": "Timeout (Sekunden)",
    "editCall": "Anruf bearbeiten",
    "callWillPatchInstantly": "Der Anruf wird sofort weitergeleitet, ohne zu prüfen, ob auf der Lead-Seite die Voicemail aktiviert wurde. Dies bedeutet, dass für die Kampagne auch dann eine Antwort verzeichnet wird, wenn die Voicemail den Anruf entgegengenommen hat.",
    "thisIsTheMessage": "Dies ist die Nachricht, die die Person hören soll, die das Telefon abhebt. Sie können benutzerdefinierte Variablen verwenden, um diese anzupassen.",
    "pleaseCheckTheLinks": "Bitte überprüfen Sie die Links, bei denen Sie einen benutzerdefinierten Wert haben. Zwischen {{ und den custom_values gibt es ein zusätzliches „%20“.",
    "anErrorOcurredPlease": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut.",
    "pleaseInsertATo": "Bitte geben Sie eine Empfängeradresse ein.",
    "pickEmailTemplate": "E-Mail-Vorlage auswählen",
    "sendTest": "Test senden",
    "composeEmail": "E-Mail verfassen",
    "composeEmailTemplate": "E-Mail-Vorlage erstellen",
    "toAddress": "Empfängeradresse",
    "addFileThroughUrl": "Datei über URL hinzufügen",
    "appCharacters": "App-Zeichenanzahl:",
    "approximateCost": "Ungefähre Kosten:",
    "estimatedCostForUs": "Geschätzte Kosten nur für SMS von den USA in die USA.",
    "mobilePhoneNumber": "Mobilrufnummer",
    "numSegments": "Anz. Segmente",
    "pickMessageTemplate": "Nachrichtenvorlage wählen",
    "pleaseProvideAPhone": "Bitte geben Sie eine Rufnummer an, an die der Test gesendet werden soll.",
    "composeEventtype": "{eventType} erstellen",
    "composeEventtypeTextTemplate": "{eventType}-Textvorlage erstellen",
    "unsupportedSmsContentType": "Nicht unterstützter SMS-Inhaltstyp {fileType}",
    "countOfTheProvided": "{count} von den bereitgestellten URL-Anhängen {plural} kein Bild. Dies kann zu Fehlern innerhalb von Twilio führen. Trotzdem speichern?",
    "dropFileHereOr": "Legen Sie die Datei hier ab oder klicken Sie hier, um eine Datei hochzuladen",
    "ifYouHaveAdditional": "Falls Sie weitere Fragen haben, sehen Sie bitte die FAQ zum Voicemail-Drop auf den Hilfeseiten ein.",
    "editVoicemail": "Voicemail bearbeiten",
    "selectAMp3Or": "Wählen Sie eine MP3- oder WAV-Datei aus. Wir unterstützen keine anderen Formate.",
    "voicemailFile": "Voicemail-Dokument",
    "warningVoicemailDropsAre": "Achtung: Voicemail-Drops funktionieren ungefähr 70 % der Zeit.",
    "youNeedToPick": "Sie müssen mindestens einen Tag auswählen",
    "editWait": "Wartezeit bearbeiten",
    "url": "URL",
    "customTime": "Benutzerdefinierte Zeit",
    "executeThisActionIf": "Führen Sie diese Aktion aus, wenn die aktuelle Zeit in dieses Zeitfenster fällt. Liegt die aktuelle Zeit außerhalb dieses Zeitfensters, überspringen Sie diesen Schritt und fahren Sie mit der nächsten Aktion fort.",
    "pickDays": "Tage auswählen",
    "pickTime": "Uhrzeit auswählen",
    "noRecordsFound1": "Keine Datensätze gefunden.",
    "formAnalyze": "Formularanalyse",
    "totalSubmission": "Gesamteinsendungen",
    "forgotPassword": "Passwort vergessen?",
    "orContinueWith": "Oder fahren Sie fort mit",
    "signIn": "Anmelden",
    "signIntoYourAccount": "Melden Sie sich bei Ihrem Konto an",
    "thePasswordYouPicked": "Das von Ihnen gewählte Passwort",
    "yourEmailAddress": "Ihre E-Mail-Adresse",
    "newEmailFrom": "Neue E-Mail von",
    "newMessageFrom": "Neue Nachricht von",
    "hasLeftANew": "hat eine neue Bewertung hinterlassen.",
    "repliedToTheReview": "hat auf die Bewertung geantwortet.",
    "loaded": "Geladen",
    "snapshot": "Schnappschuss",
    "appointment": "Termin",
    "appointmentDueInMinutes": "Termin in {minutes} Minuten für {contactName}",
    "appointmentReminder": "Terminerinnerung",
    "completedCount": "Abgeschlossen: {count}",
    "conversation": "Konversation",
    "facebookReview": "Facebook-Bewertung",
    "failedCount": "Fehlgeschlagen: {count}",
    "googleReview": "Google-Bewertung",
    "internalChatMessage": "Interne Chat-Nachricht",
    "usernameMentionedYouIn": "{userName} hat Sie in einer Konversation mit {contactName}erwähnt",
    "newAppointmentAssigned": "Neuer Termin zugewiesen",
    "aNewAppointmentWith": "Ein neuer Termin mit {contactName} wurde Ihnen zugewiesen.",
    "newAppointmentBooked": "Neuer Termin gebucht",
    "youHaveNewAppointment": "Sie haben einen neuen Termin mit {contactName}",
    "newCall": "Neuer Anruf",
    "aNewChatWith": "Ihnen wurde ein neuer Chat mit {contactName} zugewiesen.",
    "newEmail": "Neue E-Mail",
    "newMention": "Neue Erwähnung",
    "newReviewReceivedFrom": "Neue Bewertung erhalten von {contactName}",
    "aNewTypeIs": "{type} von {contactName} empfangen",
    "notification": {
      "noRecentActivity": "Keine kürzliche Aktivität"
    },
    "subAccount": "Unterkonto",
    "subaccount1": "Unterkonto:",
    "titleOnDateAt": "{title} am {date} um {time} für {contactName}",
    "titleDueInDuetime": "{title} fällig in {dueTime} {unitOfTime} für {contactName}",
    "taskReminder": "Aufgabenerinnerung",
    "youHaveCountTasks": "Sie haben {count} Aufgaben, die heute fällig sind",
    "youHaveCountTasks1": "Sie haben bis jetzt {count} Aufgaben, die überfällig sind",
    "droppedVoicemailTo": "Sprachnachricht hinterlassen bei",
    "errorWhileCloningProduct": "Fehler beim Klonen des Produkts!",
    "productName": "Produktname",
    "selectLocations": "Standorte auswählen",
    "selectUptoMaxselectablelocatio": "Wählen Sie bis zu {maxSelectableLocations} Standorte aus",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} weitere",
    "emails": "E-Mails",
    "accountNotification": "Kontobenachrichtigung",
    "customerCare": "Kundenbetreuung",
    "deliveryNotification": "Zustellbenachrichtigung",
    "fraudAlertMessaging": "Betrugswarnungen",
    "higherEducation": "Hochschulbildung",
    "lowVolumeMixedRecommended": "Geringes Volumen gemischt (empfohlen)",
    "mixed": "Gemischt",
    "pollingAndVoting": "Umfragen und Abstimmungen",
    "publicServiceAnnouncement": "Öffentliche Bekanntmachung",
    "securityAlert": "Sicherheitswarnung",
    "mixedRecommended": "Gemischt (empfohlen)",
    "australiaCompanyNumberFrom": "Australien: Unternehmensnummer bei ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Kanada: Kanadische Unternehmensnummer (Canadian Business Number, CBN)",
    "indiaCorporateIdentityNumber": "Indien: Unternehmensidentifikationsnummer (Corporate Identity Number)",
    "greatBritainCompanyNumber": "Großbritannien: Unternehmensnummer (Company Number)",
    "usaEmployerIdentificationNumbe": "USA: Arbeitgeberidentifikationsnummer (Employer Identification Number, EIN)",
    "other": "Andere",
    "israelRegistrationNumber": "Israel: Registrierungsnummer",
    "estoniaVatNumber": "Estland: Umsatzsteuer-Identifikationsnummer",
    "cooperative": "Genossenschaft",
    "corporation": "Unternehmen",
    "limitedLiabilityCompanyOr": "Gesellschaft mit beschränkter Haftung oder Einzelunternehmen",
    "nonprofitCorporation": "Gemeinnütziges Unternehmen",
    "partnership": "Partnerschaft",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Director",
    "generalCounsel": "General Counsel",
    "onlineTrainingEducation": "Online-Schulungen und -Weiterbildung",
    "financialServices": "Finanzdienstleistungen",
    "fitnessLifestyle": "Fitness und Lifestyle",
    "healthMedical": "Gesundheit und Medizin",
    "homeServices": "Haushaltsnahe Dienstleistungen",
    "legalServices": "Rechtsdienstleistungen",
    "marketingAdvertising": "Marketing und Werbung",
    "others": "Andere",
    "realEstate": "Immobilien",
    "restaurants": "Restaurants",
    "retailEcommerce": "Einzelhandel und E-Commerce",
    "yourInformationHasBeen": "Ihre Informationen wurden übermittelt.",
    "somethingWentWrong1": "Etwas ist schiefgelaufen",
    "newPassword": "Neues Passwort",
    "proceedToLogin": "Weiter zur Anmeldung",
    "anyTime": "jederzeit.",
    "callUsHighlevelSupport": "Rufen Sie den HighLevel Support an –",
    "troubleLoggingIn": "Probleme beim Anmelden?",
    "sendSecurityCode": "Verifizierungscode senden",
    "sendCodeToEmail": "Code an E-Mail-Adresse senden",
    "verifySecurityCode": "Sicherheitscode überprüfen",
    "privacyPolicy": "Datenschutzrichtlinie",
    "businessProfile": "Unternehmensprofil",
    "reserveWithGoogleIntegration": "„Mit Google reservieren“-Integration",
    "friendlyName": "Üblicher Name",
    "updateCallerId": "Anrufer-ID aktualisieren",
    "internationalFormat": "Internationales Format",
    "localFormat": "Lokales Format",
    "poolNumbers": "Pool-Nummern",
    "swappingNumbers": "Nummern tauschen",
    "selectField": "Feld auswählen",
    "surveyAnalyze": "Umfrageanalyse",
    "locationIsRequired": "Standort ist erforderlich.",
    "newSurveyName": "Neuer Umfragename",
    "copySurvey": "Umfrage kopieren",
    "primaryCalendar": "Primärer Kalender",
    "cloneEntityname": "{entityName} klonen",
    "youHaveSuccessfullySubmitted": "Ihre Dokumente wurden eingereicht",
    "addCustomValue": "Benutzerdefinierten Wert hinzufügen",
    "value": "Wert",
    "youHaveSuccessfullyDeleted": "Sie haben das Paket gelöscht.",
    "bundleDeletedSuccessfully": "Paket wurde gelöscht",
    "thereIsAnIssue": "Es gibt ein Problem mit einem Ihrer Begleitdokumente. Bitte prüfen Sie die Begleitdokumente und den Ablehnungsgrund.",
    "connect1": "Verbinden!",
    "itSeemsEitherThe": "Es scheint, dass entweder die Google-Verbindung unterbrochen ist oder am aktuellen Standort keine Verbindung hergestellt werden kann. Bitte überprüfen Sie die Integrationseinstellungen und stellen Sie die Integration erneut her, falls die Verbindung bereits besteht.",
    "selectPage": "Seite wählen",
    "somethingWentWrongPlease": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    "accept": "Akzeptieren",
    "moreThan1Phone": "Mehr als eine Rufnummer zulässig",
    "byContinuingToUse": "Durch die weitere Nutzung der HighLevel-Plattform stimmen Sie diesen neuen {termsLink} und {privacyLink} zu.",
    "byContinuingToUse1": "Durch die weitere Nutzung der HighLevel-Plattform stimmen Sie diesen neuen Dokumenten zu:",
    "termsOfService": "Nutzungsbedingungen",
    "weHaveUpdatedOur": "Wir haben unsere Nutzungsbedingungen und Datenschutzrichtlinie aktualisiert. Bitte sehen Sie sie sich an!",
    "newTriggerName": "Neuer Trigger-Name",
    "triggerName": "Trigger-Name",
    "disableDndForSpecific": "DND für bestimmte Kanäle deaktivieren",
    "selectAdAccount": "Anzeigenkonto auswählen",
    "selectAppointmentStatus": "Terminstatus auswählen",
    "below1": "unten.",
    "Required": "* erforderlich",
    "whenYouGetA": "Wenn Sie eine neue Bewertung erhalten, werden wir sie automatisch auf Ihrer Facebook-Seite veröffentlichen. Beachten Sie, dass es sich bewährt hat, nicht mehr als 3 Bewertungen pro Tag zu veröffentlichen.",
    "skip": "Überspringen",
    "copyShareLink": "Freigabelink kopieren",
    "agencyRelationshipNumbers": "Agenturbeziehungsnummern",
    "alteast1AgencyRelationship": "Mindestens eine Agenturbeziehungsnummer ist erforderlich.",
    "alteast1SubaccountId": "Mindestens eine Unterkonto-ID ist erforderlich.",
    "somethingWentWrongWhile": "Beim Speichern ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
    "5PerPage": "5 pro Seite",
    "10PerPage": "10 pro Seite",
    "amountMustGreaterOr": "Der Betrag muss größer als oder gleich 1 AUD sein.",
    "regions": {
      "africa": "Afrika",
      "asia_pacific": "Asien/Pazifik",
      "europe": "Europa",
      "latin_america": "Lateinamerika",
      "usa_and_canada": "USA und Kanada",
      "asia": "Asien",
      "latinAmerica": "Lateinamerika",
      "usaCanada": "USA und Kanada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "Keine Einträge vorhanden",
    "clear": "Klären",
    "filter": "Filter",
    "test": "Test",
    "createNewTwilioSubAccountText": "Bevor Sie die Neuberechnung aktivieren, müssen Sie ein neues Twilio-Konto erstellen, die Zugangsdaten für dieses Konto unter „Twilio-Einstellungen“ aktualisieren und die Telefonnummern migrieren.",
    "viewing": "Wird angezeigt",
    "makeSmsCompliantByAddingASenderInformation": "Erstellen Sie konforme SMS, indem Sie Absenderinformationen hinzufügen.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Erstellen Sie konforme E-Mails, indem Sie einen Abmeldelink hinzufügen",
    "enableMissedCallTextBack": "SMS-Versand bei verpassten Anrufen aktivieren",
    "productInventory": "Produktbestand",
    "viewProductVariants": "Produktvarianten anzeigen",
    "smtpSettings": "SMTP-Einstellungen",
    "locationOPMTrafficStatis": "Standort OPM Traffic-Statistiken",
    "locationGPMTrafficStatis": "Standort GPM Verkehrsstatistiken",
    "blacklistMonitorReports": "Blacklist-Monitor-Berichte",
    "twoFactorAuthentication": "Zwei-Faktor-Authentifizierung (2FA)",
    "recent": "Neueste",
    "noPermission": "Sie haben keine Berechtigung, Vorlagen für dieses Produkt zu verwalten. Weiterleitung zum Dashboard.",
    "tasksNowHave": "Aufgaben haben jetzt",
    "option": "Option",
    "facebookAdsReporting": "Facebook-Werbeanzeigen-Berichterstattung",
    "googleAdsReporting": "Google Anzeigen Berichterstattung",
    "adsDatePicker": "Datumsauswahl für Anzeigen",
    "feedbackSubmitBtn": "Feedback senden-Schaltfläche",
    "ifYouThinkMistakePleaseContact": "Wenn Sie der Meinung sind, dass dies ein Fehler ist, wenden Sie sich bitte an uns",
    "forResolution": "zur Auflösung.",
    "live": "Live",
    "payouts": "Auszahlungen",
    "greatChoice": "Großartige Wahl!",
    "toNavigate": "navigieren",
    "teams": "Teams",
    "role": "Rolle",
    "searchAccounts": "Suchen Sie nach Konten",
    "searchByNameEmailPhone": "Suche nach Namen, E-Mail oder Telefon",
    "addEmployee": "Mitarbeiter hinzufügen.",
    "removeFromLocation": "Aus dem Standort entfernen",
    "knowMore": "Mehr erfahren",
    "usingNumberPool": "Verwendung des Number Pools",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Rezensent",
    "cancel1": "Stornieren",
    "delete1": "Löschen",
    "call1": "Anruf",
    "message1": "Nachricht",
    "name1": "Name",
    "voicemail1": "Voicemail",
    "title1": "Titel",
    "choose_one": "Wählen Sie eine Option",
    "select_page": "Seite auswählen",
    "confirm1": "Bestätigen",
    "conversations1": "Konversationen",
    "copied1": "Kopiert",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Zurück",
    "details1": "Details",
    "month1": "/Monat",
    "select1": "Auswählen",
    "share1": "teilen",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Blacklist-Monitor-Berichte",
      "domainPurchase": "Domain-Kauf"
    },
    "confirmDelete": "Sind Sie sicher, dass Sie {name} löschen möchten?",
    "clicked1": "Geklickt",
    "delivered1": "Zugestellt",
    "invalid1": "Ungültig",
    "open_options": "Optionen öffnen",
    "_add_account": "Konto hinzufügen",
    "setTimezoneWarning": "Bitte stellen Sie die Zeitzone für Ihren Standort ein, um die richtigen freien Zeitfenster zu sammeln.",
    "save1": "Speichern",
    "action1": "Aktion",
    "actions1": "Aktivitäten",
    "all1": "jeder",
    "previous1": "Vorherige",
    "results1": "Ergebnisse",
    "next1": "Weiter",
    "payments1": "Zahlungen",
    "settings1": "Einstellungen",
    "total_js_heap": "Gesamter JS-Heap",
    "table": {
      "pagination": {
        "previous": "Zurück",
        "next": "Weiter"
      },
      "rowsSelected": "{count} Zeilen ausgewählt",
      "cantRearrange": "{type} kann nicht neu angeordnet werden."
    },
    "ivrCall": "IVR-Anruf",
    "sms": "SMS",
    "username": "Benutzername",
    "stay": "Bleiben",
    "placeholders": {
      "selectCountry": "Wählen Sie Ihr Land aus",
      "nameOfBusiness": "Name des Unternehmens",
      "line1": "Zeile 1",
      "line2": "Adresszeile 2",
      "enterState": "Bundesland eingeben",
      "enterCity": "Stadt eingeben",
      "enterPostalCode": "Postleitzahl eingeben",
      "chooseCountry": "Wählen Sie ein Land aus..."
    },
    "addressLine1": "Anschrift Zeile 1",
    "addressLine2": "Adresszeile 2",
    "postalCode": "Postleitzahl",
    "nameOfBusiness": "Name des Unternehmens",
    "dispute_this_review": "Diese Bewertung erörtern",
    "story_mention": "Story-Erwähnung",
    "story_reply": "Story-Antwort",
    "no": "Nein",
    "yes": "Ja",
    "annual": "jährlich",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Etwas ist schiefgelaufen"
    },
    "zero": "0",
    "perMonth": "pro Monat",
    "emailCheckLinks": "Bitte überprüfen Sie die Links, bei denen Sie einen benutzerdefinierten Wert haben. Zwischen dem {{ und dem custom_values gibt es ein zusätzliches \"%20\".",
    "fileSizeTooLarge": "Die Dateigröße beträgt mehr als 5 MB",
    "fileSizeTooLargeDescription": "Das Dokument, das Sie hochladen möchten, ist zu groß. Bitte versuchen Sie es mit einer kleineren Datei.",
    "minMaxLength40Characters2048Characters": "Mindestlänge: 40 Zeichen. Höchstlänge: 2048 Zeichen.",
    "sampleMessage2": "Beispielnachricht #2*",
    "pleaseSelectWorkflow": "Bitte wählen Sie einen Arbeitsablauf aus",
    "childrens": "Kinder",
    "brandAndCampaignRegistration": "Für die Registrierung von Marken und Kampagnen wird eine einmalige Gebühr von 20,95 $ erhoben. Eine zusätzliche Kampagnengebühr von bis zu 2,25 $ pro Monat wird gemäß den TCR-Regeln erhoben.",
    "einRequiredForRegistration": "EIN erforderlich für die Registrierung",
    "changed_props": "Geänderte Eigenschaften",
    "total_memory": "Gesamtspeicher",
    "total_store_size": "Gesamtgröße des Geschäfts",
    "total_watchers": "Total Watchers",
    "update_count": "Anzahl aktualisieren"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Massenaktionen",
      "clickHere": "Klicken Sie hier, um die Liste der Massedatenaktivitäten anzuzeigen.",
      "mergedMessage": "Diese Seite wurde mit der Massedaten Aktivitäten Liste zusammengeführt.",
      "title": "Kontaktanfragen"
    }
  },
  "conversations": {
    "noConversationsFound": "Keine {status} Konversationen gefunden",
    "create_new": "Neue Nachricht erstellen​",
    "validations": {
      "minCharsRequired": "Mindestens 3 Zeichen erforderlich",
      "twoMoreCharsRequired": "2 weitere Zeichen sind erforderlich",
      "oneMoreCharRequired": "1 weiteres Zeichen erforderlich"
    },
    "sortLabels": {
      "latestAllMessages": "Neueste – Alle Nachrichten",
      "oldestAllMessages": "Älteste – Alle Nachrichten",
      "latestManualMessages": "Neueste – Manuelle Nachrichten",
      "oldestManualMessages": "Älteste – Manuelle Nachrichten",
      "latestAll": "Neueste – Alle",
      "oldestAll": "Älteste – Alle",
      "latestManual": "Neueste – Manuell",
      "oldestManual": "Älteste – Manuell",
      "highToLow": "{name} (absteigend)",
      "manualMessagesTooltip": "Die Sortieroption gilt für Nachrichten nach dem 18. Mai 2023."
    },
    "deleteConversation": {
      "title": "Bestätigung",
      "confirmWithName": "Möchten Sie die Konversation mit {name} wirklich endgültig löschen? Das lässt sich nicht rückgängig machen.",
      "confirmWithoutName": "Möchten Sie diese Konversation wirklich für immer löschen? Das lässt sich nicht rückgängig machen."
    },
    "makeCall": {
      "enterPhoneNumber": "Um einen Anruf zu tätigen, geben Sie bitte eine Rufnummer in diesem Feld ein.",
      "invalidPhoneNumber": "Twilio Lookup hat diese Rufnummer als ungültig markiert."
    },
    "actions": {
      "markAsStarred": "Mit Sternchen markieren",
      "unarchive": "Entarchivieren",
      "unmarkAsStarred": "Sternchen entfernen"
    },
    "send": {
      "perMonthPerIp": "/Monat/IP",
      "perIp": "/ IP",
      "replyingTo": "Antworten auf",
      "requestClientsPaymentDetails": "Zahlungsdetails des Kunden anfordern",
      "saasModeCreditCardRequired": "Im SaaS-Modus ist es erforderlich, dass eine Kreditkarte des Kunden hinterlegt wird.",
      "please": "Bitte",
      "firstBeforeEnablingSaaS": "zuerst, bevor Sie den SaaS-Modus aktivieren.",
      "shareALink": "Teilen Sie einen Link",
      "shareLinkInstructions": "Teilen Sie einen Link mit Ihrem Kunden, um seine Zahlungsdetails zu erfassen",
      "requestViaEmail": "Anfrage per E-Mail",
      "twilioRebillingDescription": "Stellen Sie Ihren Kunden die Twilio-Kosten ({twilioCopy}) in Rechnung und fügen Sie einen Aufschlag hinzu",
      "seeHow": "So geht's",
      "phoneRebillingCardInfoRequired": "Für die Telefon-Neuabrechnung müssen die Kartendaten des Kunden hinterlegt sein.",
      "clientsCompanyBillingPage": "Abrechnungsseite des Kundenunternehmens",
      "ifYouPayForTwilioKeepUsing": "Wenn Sie für Twilio bezahlen, verwenden Sie weiterhin dasselbe Twilio-Konto",
      "ifClientPaysForTwilioCreateNew": "Wenn der Kunde für Twilio bezahlt, erstellen Sie ein neues Twilio-Konto",
      "learnHow": "Erfahren Sie, wie",
      "createNewTwilioAccountInstructions": "Erstellen Sie ein neues Twilio-Konto für diesen Standort",
      "learnHowToMovePhoneNumbers": "Erfahren Sie, wie Sie Telefonnummern übertragen",
      "thisIsMyClientsTwilioCreateNew": "Dies ist das Twilio-Konto meines Kunden. Neues Konto erstellen",
      "featureUnderDevelopment": "Diese Funktion befindet sich in der Entwicklung",
      "emailRebillingDescription": "Stellen Sie Ihren Kunden die E-Mail-Kosten in Rechnung und fügen Sie einen Aufschlag hinzu",
      "emailRebillingCardInfoRequired": "Für die E-Mail-Neuabrechnung müssen die Kartendaten des Kunden hinterlegt sein.",
      "emailRebillingMarginsDescription": "Dies sind Aufschläge, die Ihren Kunden in Rechnung gestellt werden, zusätzlich zu den E-Mail-Kosten,",
      "provider": "Anbieter",
      "morePlanCustomizationsAvailable": "Mehr Plananpassungen verfügbar",
      "plansAndPricing": "Pläne und Preise",
      "connectYourStripeAccountFirst": "Verbinden Sie zuerst Ihr Stripe-Konto",
      "createRecommendedPlansOnStripe": "Erstellen Sie empfohlene Pläne auf Stripe",
      "createdPlanInStripe": "Plan in Stripe erstellt",
      "customizeYourSaasPlans": "Passen Sie Ihre SaaS-Pläne an",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "Sie können empfohlene Pläne anbieten oder Ihre eigenen erstellen",
      "trialPeriod": "Testphase",
      "enterNumberOfDaysForTrial": "Geben Sie die Anzahl der Tage für den Testzeitraum ein",
      "nameCantBeEmpty": "Der Name darf nicht leer sein",
      "showStripeProductDetails": "Produktdetails von Stripe zeigen",
      "addEmail": "E-Mail hinzufügen",
      "resetMountCounts": "Anzahl der Montagen zurücksetzen",
      "connectReconnectGoogleForGbp": "Verbinden oder verbinden Sie Google erneut für GBP",
      "downloadFile": "Datei herunterladen",
      "showOnlySlowQueries": "Nur langsame Abfragen anzeigen",
      "gmbMessagingAvailable": "GMB-Messaging ist jetzt verfügbar",
      "reconnectGbpPageToEnable": "Verbinden Sie Ihre GBP-Seite erneut, um Nachrichten zu aktivieren.",
      "failedPaymentsCheckBilling": "Fehlgeschlagene Zahlungen erkannt. Bitte überprüfen Sie Ihre Abrechnung.",
      "onlyAgencyAdminsCanSeeWarning": "Nur Agenturadministratoren können diese Warnung sehen.",
      "filter": "Filter",
      "stopDeleteOperation": "Löschvorgang stoppen",
      "summary": "Zusammenfassung",
      "enableTracking": "Tracking aktivieren",
      "exportAll": "Alles exportieren",
      "newConversationStarted": "Neue Konversation gestartet",
      "startNewConversation": "Neuen Chat starten",
      "subAccountScheduledForDeletion": "Unterkonto zur Löschung vorgesehen",
      "deleteSubAccountOnScheduledTime": "Unterkonto zum geplanten Zeitpunkt löschen",
      "componentUpdatesDebuggerAlpha": "Component Updates Debugger (Alpha)",
      "componentUpdateTrackingDisabled": "Die Nachverfolgung von Komponentenaktualisierungen ist deaktiviert.",
      "deleteSubAccount": "Unterkonto löschen",
      "subAccountHasNumbersAndCampaigns": "Dieses Unterkonto hat {phoneNumberCount} Telefonnummer(n) und {campaignsCount} Kampagne(n).",
      "subAccountNoNumbersOrCampaigns": "Dieses Unterkonto hat keine Rufnummern oder Kampagnen.",
      "areYouSureDeleteSubAccount": "Möchten Sie dieses Unterkonto wirklich löschen?",
      "confirmDiscussedWithClient": "Ich bestätige, dass ich dies mit meinem Kunden besprochen habe.",
      "understandActionIrreversible": "Ich verstehe, dass diese Aktion nicht rückgängig gemacht werden kann",
      "confirmDisconnectCloseLcPhone": "Ich bestätige, dass ich das LC Phone-Konto trennen und schließen möchte.",
      "choosingNotDeleteLcPhoneWarning": "Warnung: Wenn Sie sich entscheiden, das LC Phone-Konto nicht zu löschen, werden Ihnen weiterhin Gebühren für die mit diesem Unterkonto verknüpften Telefonnummern berechnet.",
      "deleteAccount": "Konto löschen",
      "send": "Senden",
      "typeMessage": "Nachricht eingeben",
      "requestPayment": "Zahlung anfordern",
      "reply": "Antwort",
      "retry": "Wiederholen",
      "analyzeMemory": "Speicher analysieren",
      "memoryAnalysisApproximate": "🚧 Die Speicheranalyse ist nur annähernd und nicht zu 100 % genau.",
      "subAccountScheduledForDeletionItWillBeDeleted": "Dieses Unterkonto wurde zur Löschung angesetzt. Es wird gelöscht von",
      "youCanChangeYourMindBeforeThisTime": "Sie können Ihre Meinung vor diesem Zeitpunkt ändern.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Überspringen",
          "cannotIdentifyContact": "Der Kontakt und sein Standort konnten nicht identifiziert werden.",
          "contactNotSelected": "Der Kontakt ist nicht ausgewählt.",
          "messageRequired": "Stellen Sie sicher, dass Sie eine Nachricht oder eine ausgewählte Vorlage eingegeben haben.",
          "noPhoneNumber": "Der Kontakt hat keine Rufnummer.",
          "genericError": "{message}",
          "stayPrompt": "Warten"
        },
        "scheduledSuccess": "E-Mail erfolgreich geplant",
        "confirmDelete": "Sind Sie sicher, dass Sie {name} löschen möchten?"
      },
      "clear": "Löschen",
      "edit": "Bearbeiten",
      "sendNow": "Jetzt senden",
      "schedule": "Planen",
      "useTemplate": "Vorlage verwenden (Short-Video)",
      "mergeFields": "Felder zusammenführen",
      "customVariablesError": "Es gibt Probleme in Ihren benutzerdefinierten Variablen. Bitte beheben Sie diese, bevor Sie senden.",
      "sendLater": "Später senden",
      "scheduledFor": "Geplant für {date}",
      "call": "Anruf",
      "leftVoicemail": "Hat eine Voicemail hinterlassen",
      "pleaseSelectCampaign": "Bitte wählen Sie eine Kampagne aus",
      "whatsapp": {
        "no24HourMessage": "Sie können Vorlagennachrichten nur außerhalb des 24-Stunden-Fensters senden. Bitte wählen Sie eine Vorlage zum Senden aus."
      },
      "attachFile": "Datei anhängen",
      "email": {
        "fromEmail": "Von E-Mail-Adresse",
        "fromName": "Von Name",
        "smtpWarning": "SMTP-Anbieter hat einige Einschränkungen. Klicken Sie hier, um mehr zu erfahren.",
        "subject": "Betreff",
        "errors": {
          "cannotIdentifyContact": "Der Kontakt und sein Standort konnten nicht identifiziert werden.",
          "contactNotSelected": "Der Kontakt ist nicht ausgewählt.",
          "genericError": "{message}",
          "bodyRequired": "Die E-Mail muss einen Textkörper enthalten.",
          "noEmailAddress": "Der Kontakt verfügt über keine E-Mail-Adresse."
        },
        "scheduledSuccess": "Email erfolgreich geplant"
      },
      "addCalendarToSchedule": "Sie müssen einen Kalender hinzufügen, um mit der Planung von Terminen zu beginnen.",
      "slotRequired": "Zeitfenster erforderlich",
      "teamMemberRequired": "Teammitglied ist erforderlich."
    },
    "added": "hinzugefügt",
    "loadMore": "Weitere laden",
    "admin": "Admin",
    "aiEmployee": {
      "popupBlockedAlert": "Pop-ups sind deaktiviert. Bitte aktivieren Sie Pop-ups für diese Website, um automatisch zum Zoom-Meeting weitergeleitet zu werden. Klicken Sie auf „Jetzt beitreten“, um direkt zum Zoom-Meeting weitergeleitet zu werden."
    },
    "alsoCloseAssociatedSubAccount": "Auch verknüpftes",
    "analyzeMemory": "Speicher analysieren",
    "announcements": "Ankündigungen",
    "apply": "Anwenden",
    "appointment": {
      "pickDay": "Tag auswählen",
      "pickSlot": "Zeitfenster für Termin auswählen",
      "selectDate": "Tag auswählen",
      "selectSlot": "Zeitfenster auswählen",
      "slot": "Zeitfenster",
      "day": "Tag"
    },
    "areYouReallySureDeleteSubAccount": "Sind Sie wirklich sicher, dass Sie dieses Unterkonto löschen möchten?",
    "areYouSureDeleteSubAccount": "Möchten Sie dieses Unterkonto wirklich löschen?",
    "assignedContactOwner": "Zugewiesen ({contact} Eigentümer)",
    "assignedToMe": "Mir zugewiesen",
    "audio": {
      "browserNotSupported": "Ihr Browser unterstützt das Audio-Element nicht.",
      "loadingTranscription": "Transkription wird geladen …",
      "viewTranscript": "Transkript anzeigen",
      "stop": "Stopp",
      "playPause": "Wiedergabe/Pause",
      "timePlayed": "Spielzeit: Gesamt",
      "mute": "Stummschaltung",
      "playbackSpeed": "Wiedergabegeschwindigkeit",
      "download": "Herunterladen",
      "remove": "Entfernen"
    },
    "automated": "Automatisiert",
    "avatar": {
      "aiGenerated": "Diese Nachricht wurde via Conversation AI generiert",
      "messengerAutomation": "Messenger-Automatisierung",
      "workflowGenerated": "Diese Nachricht wurde via Conversation AI Arbeitsablauf Aktion generiert",
      "messageByAI": "Diese Nachricht wurde via Conversation AI generiert",
      "messageByWorkflow": "Diese Nachricht wurde via Conversation AI Arbeitsablauf Aktion generiert",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Werden Sie Teil der am schnellsten wachsenden Community.",
    "callHighlevelAt": "Rufen Sie HighLevel unter +1(888)732-4197 an",
    "callQueueTooltip": "Dieser Anruf befindet sich in der Anrufwarteschlange des Benutzers und wartet darauf, ausgelöst zu werden.",
    "callTranscript": "Anrufprotokoll",
    "clearFilters": "Filter zurücksetzen",
    "clientsCompanyBillingPage": "Abrechnungsseite des Kundenunternehmens",
    "closeChat": "Chat schließen",
    "closeConversation": "Chat schließen",
    "component": {
      "dismissMessage": "DIESE NACHRICHT VERWERFEN",
      "unblock": "Entsperren",
      "inboundDndActive": "Eingehendes DND wurde für diesen Kontakt aktiviert",
      "fetchOlderMessages": "Ältere Nachrichten abrufen",
      "conversationBegan": "Chat hat begonnen",
      "celebrationTitle": "Juhu! Die Chats laufen jetzt",
      "celebrationBody": "Das ist erst der Anfang. Lassen Sie uns gemeinsam herausfinden, wie GHL Ihnen beim Aufbau Ihres Unternehmens helfen kann.<br />In der Zwischenzeit können Sie nach Herzenslust weiterhin Nachrichten versenden"
    },
    "componentUpdateTrackingDisabled": "Die Nachverfolgung von Komponentenaktualisierungen ist derzeit deaktiviert",
    "componentUpdatesDebuggerAlpha": "🚧 Komponenten-Updates-Debugger (Alpha) - In Arbeit",
    "confirmDelete": "Chat(s) löschen?",
    "confirmDeleteTextLine11": "Sind Sie sicher, dass Sie diesen Chat löschen möchten? Diese Aktion ist unwiderruflich.",
    "confirmDeleteTextLine12": "Chats ausgewählt",
    "confirmDeleteTextLine21": "Diese Aktion ist unwiderruflich. Möchten Sie trotzdem fortfahren?",
    "confirmDisconnectedAllIntegrations": "Ich bestätige, dass ich alle Integrationen (wie Twilio, Mailgun, GMB, Domains, Facebook, Zoom usw.) davon getrennt habe",
    "confirmStoppedAllAutomations": "Ich bestätige, dass ich alle Automatisierungen in diesem Unterkonto gestoppt habe",
    "connectReconnectGoogleForGbp": "Verbinden Sie Ihr Google-Konto (erneut), um GBP-Nachrichten zu erhalten!",
    "connectWithCertifiedAdmin": "Verbinden Sie sich mit einem zertifizierten Administrator",
    "connectWithTeamForHelp": "Kontaktieren Sie unser Team für Unterstützung per Live-Videoanruf!",
    "connectWithUs": "Nehmen Sie Kontakt mit uns auf",
    "connectZoomAccount": "Zoom-Konto verbinden",
    "contactEngagementScore": "{contact} Engagement-Score",
    "dailyBrainstormingSessions": "Tägliche Brainstorming-Sitzungen mit HighLevel",
    "deleteAccount": "Konto löschen",
    "deleteSubAccountOnScheduledTime": "Unterkonto zum geplanten Zeitpunkt löschen",
    "disableSaasMode": "SaaS-Modus deaktivieren",
    "dnd": {
      "configure": "KONFIGURATION",
      "status": {
        "on": "AKTIVIERT",
        "partial": "Unvollständig"
      }
    },
    "editAppointment": {
      "updateButton": "Termin aktualisieren",
      "scheduleAppointment": "Termin vereinbaren",
      "editAppointment": "Termin bearbeiten",
      "calendar": "Kalender",
      "selectCalendar": "Kalender auswählen",
      "roundRobin": "Round Robin",
      "pickTeamMember": "Teammitglied auswählen",
      "selectTeamMember": "Teammitglied auswählen",
      "teamMemberRequired": "Teammitglied ist erforderlich.",
      "slotRequired": "Zeitfenster erforderlich",
      "appointmentTitle": "Titel des Termins",
      "appointmentTitleTooltip": "Lassen Sie das Feld leer, wenn Sie den vorkonfigurierten Titel des Termins verwenden möchten",
      "contactName": "Kontaktname",
      "name": "Name",
      "nameRequired": "Name erforderlich",
      "emailAddress": "E-Mail-Adresse",
      "phoneNumber": "Rufnummer",
      "phoneNumbers": "Rufnummer",
      "dateOfBirth": "Geburtsdatum",
      "contactTimezone": "Kontaktzeitzone (für Erinnerungen verwendet)",
      "chooseOne": "Wählen Sie eine aus …",
      "meetingLocation": "Besprechungsort",
      "meetingLocationTooltip": "Lassen Sie das Feld leer, wenn Sie den vorkonfigurierten Besprechungsort verwenden möchten",
      "status": "Status",
      "appointmentStatus": "Terminstatus",
      "additionalNotes": "Zusätzliche Hinweise",
      "notes": "Notizen",
      "actionRequired": "Aktion erforderlich",
      "confirmed": "Bestätigt",
      "invalid": "Ungültig",
      "cancelled": "Abgebrochen",
      "showed": "Erschienen",
      "noShow": "Nichterscheinen",
      "busy": "Beschäftigt",
      "free": "Kostenlos",
      "noCalendarMessage": "Sie müssen einen Kalender hinzufügen, um mit der Planung von Terminen zu beginnen."
    },
    "email": {
      "errors": {
        "bodyRequired": "Die E-Mail muss einen Textkörper enthalten; sonst kann sie nicht gesendet werden.",
        "cannotIdentifyContact": "Der Kontakt und sein Standort können nicht identifiziert werden.",
        "contactNotSelected": "Der Kontakt ist nicht ausgewählt.",
        "noEmailAddress": "Der Kontakt verfügt über keine E-Mail-Adresse."
      },
      "thread": {
        "failedToFetch": "E-Mail-Inhalt konnte nicht abgerufen werden",
        "forward": "Weiterleiten"
      },
      "reply": "Antworten",
      "share": "Teilen",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Konto hinzufügen",
      "respond": "Antworten",
      "retry": "Wiederholen",
      "moreEmailsInThread": "{count} mehr E-Mails im Thread",
      "fromName": "Von Name",
      "fromEmail": "Von E-Mail",
      "subject": "Betreff",
      "attachFile": "Datei anhängen",
      "useTemplate": "Vorlage verwenden (Short-Video)",
      "requestPayment": "Zahlung anfordern",
      "clear": "Löschen",
      "sendNow": "Jetzt senden",
      "schedule": "Zeitplan",
      "send": "Senden",
      "smtpWarning": "SMTP-Anbieter hat einige Einschränkungen. Klicken Sie hier, um mehr zu erfahren.",
      "chooseOne": "Wählen Sie eine aus …",
      "deliveredCount": "{delivered}/{total} gesendet",
      "typeMessage": "Nachricht eingeben",
      "sendLater": "Später senden",
      "scheduledFor": "Geplant für {date}"
    },
    "emailRebillingCardInfoRequired": "Um die E-Mail-Rechnungsstellung zu aktivieren, müssen Sie die Kartendaten Ihres Kunden eingeben auf der",
    "emailRebillingDescription": "So können Sie Ihren Kunden E-Mail-Kosten in Rechnung stellen und einen Aufschlag erheben.",
    "emailRebillingMarginsDescription": "Dies sind Aufschläge, die Ihren Kunden zusätzlich zu den von Ihnen getragenen E-Mail-Kosten in Rechnung gestellt werden",
    "enableTracking": "Tracking aktivieren",
    "exploreHighlevelExperts": "Entdecken Sie HighLevel-Experten, die Ihnen bei der Einrichtung Ihres Systems, der Automatisierung von Workflows oder der Anpassung Ihres Projekts helfen können.",
    "exportAll": "Alles exportieren",
    "facebook": {
      "errors": {
        "generalError": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder überprüfen Sie die Facebook-Integration. Fehlermeldung:",
        "noFacebookId": "Der Kontakt hat keine Facebook-ID."
      }
    },
    "failedPaymentsCheckBilling": "Sie haben eine oder mehrere fehlgeschlagene Zahlungen. Bitte überprüfen Sie Ihre Abrechnungshistorie.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Über",
      "aiActionLogs": "AI-Aktionsprotokolle",
      "inRange": "Im Umfang",
      "invoice": "Rechnung",
      "messageDirectionTooltip": "Der Filter gilt für Nachrichten nach dem 9. Mai 23",
      "appointments": "Termine"
    },
    "followed": "Gefolgt von",
    "followedByMe": "Gefolgt von mir",
    "followedBySpecificUser": "Gefolgt von einem bestimmten Benutzer",
    "follower": "Follower",
    "followerAssignmentContact": "Follower ({contact}-Zuweisung)",
    "gbp": {
      "errors": {
        "generalError": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder überprüfen Sie die Integration des Google Business-Profile. Fehlermeldung:",
        "noGBPId": "Der Kontakt hat keine GBP-Id."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile-Chat ist nicht mehr verfügbar",
    "getAccessToHighlevelWelcomeCourse": "Sie erhalten Zugriff auf den HighLevel-Willkommenskurs",
    "getPriorityTroubleshooting": "Sie erhalten Priorität für die Fehlerbehebung, professionelle Beratung und direkten Zugang zu unserer technischen Gruppe über Slack.",
    "gmbMessagingAvailable": "Google Business Messaging ist für Ihr Konto verfügbar.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Bewertung:",
      "replyDate": "Antwortdatum:",
      "replyFrom": "Antwort von:",
      "review": "Bewertung",
      "reviewDate": "Bewertungsdatum:",
      "reviewFrom": "Bewertung von:"
    },
    "highlevelEvents": "HighLevel Events",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Diese Signatur vor dem zitierten Text in Antworten einfügen",
    "instagram": {
      "errors": {
        "generalError": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder überprüfen Sie die Instagram-Integration. Fehlermeldung:",
        "noInstagramId": "Der Kontakt hat keine Instagram-Id."
      }
    },
    "joinOurFacebookGroup": "Treten Sie unserer Facebook-Gruppe bei",
    "keepUpToDateWithLatestNews": "Bleiben Sie über alle Neuigkeiten und Veröffentlichungen auf dem Laufenden!",
    "lastMessageChannel": "Letzter Nachrichtenkanal",
    "lastMessageDirection": "Letzte Nachricht Richtung",
    "lastOutboundMessageType": "Letzter ausgehender Nachrichtentyp",
    "learnHow": "Erfahren Sie, wie.",
    "leftComment": "hat einen Kommentar hinterlassen",
    "leftPanel": {
      "recents": "Neueste",
      "unread": "Ungelesen",
      "createNewMessage": "Neue Nachricht erstellen",
      "minCharsRequired": "Mindestens 3 Zeichen erforderlich",
      "twoMoreCharsRequired": "2 weitere Zeichen sind erforderlich",
      "oneMoreCharRequired": "Es wird noch 1 Zeichen benötigt"
    },
    "liveChat": {
      "endLiveChat": "Live-Chat beenden",
      "errors": {
        "generalError": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder überprüfen Sie die Integration von Google My Business. Fehlermeldung:"
      },
      "requestContact": "Kontakt anfordern"
    },
    "live_chat_message": "Live-Chat-Nachricht",
    "made": ", die vorgenommen wurden",
    "memoryAnalysisApproximate": "🚧 Die Speicheranalyse ist nur annähernd und nicht zu 100 % genau.",
    "mentioned": "Erwähnt gegenüber",
    "mentions": "Erwähnungen",
    "mentionsOfMe": "Erwähnungen von mir",
    "mentionsOfSpecificUser": "Erwähnungen von bestimmten Benutzern",
    "message": {
      "replyAll": "Allen antworten",
      "details": "Details",
      "reply": "Antworten",
      "unsuccessful": "Fehlgeschlagen",
      "pending": "Anhängig",
      "inboundCall": "Eingehender Anruf",
      "outboundCall": "Ausgehender Anruf",
      "ivrCall": "IVR-Anruf",
      "leftVoicemail": "Hat eine Voicemail hinterlassen",
      "storyReply": "Story-Antwort",
      "storyMention": "Story-Erwähnung",
      "replyAsDM": "Mit DM antworten",
      "newCommentOnPost": "Neuer Kommentar zu {pageName}s Beitrag.",
      "goToPost": "Zum Post gehen",
      "replyNotAvailable": "Das Antworten mit privater DM ist für Feedback, das älter als 7 Tage ist, nicht möglich.",
      "addToDocuments": "Zu Dateien hinzufügen",
      "attachmentsAddedSuccess": "Anhänge erfolgreich zu Dateien hinzugefügt",
      "attachmentsAddedFailed": "Fehler beim Hinzufügen von Anhängen zu Dateien",
      "reportFeedbackForAI": "Feedback für AI melden",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Möchten Sie diesen Zeitplan wirklich abbrechen?",
      "cancelScheduledMessage": "Geplante Nachricht abbrechen?",
      "cancelSend": "Senden abbrechen",
      "cancelScheduledSuccess": "Geplante Nachricht wurde erfolgreich abgebrochen",
      "cancelScheduledError": "Beim Abbrechen der geplanten Nachricht ist ein Fehler aufgetreten.",
      "cc": "CC",
      "channel": "Kanal",
      "createdBy": "Erstellt von",
      "direction": "Richtung",
      "emailCampaign": "E-Mail-Kampagne",
      "facebookMessage": "Facebook-Nachricht",
      "instagramMessage": "Instagram-Nachricht",
      "messageId": "Nachrichten-ID",
      "messageIdLabel": "Nachrichten-ID: ",
      "trigger": "Auslöser",
      "unanswered": "Unbeantwortet",
      "yes": "Ja",
      "messageDetails": "Nachrichten-Info",
      "from": "Von",
      "fromLabel": "Von:",
      "to": "An",
      "toLabel": "An:",
      "unknown": "Unbekannt",
      "unknownFrom": "Unbekannt von",
      "unknownTo": "Unbekannt an",
      "unknownDirection": "Unbekannte Richtung",
      "dateUnknown": "Unbekanntes Datum",
      "emailFromUnknown": "E-Mail von unbekanntem Absender",
      "smsFromUnknown": "SMS von Unbekannt",
      "callFromUnknown": "Anruf von Unbekannt",
      "voicemailFromUnknown": "Voicemail von Unbekannt",
      "emailToUnknown": "E-Mail an Unbekannt",
      "smsToUnknown": "SMS an Unbekannten",
      "callToUnknown": "Anruf an Unbekannt",
      "voicemailToUnknown": "Voicemail an Unbekannt",
      "failed": "Fehlgeschlagen",
      "datetime": "Tag und Uhrzeit",
      "manual": "Manuell",
      "automation": "Automatisierung",
      "workflow": "Arbeitsablauf",
      "campaign": "Kampagne",
      "bulkRequest": "Massedatenanfrage",
      "delivered": "Zugestellt",
      "bounced": "Unzustellbar",
      "opened": "Geöffnet",
      "sent": "Gesendet",
      "scheduled": "Geplant",
      "pageName": "Seitenname",
      "gbpMessage": "GBP-Nachricht",
      "no": "Nein",
      "eventsTrackedForContactOnly": "Veranstaltungen werden derzeit nur für die E-Mail-Adresse des Kontakts erfasst.",
      "completed": "Abgeschlossen",
      "voicemail": "Voicemail",
      "busy": "Beschäftigt",
      "pending": "Anhängig",
      "read": "Lesen",
      "nativeIntegrations": "Native Integrationen",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "E-Mail",
      "sms": "SMS",
      "phoneCall": "Telefonanruf",
      "voiceMail": "Voicemail",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Bewertungen",
      "others": "Andere",
      "partialDetailsWarning": "Für Nachrichten vor dem 15. Juli 2022 sind unvollständige Details verfügbar.",
      "agencySystem": "Agentursystem",
      "reply": "Antworten"
    },
    "multiplePhone": {
      "chooseNumber": "Wählen Sie eine Nummer, um den Chat zu beginnen:",
      "continue": "Weiter",
      "noPhones": "Keine Rufnummern verfügbar"
    },
    "myChat": "Mein Chat",
    "myInbox": "Mein Posteingang",
    "newConversationStarted": "Neue Konversation gestartet",
    "newMessage": {
      "title": "Neue Nachricht:",
      "errors": {
        "phoneRequired": "Rufnummer ist erforderlich"
      }
    },
    "noConversationSelected": "Kein Chat ausgewählt",
    "noResultsToShow": "Keine Ergebnisse anzuzeigen",
    "onboardingVideoTutorials": "Onboarding-Video-Tutorials",
    "onlyAgencyAdminsCanSeeWarning": "Nur Agenturadministratoren können diese Warnung sehen. Weitere Informationen",
    "onlyVisibleToUsers": "Nur für Benutzer sichtbar",
    "perMonthPerIp": "/Monat/IP",
    "phone": {
      "call": "{name} anrufen",
      "callingOptions": "{count} Anrufoptionen",
      "phoneNumbers": "Telefonnummern",
      "callOptions": "{count} Anrufoptionen",
      "dndActive": "DND ist für Anrufe aktiv",
      "primary": "Primär"
    },
    "pleaseDisableSaasMode": "Bitte deaktivieren Sie den SaaS-Modus für dieses Unterkonto",
    "pleaseSelectCampaign": "Bitte wählen Sie eine Kampagne aus",
    "premiumSupport": "Premium-Support",
    "quickFilters": "Schnell-Filter",
    "reconnectGbpPageToEnable": "Stellen Sie die Verbindung zu Ihrer GBP-Seite wieder her, um die Funktion zu aktivieren.",
    "replyAsDMTooltip": "Antworten Sie auf diesen Kommentar mit privater DM.",
    "replyingTo": "Antwort auf",
    "resetMountCounts": "Reset Mount Counts",
    "review": {
      "errors": {
        "generalError": "Es ist ein Fehler aufgetreten. Fehlermeldung:",
        "googleIntegrationError": "Es ist nicht möglich, auf diese Bewertung zu antworten. Es scheint, dass bei Ihrer Google-Integration ein Fehler aufgetreten ist. Bitte verbinden Sie erneut in Konfig -> Integrationen.",
        "noReviewId": "Die Konversation hat keine Bewertungs-ID."
      },
      "reviewPostTo": "Beitrag an {network} überprüfen",
      "sharedOn": "Bewertung geteilt an {network}",
      "disputeReview": "Diese Bewertung erörtern",
      "learnHow": "(Erfahren Sie, wie?)",
      "seeOnGBP": "Diese Bewertung zu GBP ansehen",
      "alreadyShared": "Diese Bewertung wurde bereits auf {network} veröffentlicht. Sind Sie sicher, dass Sie ihn erneut veröffentlichen möchten?"
    },
    "reviewId": "Bewertungs-ID",
    "schedule": {
      "sendSchedule": "Zeitplan senden",
      "timezone": "Zeitzone ({heading})",
      "title": "Planen Sie Ihren {type}"
    },
    "scheduling": "Planung wird vorgenommen …",
    "seeHow": "So geht's",
    "selectFilter": "Filter auswählen",
    "selected": "ausgewählt",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Betreff:",
      "subjectPlaceholder": "Betreff der E-Mail",
      "to": "An:",
      "sending": "Wird gesendet …",
      "sendButton": "E-Mail senden"
    },
    "setupAccountWithFreeTutorials": "Richten Sie Ihr Konto mit kostenlosen Tutorials ein",
    "showOnlySlowQueries": "Nur langsame Abfragen anzeigen (>{threshold}ms)",
    "sms": {
      "confirmSending": "Senden der Nachricht bestätigen",
      "editModal": {
        "compose": "SMS verfassen"
      },
      "errors": {
        "customVariablesIssue": "Es gibt Probleme in Ihren benutzerdefinierten Variablen. Bitte beheben Sie diese, bevor Sie senden.",
        "messageOrTemplateRequired": "Stellen Sie sicher, dass Sie eine Nachricht oder eine ausgewählte Vorlage eingegeben haben.",
        "noPhoneNumber": "Der Kontakt hat keine Rufnummer."
      },
      "scheduledSuccessfully": "SMS erfolgreich geplant",
      "sendAnyway": "Trotzdem senden",
      "spamWarning": "Ihr SMS-Inhalt kann Verweise auf Cannabis, SHAFT, Vape oder andere verbotene Themen enthalten. Das Versenden solcher Inhalte per SMS ist strengstens untersagt und kann zu Kontoeinschränkungen führen. Bitte überprüfen Sie Ihren Inhalt sorgfältig, bevor Sie fortfahren.",
      "send": "Senden"
    },
    "startNewConversation": "Neuen Chat starten",
    "subAccountAndDeleteAllPhoneNumbers": "Unterkonto schließen und alle Rufnummern löschen",
    "subAccountScheduledForDeletion": "Dieses Unterkonto ist zur Löschung vorgesehen",
    "subAccountScheduledForDeletionItWillBeDeleted": "Dieses Unterkonto wurde zur Löschung angesetzt. Es wird gelöscht am",
    "teamInbox": "Gruppen-Posteingang",
    "threshold": "Schwellenwert",
    "understandActionIrreversible": "Ich verstehe, dass diese Aktion unumkehrbar ist und alle Daten in diesem Unterkonto verloren gehen",
    "unstarred": "Nicht markiert",
    "use_a_template": "Vorlage verwenden",
    "userAvailability": "Benutzerverfügbarkeit",
    "userCalendarConfiguration": "Benutzerkalender-Konfiguration",
    "userInfo": "Benutzerinformationen",
    "userRoles": "Benutzerrollen",
    "viewSupportTickets": "Sehen Sie sich Ihre Support-Tickets, unsere Support-Artikel und hilfreiche FAQs an!",
    "visitOurHelpCenter": "Besuchen Sie unsere Hilfeseiten",
    "welcomeCourse": "Willkommenskurs",
    "whatsapp_logo": "WhatsApp-Logo",
    "youCanChangeYourMindBeforeThisTime": "Sie können Ihre Meinung vor diesem Zeitpunkt ändern.",
    "zoomAccount": "Zoom-Konto",
    "deleteEmails": "{count} E-Mail(s) löschen",
    "fileAttachment": {
      "urlNotFound": "Die URL kann nicht gefunden werden",
      "unsupportedAttachment": "Diese Anhänge werden möglicherweise nicht mehr unterstützt.",
      "downloadFile": "Dokument herunterladen"
    },
    "composer": {
      "internalComment": "Interner Kommentar"
    },
    "dropdown": {
      "openOptions": "Optionen öffnen",
      "messageDetails": "Nachrichten-Info"
    },
    "respond": "Antworten Sie",
    "selectTemplate": "Vorlage auswählen",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "Sie haben Pop-ups deaktiviert. Bitte aktivieren Sie Pop-ups für diesen Standort, um automatisch zu einem Zoom-Meeting weitergeleitet zu werden. Bitte Klicken Sie auf „jetzt beitreten“, um direkt zum Zoom-Meeting weitergeleitet zu werden.",
        "helpAndSupport": "Hilfe und Support",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Ablehnen",
      "body": "Das ist erst der Anfang. Lassen Sie uns gemeinsam herausfinden, wie GHL Ihnen beim Aufbau Ihres Unternehmens helfen kann.\nIn der Zwischenzeit können Sie nach Herzenslust weiterhin Nachrichten versenden",
      "title": "Juhu! Die Chats laufen jetzt"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "Hilfeartikel hier verweisen",
      "message": "Bitte aktivieren Sie Cookies von Drittanbietern, um diese Seite korrekt anzuzeigen. Sie können auf unsere",
      "ok": "OK",
      "title": "Drittanbieter-Cookies funktionieren nicht"
    }
  },
  "crash": {
    "message": "Es tut uns leid, aber es ist etwas Unerwartetes passiert. Bitte versuchen Sie, die Seite zu aktualisieren.",
    "refresh": "Seite aktualisieren",
    "title": "Hoppla! Etwas ist schiefgelaufen"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Abbruch der Löschung für {name}",
      "confirmAbort": "Ja, abbrechen",
      "keepDeleting": "Nein, weiterhin löschen",
      "message": "Sind Sie sicher, dass Sie den Vorgang abbrechen möchten?",
      "scheduledForDeletion": "Dieser Standort soll am {date} gelöscht werden",
      "title": "Löschen abbrechen",
      "warning": "Bitte beachten Sie: Der Standort wird am geplanten Datum gelöscht, es sei denn, Sie brechen das Löschen ab."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Dateien zum Hochladen hier ablegen",
      "uploadError": "Systemfehler: Konnte keine Anfrage an AWS senden. (Vielleicht ein CORS-fehlgeschlagen)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "{entityName}hinzufügen",
      "clonedMessage": "{entityName} Klon erstellt! Wechseln Sie zu einem Konto, in dem es geklont wurde, und suchen Sie es unter der Registerkarte {entityName}.",
      "errorGettingDetails": "Beim Abrufen der {entityName} -Details scheint Fehlgeschlagen aufgetreten zu sein. Bitte überprüfen Sie die URL oder versuchen Sie es erneut!",
      "permissionError": "Fehlgeschlagene Autorisierung: Dies ist ein geschützter Funnel und kann hier nicht erstellt werden."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleCalendar Logo"
    },
    "printful": {
      "logo": "Printful Logo",
      "title": "Printful: Druck An Anfrage"
    },
    "printify": {
      "logo": "Printify-Logo",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation Logo",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Shippo-Logo",
      "title": "Shippo: Versandintegration"
    },
    "tikTok": {
      "accountNotConnected": "Konto nicht verbunden",
      "accountNotConnectedMessage": "Ihr Konto ist nicht mit dem TikTok-Anzeigenkonto verbunden. Vollständige Integration, um Formulare anzuzeigen und Felder zuzuordnen.",
      "advertiserId": "Werbetreibender-ID",
      "companyFields": "{companyName} Felder",
      "editFields": "Felder bearbeiten",
      "errorSubscribing": "Fehlgeschlagen beim Abonnieren der Seite.",
      "formsNotAvailable": "Formulare sind nicht verfügbar",
      "mandatoryFieldsNote": "Hinweis: Ordnen Sie eines der folgenden Pflichtfelder zu, um erfolgreich Leads in Ihr Konto zu erhalten. Felder: Vorname, Nachname, Email, Rufnummer",
      "noFormsMessage": "Sie haben jetzt kein Ausschau halten-Formular in Ihrem TikTok-Anzeigenkonto erstellt. Besuchen Sie Ihr TikTok-Anzeigenkonto und erzeugen Sie eines, um loszulegen.",
      "pageId": "Seiten-ID",
      "selectAdvertiserAccount": "Klicken Sie das Konto des Werbetreibenden aus"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Sonstiges / Ich weiß es nicht",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "Mit einigen einfachen Schritten können Sie dieses Unterkonto pausieren"
    },
    "transfer": {
      "chooseDescription": "Ihre Übertragungsart wählen",
      "chooseMethod": "Dieses Unterkonto übertragen",
      "eject": {
        "description": "Erhalten Sie 40 % wiederkehrende Provision auf das Abonnement des neuen Kontos.",
        "title": "Als neues Konto entfernen"
      },
      "modal": {
        "confirmDetails": "Bitte Details vor der Übertragung speichern",
        "confirmNomineePrefix": "Inhaber benennen für",
        "confirmTransfer": "Übertragung bestätigen",
        "consentText": "Ich habe den obigen Leitfaden gelesen und verstanden und gebe allen Einschränkungen meine Genehmigung",
        "ejectErrorTitle": "Unterkonto kann nicht entfernt werden.",
        "ejectGenericError": "Das Unterkonto, das Sie entfernen möchten, kann nicht entfernt werden. Bitte kontaktieren Sie den Support.",
        "ejectGuidelines": "Richtlinien zum Entfernen von Unterkonten",
        "ejectSubject": "Das Entfernen eines Unterkontos setzt voraus, dass der Benutzer die Anfrage zur Erzeugung einer neuen Agentur akzeptiert.",
        "ejectSuccessTitle": "Anfrage zum Entfernen des Unterkontos an den ausgewählten Benutzer gesendet",
        "enterPassword": "Bitte zur Speicherung Ihr Passwort eingeben",
        "genericError": "Das Unterkonto, das Sie übertragen möchten, kann nicht übertragen werden. Bitte kontaktieren Sie den Support.",
        "guidelines": "Richtlinien für die Übertragung von Unterkonten",
        "guidelinesConsent": "Bitte lesen und zustimmen",
        "hipaaDisclaimer": "Haftungsausschluss",
        "hipaaText": "Sie sollten diesem Unterkonto mitteilen, dass es derzeit über HIPAA-Schutz verfügt, aber möglicherweise nicht denselben Schutz bei der Agentur erhält, zu der es übertragen wird.",
        "noUsersDescription": "Mit diesem Unterkonto sind keine Benutzer verknüpft. Bitte fügen Sie einen Unterkonto-Benutzer hinzu und fahren Sie dann fort.",
        "noUsersSearch": "Keine Benutzer gefunden.",
        "noUsersTitle": "Keine Benutzer gefunden",
        "nomineeInstructions": "Der Kandidat erhält einen Link zur Anmeldung bei HighLevel",
        "passwordError": "Ungültiges Passwort",
        "passwordErrorDescription": "Das von Ihnen eingegebene Passwort ist falsch. Bitte versuchen Sie es erneut.",
        "relationshipError": "Bitte die korrekte Beziehungsnummer eingeben",
        "relationshipNumber": "Zuordnungsnummer der empfangenden Agentur",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Übertragung beantragen",
        "seeAllRequests": "Alle Anfragen anzeigen",
        "successMessage": "Das Unterkonto wird übertragen, sobald die empfangende Agentur Ihre Übertragungsanfrage akzeptiert hat.",
        "successTitle": "Anfragen zum Übertragen des Kontos an die empfangende Agentur zugestellt",
        "title": "Unterkonto übertragen",
        "transferSubject": "Die Übertragung auf ein Unterkonto unterliegt der Annahme durch die empfangende Agentur in ihrem Konto.",
        "confirmNomineeSuffix": " zu "
      },
      "transferExisting": {
        "description": "Übertragen Sie das gesamte Unterkonto auf ein anderes Konto.",
        "title": "Auf ein bestehendes Konto übertragen"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Nächste Ausführung",
      "title": "Massedaten-Anfragen"
    },
    "campaign": {
      "account": "Konto",
      "accountBuffer": "Konto Puffer",
      "accountBufferDescription": "Es gibt kein Limit für die Anzahl der Empfänger, die jeden Tag aus einer Liste zu dieser Kampagne hinzugefügt werden können.",
      "accounts": "Konten",
      "activity": "Aktivität",
      "acquire": "Erben",
      "acquisitionDescription": "Kundenakquise-Kampagnen helfen Ihnen dabei, vielversprechende, interaktionsbereite Leads zu generieren.",
      "addEvent": "Veranstaltung hinzufügen",
      "addUser": "Benutzer hinzufügen",
      "allMarket": "Gesamter Markt",
      "allowMultiple": "Mehrere aktivieren",
      "assignedToTooltip": "Wenn diese Kampagne gestartet wurde, wurde dieser Kontakt diesem Benutzer zugewiesen. Änderungen an der Zuweisung des Kontakts werden sich auf die Vorkommnissen auswirken, ändern jedoch nicht diesen Anfangswert.",
      "atLeastOneEvent": "Mindestens eine Veranstaltung ist erforderlich.",
      "automations": "Automatisierungen",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus Unterscheidung sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Unzustellbar",
      "buffering": "Pufferung",
      "campaignActivity": "Kampagnenaktivität",
      "campaignConfiguration": "Kampagnen-Einstellung",
      "campaignConfigurationWarning": "Die Kampagnen-Einstellung wirkt sich auf alle Märkte aus. Stellen Sie sicher, dass Sie Änderungen an dieser Konfig vornehmen müssen.",
      "campaignCreation": "Erstellung einer Kampagne",
      "campaignId": "Kampagnen-ID",
      "campaignStatusByRecipients": "Kampagnenreputationen via Empfänger",
      "clickThroughRate": "Klicken Via Frequenz",
      "clickedThrough": "Durchgeklickt",
      "conditionIfExplanation": "Führen Sie diese Kampagne oder Veranstaltung aus, falls die derzeitige Sekunden in dieses Fenster fallen. Falls die derzeitige Sekunden außerhalb dieses Fensters liegen, überspringen Sie die Kampagne oder Veranstaltung und fahren Sie mit der nächsten fort.",
      "conditionWhenExplanation": "Führen Sie die Vorkommnisse in dieser Kampagne aus, wenn die Derzeit in dieses Fenster fällt, andernfalls Warten Sie bis zum Nächsten Fenster, um die Vorkommnisse auszuführen.",
      "createCampaign": " Kampagne erstellen",
      "ctr": "CTR",
      "customerAcquisition": "Kunden Kaufen",
      "dateAdded": "Datum hinzugefügt",
      "dateAddedTooltip": "Das genaue Tag und die Uhrzeit, zu denen der Kontakt zu dieser Kampagne hinzugefügt wurde. Die Startzeit der ersten Veranstaltung kann je nach Einstellungen variieren.",
      "deletedRestorePrompt": "Diese Kampagne ist gelöscht worden! Möchten Sie es Zurücksetzen?",
      "delivered": "Zugestellt",
      "deliveryRate": "Auslieferungsrate",
      "draftMode": "Entwurfsmodus",
      "draftModeDescription": "Diese Kampagne ist ein Entwurf. Es kann erst verwendet werden, wenn es veröffentlicht ist.",
      "dropped": "Entfernt",
      "emailActivity": "Email Aktivität",
      "emailActivityFilterExample": "E-Mail-Aktivität: Durchgeklickt",
      "event": "Veranstaltung",
      "eventFilterExample": "Veranstaltung: 10X Email 4 (Listing-Lieferung)",
      "filters": "Filter",
      "emailPerformanceByAccount": "Email-Performance Via Konto",
      "emailsNotSentOnDays": "E-Mails werden nicht an Samstagen und Sonntagen gesendet.",
      "emailsSentOnDays": "E-Mails werden am Montag, Dienstag, Mittwoch, Donnerstag und Freitag gesendet.",
      "eventStartDate": "Veranstaltungsbeginn",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "Stadt Perks Coffehouse",
      "exampleDate": "8. Mai 2017 13:27 Uhr",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Stellen Sie sicher, dass die Statistiken nicht älter als ein Monat sind.",
      "exampleEventName": "10X Email 4 (Lieferung der Angebote)",
      "getMoreCustomers": "Gewinnen Sie mehr Kunden",
      "inProgress": "In Bearbeitung",
      "includedDays": "Eingeschlossene Tage",
      "internalSource": "Internal Quelle",
      "lastUpdate": "Letzte Aktualisierung",
      "leadValuePlaceholder": "$-Wert des Interessenten",
      "loopDetected": "Diese Kampagne wurde im Entwurfsstatus gesperrt, da sie einen Loop verursacht. Um diese Kampagne zu aktivieren, wenden Sie sich bitte an den Support.",
      "market": "Markt",
      "moreDetails": "Weitere Details",
      "myCampaigns": "Meine Kampagnen",
      "na": "K. A.",
      "newFolder": " Neuer Ordner",
      "nextCampaign": "Nächste Kampagne",
      "nextExecutionTime": "Nächste Implementierung Stunde",
      "opened": "Geöffnet",
      "openRate": "Öffnungsrate",
      "option2": "Option 2",
      "option3": "Option 3",
      "pageNavigation": "Beispiel für eine Seitennavigation",
      "processed": "Verarbeitet",
      "published": "Veröffentlicht",
      "recipient": "Empfänger",
      "recipients": "Empfänger",
      "sampleCampaign": "Beispiel-Kampagne ",
      "scheduling": "Zeitplanung",
      "seeHotLeads": "Sehen Sie sich heiße Interessenten an",
      "selectDateRange": "Datumsbereich auswählen",
      "selectTimeZone": "Zeitzone Klicken",
      "separator": " / ",
      "showingCount": "{current} von {total}werden angezeigt",
      "spamReport": "Spam-Bericht",
      "startByAddingEvent": "Fügen Sie dieser Kampagne zunächst eine Veranstaltung hinzu.",
      "stopOnResponse": "Bei Antwort anhalten",
      "stopped": "Pausiert",
      "time": "Zeit",
      "timeConditionNote": "Nachricht: Wenn der erste Schritt in den Kampagnen auf 'Unmittelbar' gesetzt ist, dann gilt der Status für diesen ersten Schritt nicht.",
      "timeZoneDescription": "Diese Einstellung beeinflusst die Zeit, zu der Ihre Medien gesendet werden.",
      "totalLeads": "Leads gesamt",
      "undeliverable": "Unzustellbar",
      "unsubscribe": "Abmeldung",
      "upNext": "Als Nächstes",
      "utc": "UTC",
      "window": "Fenster"
    },
    "embed": {
      "copyLinkInstructions": "Kopieren Sie den unten stehenden Link und teilen Sie ihn ganz einfach, wo immer Sie möchten.",
      "embed": "Einbinden",
      "iframeEmbed": "Iframe Einbetten",
      "integrateInstructions": "Verwenden Sie die Nächste Optionen, um Ihr Benutzerdefiniert Formular in Ihre Seite zu integrieren.",
      "integrateYourForm": "Integrieren Sie Ihr Formular",
      "link": "Link",
      "saveAndExit": "Speichern und Beenden"
    },
    "jotbox": {
      "deleteSubmission": "Einreichung löschen",
      "downloadPdf": "PDF herunterladen",
      "ofSubmissions": " von {total} Einreichungen",
      "pages": "Seiten",
      "records": "Datensätze",
      "searchPlaceholder": "Suche nach Name, E-Mail, Telefon und Kontakt-ID",
      "selectYourForm": "Wählen Sie Ihr Formular",
      "timeSigned": "Zeitpunkt der Unterzeichnung:",
      "totals": "Gesamt:"
    },
    "survey": {
      "createNewSurvey": "Neue Umfrage erzeugen",
      "integrateYourSurvey": "Integrieren Sie Ihre Umfrage",
      "noSurveysForAnalyze": "Sie haben noch keine Umfrage. Bitte Erzeugen Sie zuerst eine Umfrage, um die Statistiken hier zu sehen.",
      "noSurveysForSubmission": "Sie haben noch keine Umfrage. Bitte erzeugen Sie zuerst eine Umfrage, um die Einreichung hier zu sehen.",
      "noSurveysYet": "Sie haben noch keine Umfrage.",
      "refreshData": "Daten aktualisieren",
      "searchSurveys": "Umfragen durchsuchen",
      "surveyBuilder": "Umfrage-Builder",
      "toCreateFirstSurvey": ", um Ihre erste Umfrage zu erstellen."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Produkt geklont! Wechseln Sie zu dem Konto, in das es geklont wurde, und suchen Sie es unter dem Tab Mitgliedschaft > Produkte.",
      "errorGettingDetails": "Es scheint ein Fehler beim Abrufen der Produktdetails aufzutreten. Bitte überprüfen Sie die URL oder versuchen Sie es erneut!"
    },
    "resetPassword": {
      "title": "Passwort zurücksetzen",
      "button": "Passwort zurücksetzen",
      "newPassword": "Neues Passwort",
      "generateStrongPassword": "Generieren Sie ein sicheres Passwort",
      "sendEmailNotification": "Senden Sie außerdem eine E-Mail-Benachrichtigung.",
      "errorMessage": "Beim Zurücksetzen des Passworts ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "updating": "Wird aktualisiert …"
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ Via",
      "combo": {
        "signedUp": "haben sich in den letzten 24 Stunden bei ProveSource registriert",
        "verifiedBy": "verifiziert durch "
      },
      "conversions": {
        "recentlyBought": "haben dies vor Kurzem gekauft",
        "timeAgo": "in den letzten 16 Minuten ",
        "visitorsCount": "50 Besucher"
      },
      "pageVisits": {
        "description": "scheinen ebenfalls hungrig zu sein.",
        "timeAgo": "in den letzten 21 Minuten                        ",
        "title": "50 Feinschmecker"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessge",
        "rating": "5-Sterne-Bewertung",
        "recently": "Vor Kurzem",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "für ProveSource registriert",
        "location": "(London, Vereinigtes Königreich)",
        "name": "Mike ",
        "timeAgo": "vor 40 Minuten                        "
      },
      "visitors": {
        "description": "Musikliebhaber online"
      }
    },
    "step1": {
      "combo": {
        "description": "Gesamtzahl der Personen anzeigen, die innerhalb von 24 Stunden, 7 oder 30 Tagen eine bestimmte Aktion ausgeführt haben.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Erzeugen Sie Soziale Medien-Bestätigung via Display, wie viele Kunden eine bestimmte Aktion ausgeführt haben."
      },
      "liveReviews": {
        "description": "Zeigen Sie Ihren Besuchern in Echtzeit echte Bewertungen mit 4+ Sternen aus den letzte 6 Monaten."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Anzeigen, wie viele Besucher sich jetzt Ihre Voll Standort in Live ansehen."
      },
      "pageVisits": {
        "description": "Zeigen Sie Ihren Besuchern, dass sie nicht die Einzigen auf der Party sind, indem Sie die neuesten Seitenbesuche hervorheben."
      },
      "stream": {
        "description": "Was ist besser, als Soziale Medien An zu geben? Zeigen Sie Ihre aktuellen Kunden und deren Aktionen."
      }
    },
    "step2": {
      "captureDescription2": "Jede Seiten-URL muss ein E-Mail-Formularfeld enthalten",
      "captureDescription3": " und ProveSource muss installiert sein. ",
      "comboType": "Kombination eintippen",
      "connectAccounts": "Stellen Sie sicher, dass Sie die Konten verbinden, von denen Sie Bewertungen ziehen möchten",
      "connectGoogleAccount": "Verbinden Sie das Google-Konto Ihres Standorts",
      "formSubmissions": "Formulareinreichungen",
      "googleAccount": "Google-Konto",
      "howToTrack": "Wie man verfolgt",
      "howToTrackDescription": "Wie sollten wir Ihre Konversionsrate verfolgen?",
      "pageUrl": "Seiten-URL",
      "productPurchase": "Produktkauf",
      "trackAllUrls": "Alle Seiten-URLs verfolgen, die den folgenden Ausdruck enthalten. ",
      "trackVisitors": "Besucher-Tracking",
      "trackVisits": "Besuche nachverfolgen",
      "urlTip": " Wir behandeln http://, https://, www und nicht-www als separate Varianten der URL und Seite. ",
      "urlValidationError": "Sie müssen mindestens eine URL hinzufügen. Die URL ist ungültig. Vergessen Sie nicht, http:// oder https:// hinzuzufügen",
      "userSignup": "Benutzerregistrierung",
      "visits": " Besuche",
      "webhookDescription": "Rufen Sie den folgenden Endpunkt auf, um uns über ein Ereignis oder eine Konversion zu informieren, die auf Ihrer Seite stattgefunden hat und mit dieser Benachrichtigung zusammenhängt. Wir kümmern uns um den Rest.",
      "webhookRequest": "Webhook-Anfrage",
      "whatToTrack": "Was möchten Sie nachverfolgen?",
      "whereToCapture": "Wo soll erfasst werden",
      "whereToCaptureDescription": "Wo erfassen Sie Konversionen?",
      "whichPagesToTrack": "Welche Seiten sollen wir verfolgen?",
      "yourWebhookUrl": "Ihre Webhook-URL"
    },
    "step3": {
      "allPages": " Alle Seiten",
      "displayOnAllPages": "Auf allen Seiten-URLs anzeigen, die den folgenden Ausdruck enthalten: ",
      "whereToDisplay": "Wo anzeigen",
      "whereToDisplayActivity": "Wo sollen wir diese Aktivität anzeigen?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "für schön aussehende Symbole (Rechtsklick auf ein Symbol -> Bildadresse kopieren)",
      "messageSettings": "Nachrichteneinstellungen",
      "messageText": "Nachrichtentext",
      "referToVisitorsAs": "Bezeichnen Sie Besucher als",
      "visitIcons8": "Besuche"
    },
    "step5": {
      "allowUsersToClose": " Ermöglichen Sie es Benutzern, die Benachrichtigung zu schließen ",
      "behavior": "Verhalten",
      "bottomLeft": "Unten links",
      "bottomRight": "Unten rechts",
      "clickableNotification": " Klickbare Benachrichtigung ",
      "customizeDescription": "Ändern Sie die folgenden Einstellungen, um das Verhalten und das Aussehen Ihrer Benachrichtigung zu steuern.",
      "design": "Styling",
      "displayNotificationFor": "Benachrichtigung anzeigen für",
      "displayRules": "Anzeigeregeln",
      "hideOnMobileScreens": " Auf mobilen Bildschirmen ausblenden ",
      "linkRelativeNote": " Falls http:// übersprungen wird, öffnet sich die Verknüpfung relativ zur angezeigten Seite ",
      "minimumEventsToDisplay": "Mindestanzahl anzuzeigender Ereignisse",
      "notificationLink": "Benachrichtigungslink",
      "notificationPosition": "Benachrichtigungsposition",
      "openLinkInNewTab": "Link in neuem Tab öffnen",
      "selectPosition": "Position auswählen",
      "showOnlyOncePerSession": " Nur einmal pro Sitzung anzeigen ",
      "titleBackground": "Titelhintergrund",
      "titleColor": "Überschriftfarbe",
      "topLeft": "Oben links",
      "topRight": "Oben rechts",
      "typeUrlHere": "Tippen Sie hier die URL ein"
    },
    "step6": {
      "identifyNotification": "Identifizieren Sie Ihre Push-Benachrichtigung",
      "launchMessage": "Wir stehen kurz vor dem Start, bitte nehmen Sie Platz und schnallen Sie sich an.",
      "notificationName": "Benachrichtigungsname",
      "notificationNamePrompt": "Wie lautet der Name Ihrer Push-Benachrichtigung?",
      "wellDone": "Gut gemacht."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Abonnement wurde erfolgreich erstellt",
      "youCanNowSetupWordPress": "Sie können jetzt Ihre WordPress-Website einrichten.",
      "subscriptionFailed": "Abonnement fehlgeschlagen",
      "resubscriptionSuccessful": "Wiederanmeldung erfolgreich",
      "successfullyReactivated": "Ihr WordPress-Abonnement wurde erfolgreich reaktiviert.",
      "reactiveSub": "Das Abonnement kann nicht reaktiviert werden",
      "resubscriptionFailed": "Erneute Anmeldung fehlgeschlagen"
    },
    "v2": {
      "viewDetails": "Details anzeigen",
      "chatConversationAssigned": "Chat-Chat zugewiesen",
      "internalChat": "Interner Chat",
      "newTask": "Neue Aufgabe",
      "appointmentReminder": "Terminerinnerung",
      "facebookReview": "Facebook Bewertung",
      "googleReview": "Google Bewertung",
      "internalChatMessage": "Interne Chat-Nachricht",
      "newAppointmentAssigned": "Neuer Termin zugewiesen",
      "newAppointmentBooked": "Neuer Termin gebucht",
      "newCall": "Neuer Anruf",
      "newEmail": "Neue E-Mail",
      "newMention": "Neue Erwähnung",
      "newReviewReceived": "Neue Bewertung erhalten von {contactName}",
      "taskReminder": "Aufgabenerinnerung",
      "completed": "erledigt",
      "failed": "Fehlgeschlagen",
      "subAccount": "Unterkonto",
      "newMessage": "Neue Nachricht",
      "newAppointmentBookedWith": "Neuer Termin mit {contactName}gebucht",
      "newAppointmentAssignedTo": "Neuer Termin zugewiesen an {contactName}",
      "appointmentDueIn": "Termin in {minutes} Minuten mit {contactName}fällig",
      "newTypeReceived": "Neues {type} von {contactName}erhalten.",
      "newChatAssigned": "Neuer Chat zugewiesen von {contactName}",
      "taskDueDate": "Aufgabe '{title}' ist fällig am {date} um {time} für {contactName}.",
      "tasksDueToday": "{count} Aufgaben, die heute fällig sind",
      "tasksOverdue": "{count} Aufgaben überfällig",
      "taskDueIn": "Aufgabe '{title}' ist in {dueTime} {unitOfTime} für {contactName} fällig.",
      "mentionedInConversation": "{userName} hat Sie im Gespräch mit {contactName}erwähnt",
      "now": "jetzt"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Logo des Unternehmens"
      },
      "bestExperience": "beste Erfahrung.",
      "optimizedFor": "Diese Seite ist für optimale Leistung optimiert.",
      "portraitMode": "Kopfbildmodus",
      "toGiveYou": "um Ihnen die"
    }
  },
  "pagination": {
    "goToFirstPage": "Gehen Sie zur ersten Seite",
    "goToLastPage": "Zur letzten Seite gehen",
    "goToNextPage": "Zur nächsten Seite gehen",
    "goToPreviousPage": "Zur vorherigen Seite springen",
    "itemsSelected": "{count} Element ausgewählt",
    "showingEntries": "Anzeigen von Einträgen {from} bis {to} von insgesamt {total}"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Bitte Zahlungsmethode hinzufügen für",
    "_segment": "/ Segment",
    "ad_manager": "Anzeigen-Manager",
    "add": "[HINZUFÜGEN:",
    "ai_employee": "AI-Mitarbeiter",
    "billing": {
      "incompleteBillingInfo": "Ihre Rechnungsdaten für dieses Konto sind unvollständig. Bitte aktualisieren Sie diese umgehend.",
      "updateNow": "Jetzt aktualisieren"
    },
    "charge": "Gebühr",
    "contactLimit": {
      "message": "Sie haben in Ihrem aktuellen Tarif das Limit für das Hinzufügen von {contact} erreicht. Um fortzufahren, aktualisieren Sie bitte Ihren Tarif und schalten Sie zusätzliche Kapazitäten frei.",
      "upgradeNow": "Jetzt erweitern",
      "warningMessage": "Sie haben {current} Kontakt(e), während Ihr Tarif nur bis zu {limit} erlaubt.",
      "warningTitle": "Die Kontonutzung überschreitet das Limit. Bitte führen Sie ein Upgrade durch, um ohne Unterbrechung weiterzuarbeiten."
    },
    "cost_borne_by_you": "von Ihnen getragenen Kosten",
    "dedicated_ip": "Feste IP",
    "electeditem": "Ausgewähltes Element",
    "feedback": "Feedback:",
    "hello": "Hallo",
    "helpDrawer": {
      "aiSupportAssistant": "AI Support Assistant",
      "clickToCopy": "Klicken Sie, um die Beziehungsnummer zu kopieren",
      "clickToCopyToClipboard": "Klicken Sie, um die Nummer in die Zwischenablage zu kopieren",
      "companyRelationshipNumber": "Beziehungsnummer des Unternehmens",
      "hiImHighly": "Hallo, ich bin Highly!",
      "implementation": "Implementierung",
      "joinImplementationVideo": "Am Videoanruf zur Implementierung teilnehmen",
      "joinTrialZoom": "Treten Sie dem Trial Zoom-Meeting bei",
      "kickoff": "Kick-off",
      "needHelpChatVideo": "Brauchen Sie Hilfe? Starten Sie jetzt einen Chat oder Videoanruf mit uns!",
      "openAIAssistant": "AI Support Assisstant öffnen",
      "premium": "Premium",
      "priority": "Priorität",
      "raiseSupportTicket": "Support-Ticket erstellen",
      "raiseTicket": "Ticket erstellen",
      "relationshipNumber": "Beziehungsnummer",
      "startAISupportChat": "AI-Support-Chat starten",
      "startAgentChatWait": "Agentenchat mit 2–5 Minuten Wartezeit starten",
      "startChatChoose": "Chat starten: zwischen AI-Unterstützung oder Agenten-Chat wählen",
      "startImplementationVideo": "Implementierungs-Videoanruf starten",
      "startZoom": "Zoom starten",
      "startZoomCall": "Zoom-Anruf starten",
      "subtitle": "Egal, ob Sie mit uns oder der Community sprechen oder selbst lernen möchten, bei uns sind Sie an der richtigen Adresse!",
      "title": "Hilfe und Support",
      "trialExperience": "Erfahrung im Trial",
      "useButtonsBelow": "Verwenden Sie eine der untenstehenden Schaltflächen, um Hilfe zu erhalten!",
      "videoCallReward": "Nehmen Sie an einem Videoanruf teil, um Ihr Konto einzurichten, und lassen Sie sich für Ihre Teilnahme {amount} Ihrem Wallet gutschreiben.",
      "videoCallType": "Nehmen Sie zu Ihrem {type}-Call an einem Videoanruf mit mir teil.",
      "yourPremiumSupportSpecialist": "Ihr {type}-Supportspezialist",
      "yourSpecialist": "Ihr {type}-Spezialist",
      "yourSupportSpecialist": "Ihr Supportspezialist",
      "videoCall": "Videoanruf",
      "active": "Aktiv",
      "announcementsAria": "Ankündigungen – klicken Sie, um in einem neuen Tab zu öffnen",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Klicken Sie hier, um auf den HighLevel-Willkommenskurs zuzugreifen",
      "clickToUpgrade": "Zum Upgraden hier klicken",
      "connectCertifiedAdminAria": "Kontaktieren Sie einen zertifizierten Administrator – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
      "connectWithUsAria": "Verbinden Sie sich mit uns – starten Sie den Live-Chat",
      "contactUsAria": "Kontaktieren Sie uns – rufen Sie HighLevel an unter +1(888)732-4197",
      "copied": "Kopiert",
      "highlevelEventsAria": "HighLevel Events – zum Öffnen in neuem Tab hier klicken",
      "joinFacebookGroupAria": "Treten Sie unserer Facebook-Gruppe bei – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
      "onboardingVideoTutorialsAria": "Onboarding-Video-Tutorials – klicken Sie hier, um die Seite in einem neuen Tab zu öffnen",
      "recommended": "Empfohlen",
      "visitHelpCenterAria": "Besuchen Sie unser Hilfe-Center – klicken Sie hier, um in einem neuen Tab zu öffnen",
      "contactUs": "Kontakt uns",
      "agentChatWaitTime": "Agenten-Chat (ca. 2–5 Min Wartezeit)",
      "aiSupportChat": "AI-Support-Chat",
      "startChat": "Chat starten",
      "announcements": "Hinweise",
      "fastestGrowingCommunity": "Werden Sie Teil der am schnellsten wachsenden Community.",
      "callHighlevelPhone": "Rufen Sie HighLevel unter +1(888)732-4197 an",
      "connectCertifiedAdmin": "Verbinden Sie sich mit einem zertifizierten Administrator",
      "connectTeamVideoCall": "Kontaktieren Sie unser Team für Unterstützung per Live-Videoanruf!",
      "connectWithUs": "Verbinden Sie sich mit uns",
      "dailyBrainstormingSessions": "Tägliche Brainstorming-Sitzungen mit Highlevel",
      "certifiedAdminDescription": "Entdecken Sie HighLevel-Experten, die Ihnen bei der Einrichtung Ihres Systems, der Automatisierung von Workflows oder der Anpassung Ihres Projekts helfen können.",
      "getAccessWelcomeCourse": "Erhalten Sie Zugriff auf den HighLevel-Willkommenskurs",
      "premiumSupportDescription": "Erhalten Sie Priorität bei der Fehlerbehebung, professionelle Beratung und direkten Zugang zu unserem technischen Team über Slack.",
      "highlevelEvents": "Highlevel Veranstaltungen",
      "joinFacebookGroup": "Treten Sie unserer Facebook Gruppe bei",
      "onboardingVideoTutorials": "Video-Tutorials zum Onboarding",
      "premiumSupport": "Premium-Support",
      "setupAccountFreeTutorials": "Richten Sie Ihr Konto ein, mit kostenlosen Tutorials",
      "viewSupportTicketsArticles": "Sehen Sie sich Ihre Support-Tickets, unsere Support-Artikel und hilfreichen FAQs an!",
      "visitHelpCenter": "Besuchen Sie unser Hilfe-Center",
      "welcomeCourse": "Willkommenskurs",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Schließen Sie die Hilfe- & Support-Schublade",
      "upgradePlanToEnable": "Sie müssen Ihren Plan erweitern, um diese Funktion zu aktivieren",
      "premiumSupportActive": "Ihr Premium-Support ist aktiv.",
      "premiumSupportClickUpgrade": "Premium-Support – Klicken Sie, um Ihren Plan zu aktualisieren.",
      "premiumSupportActiveAria": "Premium-Support - Ihr Premium-Support ist aktiv",
      "keepUpToDateNews": "Bleiben Sie mit allen neuesten Nachrichten und Veröffentlichungen auf dem Laufenden!"
    },
    "hi": "Hallo",
    "is_scheduled_for_deletion_on": "ist zur Löschung vorgesehen am",
    "k": "K",
    "limit_updated_from": "Limit wurde aktualisiert von",
    "minimum_must_be": "Mindestens erforderlich:",
    "more_emails_in_thread": "weitere E-Mails im Thread",
    "multipleUsers": {
      "chooseAccount": "Konto auswählen, um fortzufahren"
    },
    "must_be_in_range_of_0": "Muss liegen im Bereich von 0–",
    "numbers_and": "Nummer(n) und",
    "premiumSupport": {
      "assigningManager": "Zuweisung eines Technical Konto Managers …",
      "bookCall": "Anruf buchen",
      "hiIm": "Hallo, ich bin {name}",
      "joinZoomNow": "Jetzt am Zoom-Call teilnehmen",
      "quickActions": "Schnelle Unterstützungsmaßnahmen",
      "quickLinks": "Schnellzugriffe",
      "raiseFeatureRequest": "Anfrage zu Funktion einreichen",
      "slackChannelCreating": "Einen Moment bitte – Ihr Premium-Slack-Kanal wird gerade eingerichtet! 🚀",
      "technicalAccountManager": "Technical Account Manager",
      "viewRoadmap": "Produkt-Roadmap anzeigen"
    },
    "prospecting": "Interessentengewinnung",
    "reloadPopup": {
      "message": "Wir haben bemerkt, dass Sie die Seite schon seit länger nicht mehr aktualisiert haben. Bitte aktualisieren Sie, um die App optimal nutzen zu können.",
      "refreshNow": "Aktualisieren Sie jetzt"
    },
    "resell_settings": "Wiederverkaufseinstellungen",
    "row": "Zeile",
    "select_upto": "Wählen Sie bis zu",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Erhalten Sie individuelle Unterstützung zu einem für Sie passenden Zeitpunkt.",
      "title": "Telefongespräch mit dem Support von Highlevel vereinbaren"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "Dies sind Margen, die Ihren Kunden in Rechnung gestellt werden, über die",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Überlassen Sie uns die problemlose Verwaltung von Twilio",
        "benefit2": "Unser Support-Team kümmert sich um Ihre Twilio-Probleme",
        "button": "Erledigen Sie es für mich",
        "drawback": "Zahlen Sie {price} extra an VAS, anstatt es selbst zu tun",
        "title": "Wir erledigen das für Sie"
      },
      "lowCreditsMessage": "Sie müssen ein Twilio-Konto verbinden, um Anrufe und Texte zu verwalten, die über HighLevel gesendet oder empfangen werden.",
      "lowCreditsTitle": "Ihr kostenloses Twilio-Guthaben ist fast aufgebraucht, aber keine Sorge, wir helfen Ihnen!",
      "selfSetup": {
        "benefit1": "Verwalten Sie Ihre Ausgaben",
        "benefit2": "Mehr Kontrolle über Ihren Twilio-Dienst",
        "button": "Verwaltung über uns",
        "drawback1": "Jemanden beauftragen, um den Twilio-Dienst zu verwalten",
        "drawback2": "Wenden Sie sich an den Twilio-Support, wenn etwas nicht funktioniert.",
        "title": "Machen Sie es selbst"
      },
      "wip": {
        "button": "Twilio jetzt einrichten",
        "fallback": "Vorerst müssen Sie Ihr Twilio-Konto selbst verwalten.",
        "message": "Vielen Dank, dass Sie sich für uns entschieden haben, aber wir arbeiten noch an der Entwicklung dieser Funktion. Wir melden uns bei Ihnen, sobald wir diese für Ihr Konto bereitstellen können.",
        "title": "Wir arbeiten noch daran!!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Mehr Optionen werden geladen …",
      "noElementsFound": "Hoppla! Keine Komponenten gefunden. Denken Sie über eine Änderung der Suchanfrage nach.",
      "noLocationsFound": "Keine Standorte gefunden. Versuchen Sie es mit einem anderen Suchbegriff.",
      "typeToSearch": "Zum Suchen eintippen",
      "enterUserEmail": "E-Mail des Nutzers eingeben"
    },
    "updating": "Aktualisierung erfolgt …",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Vorlage verwenden"
    },
    "validEmail": {
      "andYouCan": "Und Sie können",
      "as": "als",
      "canReverify": "Sie können Ihre E-Mail erneut verifizieren",
      "emailIs": "Diese E-Mail-Adresse ist",
      "emailMarkedAs": "Diese E-Mail-Adresse wurde markiert als",
      "markedAsInvalid": "Diese E-Mail-Adresse ist markiert als",
      "notVerified": "Nicht verifiziert",
      "reverifyHere": "Hier erneut überprüfen",
      "verifyHere": "Hier überprüfen"
    },
    "will_give_you_about": "erhalten Sie etwa",
    "checkout": {
      "confirm": "Bestätigen",
      "cardInformation": "Karteninformationen",
      "cardNumberInvalid": "Ihre Kartennummer ist ungültig.",
      "commitment": "Verpflichtung",
      "paymentConsent": "Mit Ihrer Bestätigung gestatten Sie LeadConnector, Ihre Karte für diese Zahlung zu belasten.",
      "subscriptionConsent": "Indem Sie Ihr Abonnement bestätigen, gestatten Sie LeadConnector, Ihre Karte für diese Zahlung und zukünftige Zahlungen für dieses Abonnement zu belasten.",
      "endingIn": "endet in",
      "month": "Monat",
      "pay": "Bezahlen",
      "payWithCard": "Mit Karte bezahlen",
      "paymentBeingProcessed": "Die Zahlung wird gerade bearbeitet. Bitte laden Sie die Seite nicht neu und klicken Sie nicht auf die Zurück-Schaltfläche",
      "proceedWithExistingCard": "Mit vorhandener Karte fortfahren",
      "proceedWithNewCard": "Mit neuer Karte fortfahren",
      "purchase": "kaufen",
      "subscribe": "Abonnement",
      "subscribeTo": "Abonnieren Sie",
      "pleaseUpdateCardDetails": "Bitte aktualisieren Sie die Kartendetails",
      "zip": "zip",
      "retry": "erneut versuchen",
      "initialChargesProrated": "Die anfänglichen Gebühren werden anteilig berechnet, und die regelmäßige Abrechnung beginnt ab",
      "youWillBeChargedFor": "Ihnen wird etwas in Rechnung gestellt.",
      "days": "Tage",
      "rightNowForPeriodTill": "jetzt für den Zeitraum bis",
      "startGettingChargedFullAmount": "und Ihnen wird der volle Betrag in Rechnung gestellt",
      "perMonthStartingFrom": "/Monat ab",
      "nameOnCard": "Name auf der Karte",
      "somethingWentWrong": "Etwas ist schiefgelaufen",
      "errorImg": "Fehlerbild",
      "networkError": "Netzwerkfehler, bitte versuchen Sie es später erneut",
      "paymentCouldNotBeProcessed": "Die Zahlung konnte nicht verarbeitet werden. Bitte versuchen Sie erneut, eine Karte hinzuzufügen."
    },
    "deleteLocation": {
      "back": "Zurück",
      "delete": "Löschen",
      "completeStepsToDelete": "Sie müssen einige einfache Schritte vollziehen, um diesen Standort zu löschen.",
      "alsoCloseAssociated": "Auch eng verknüpft",
      "scheduling": "Planung...",
      "subAccountAndDeletePhoneNumbers": "Unterkonto schließen und alle Telefonnummern löschen",
      "somethingWentWrongTryAgain": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
      "deleteSubAccount": "Unterkonto löschen",
      "scheduleForDeletion": "Zur Löschung vorgemerkt"
    },
    "productRebilling": {
      "enableRebilling": "Neuberechnung aktivieren",
      "ratesMayDifferUK": "Die Preise können je nach Region variieren. Die angezeigten Berechnungen basieren auf den Tarifen für das Vereinigte Königreich,",
      "examplePricingGpt4oMini": "Preisbeispiel – GPT-4o Mini",
      "input": "Eingabe",
      "output": "Ausgabe",
      "supportDoc": "Support-Dokumentation",
      "unsavedChanges": "Nicht gespeicherte Änderungen",
      "to": "Zu",
      "chargedToCustomerLower": "Dem Kunden in Rechnung gestellt",
      "model": "Modell",
      "profit": "Gewinn",
      "saving": "Wird gespeichert …",
      "type": "Typ",
      "updating": "Wird aktualisiert...",
      "clickHere": "Hier klicken",
      "chargedToCustomer": "Dem Kunden in Rechnung gestellt:",
      "enabling": "Aktivieren...",
      "forMoreDetails": "für mehr Details.",
      "tenDollarsWillGive": "Für 10 USD erhalten Sie ungefähr",
      "yourCost": "Ihre Kosten",
      "seeHow": "Sehen Sie, wie",
      "clientCompanyBillingPage": "Abrechnungsseite des Unternehmens des Kunden",
      "connectStripeToEnable": "Um die erneute Rechnungsstellung zu aktivieren, müssen Sie Ihr Stripe-Konto verbinden",
      "companyStripeIntegrationPage": "Stripe-Integrationsseite des Unternehmens",
      "enterClientCardInfo": "Um die automatische Abrechnung zu aktivieren, müssen Sie die Kartendaten Ihres Kunden eingeben auf",
      "gpt4oMini": "GPT-4o mini",
      "for750kWords": "(für 750.000 Wörter)",
      "words": "Wörter",
      "yourCostLower": "Ihre Kosten",
      "and": "und",
      "or": "oder",
      "minimumMustBeBetween": "Das Minimum muss zwischen liegen",
      "upgradeToAgencyPro": "Upgrade auf Agentur Pro",
      "planToSetMargins": "Planen, Gewinnspannen festzulegen"
    },
    "m": "m",
    "label": "Label",
    "company_email_": "Firmen-E-Mail-Adresse (",
    "me_": "Ich (",
    "automation_type": "Automatisierungstyp",
    "calendar_groups": "Kalendergruppen",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "Keine Produkte verfügbar",
    "selectProduct": "Produkt auswählen"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Zusätzliche {product} Nachrichten werden den Standorten nicht berechnet. Um eine Neuberechnung für den Kunden vorzunehmen, aktivieren Sie bitte den SaaS-Modus und die Neuberechnung.",
      "agreementPrefix": "Ich bin einverstanden mit der Aktivierung",
      "agreementSuffix": "ohne Wiederverkauf für diesen Kunden und nehme zur Kenntnis, dass mir Kosten in Rechnung gestellt werden",
      "buildResellerOffer": "Erstellen Sie Ihr Wiederverkaufsangebot",
      "deployDirectlyDescription": "Verwenden Sie diese Option, wenn Sie {product} als Teil Ihres Angebots anbieten oder wenn Sie Ihrem Kunden extern eine Rechnung stellen möchten",
      "deployPrefix": "Bereitstellen",
      "directlySuffix": "Direkt",
      "learnMore": "Mehr erfahren.",
      "offerPrefix": "Angebot",
      "resellPrefix": "Wiederverkaufen",
      "resellingPrefix": "Wiederverkauf",
      "subscriptionRestriction": "Die Einstellung kann nicht geändert werden, da das Unterkonto bereits abonniert ist",
      "zero": "0",
      "highlevelPrice": "HighLevel-Preis",
      "howDoesItWork": "Wie funktioniert das?",
      "payNowButton": "Jetzt bezahlen",
      "priceValidationError": "Der Preis muss größer oder gleich dem HighLevel-Preis sein",
      "saving": "Speichert",
      "yourPrice": "Ihr Preis",
      "yourProfit": "Ihr Gewinn"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Der Empfang von eingehenden Nachrichten und die Beantwortung mit Freitext im Chatfenster sind kostenlos. Für ausgehende Vorlagennachrichten fallen zusätzliche Bearbeitungsgebühren an.",
      "whatsappLocation": "WhatsApp-Standort"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Die Konfiguration kann nicht geändert werden, da der Standort bereits ein Abonnement hat",
        "offerPrefix": "Angebot ",
        "poweredByPrefix": " (Unterstützt von Search Atlas)",
        "toggleTooltipDisable": "Diese Aktion wird das SEO-Widget für alle Unterkonten deaktivieren.",
        "toggleTooltipEnable": "Diese Aktion wird das SEO-Widget für alle Unterkonten aktivieren.",
        "resellPrefix": "Wiederverkaufs- ",
        "howDoesItWork": "Wie funktioniert das?",
        "buildResellerOffer": "Erstellen Sie Ihr Wiederverkaufsangebot",
        "yourPrice": "Ihr Preis",
        "highlevelPrice": "HighLevel-Preis",
        "yourProfit": "Ihr Gewinn",
        "priceValidationError": "Der Preis muss höher als oder gleich dem HighLevel-Preis sein",
        "saving": "Wird gespeichert",
        "save": "Speichern",
        "deployPrefix": "Bereitstellen ",
        "directlySuffix": "Direkt",
        "deployDirectlyDescription": "Verwenden Sie diese Option, falls Sie SEO als Teil Ihres Angebots anbieten oder falls Sie Ihrem Kunden extern eine Rechnung stellen möchten",
        "agreementPrefix": "Ich bin einverstanden mit der Aktivierung von ",
        "agreementSuffix": " für diesen Kunden (ohne Wiederverkauf) und nehme zur Kenntnis, dass mir dafür Kosten in Rechnung gestellt werden:",
        "payNowButton": "Jetzt bezahlen",
        "subscriptionCreating": "Das Abonnement wird erstellt.<br/>Bitte laden Sie die Seite nicht neu und klicken Sie nicht auf die Zurück-Schaltfläche",
        "subscriptionCreated": "Abonnement wurde erstellt. Bitte warten …",
        "subscriptionError": "Es kann kein Abonnement erstellt werden. Bitte kontaktieren Sie den Support."
      },
      "adManager": {
        "subscriptionRestriction": "Die Konfiguration kann nicht geändert werden, da der Standort bereits ein Abonnement hat",
        "offerPrefix": "Angebot ",
        "resellingPrefix": "Wiederverkaufs-",
        "resellPrefix": "Wiederverkaufs- ",
        "howDoesItWork": "Wie funktioniert das?",
        "bookACall": "Anruf vereinbaren",
        "bookCallTooltip": "Vereinbaren Sie einen Anruf mit unserem Team, um mehr über den Anzeigen-Manager zu erfahren",
        "buildResellerOffer": "Erstellen Sie Ihr Wiederverkaufsangebot",
        "yourPrice": "Ihr Preis",
        "highlevelPrice": "HighLevel-Preis",
        "yourProfit": "Ihr Gewinn",
        "priceValidationError": "Der Preis muss höher oder gleich dem HighLevel-Preis sein",
        "loading": "Wird geladen …",
        "save": "Speichern",
        "deployPrefix": "Bereitstellen ",
        "directlySuffix": "Direkt",
        "deployDirectlyDescription": "Nutzen Sie diese Option, wenn Sie den Anzeigen-Manager als Teil Ihres Angebots anbieten oder wenn Sie Ihrem Kunden eine externe Rechnung stellen möchten",
        "agreementPrefix": "Ich bin einverstanden mit der Aktivierung von ",
        "agreementMiddle": " für diesen Kunden (ohne Wiederverkauf) und nehme zur Kenntnis, dass mir dafür Kosten in Rechnung gestellt werden:",
        "agreementSuffix": " pro Monat",
        "stripeNotConnectedLocationWarning": "Stripe ist für diesen Standort nicht verbunden. Bitte verbinden Sie Stripe, um diese Funktion zu aktivieren.",
        "stripeNotConnectedAgencyWarning": "Stripe ist für diese Agentur nicht verbunden. Bitte verbinden Sie Stripe, um diese Funktion zu aktivieren.",
        "underSubAccountReselling": "pro Monat im Rahmen des Weiterverkaufs unter einem Unterkonto"
      },
      "dedicatedIp": {
        "description": "So können Sie Ihren Kunden die Kosten für feste IP-Adressen (die für den ausgehenden E-Mail-Versand verwendet werden) in Rechnung stellen und einen Aufschlag erheben",
        "numberOfIps": "Anzahl der IPs:",
        "yourCost": "Ihre Kosten:",
        "chargedToCustomer": "Gebühren für den Kunden:",
        "profit": "Gewinn:",
        "monthlyProfit": "Monatlicher Gewinn:",
        "loading": "Wird geladen …",
        "save": "Speichern",
        "revokeDedication": "Angebot fester IPs widerrufen",
        "revokeDescription": "Verwenden Sie diese Option, um Ihrem Kunden keine neuen festen IPs mehr anzubieten, ohne ihm dafür Gebühren zu berechnen",
        "existingSubscriptionsNote": "Bestehende IP-Abonnements sind davon nicht betroffen",
        "revoke": "Widerrufen",
        "provideDirectlyTitle": "Feste IP für den E-Mail-Versand direkt zur Verfügung stellen",
        "provideDirectlyDescription": "Verwenden Sie diese Option, um Ihrem Kunden eine feste IP zuzuweisen, ohne ihm etwas dafür zu berechnen",
        "agreeToProvideText": "Ich bin damit einverstanden, die IP für diesen Kunden ohne Upsell anzubieten",
        "acknowledgeChargeText": "Ich bestätige, dass mir 59 $ pro Monat und IP in Rechnung gestellt werden",
        "agree": "Ich stimme zu",
        "yourMonthlyCost": "Ihre monatlichen IP-Kosten:",
        "monthlyChargeToCustomer": "Monatliche Gebühr für den Kunden:",
        "resellingSettingsSuffix": " Wiederverkaufseinstellungen",
        "ipRebillingAmount": "IP-Neuberechnungsbetrag"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "Ich bestätige, dass ich dies mit meinem Kunden besprochen habe und ich seine Genehmigung habe",
        "confirmQuestion": "Sind Sie sicher, dass Sie den SaaS-Modus für dieses Konto deaktivieren möchten?",
        "dataLossAck": "Mir ist bewusst, dass alle Neuberechnungsdaten, SaaS-Abonnementdaten und das Transaktionsbuch verloren gehen",
        "disableSaas": "SaaS deaktivieren",
        "irreversibleAck": "Ich verstehe, dass diese Aktion nicht rückgängig gemacht werden kann"
      },
      "confirmationModal": {
        "cancelSubscription": "Kündigen Sie auch das zugehörige SaaS-Abonnement",
        "confirmDisable": "Deaktivieren bestätigen",
        "confirmQuestion": "Sind Sie sicher, dass Sie den SaaS-Modus deaktivieren möchten?",
        "somethingWentWrong": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal."
      },
      "processingModal": {
        "closeNow": "Jetzt schließen",
        "closeWindowInstructions": "Sie können dieses Fenster schließen – wir werden Sie per E-Mail informieren, sobald dieser Vorgang abgeschlossen ist",
        "title": "SaaS wird für diesen Standort in Kürze deaktiviert.",
        "typicalTime": "Dies dauert üblicherweise höchstens 10 Minuten."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Benutzerdefiniertes Feld hinzufügen",
      "fieldKey": "Industrie-Token",
      "fieldName": "Feldname",
      "idWillBeAdded": "Die ID wird nach Erstellen des Verlustgrunds hinzugefügt",
      "lostReasonID": "Verlustgrund-ID",
      "placeholder": "Platzhalter"
    },
    "locationMailGun": {
      "bccAddress": "BCC Anschrift",
      "clearError": "Fehlgeschlagen klären",
      "deleteConfirmationMessage": "Durch diese Aktion wird die Mailgun-Verbindung getrennt.",
      "deleteConnection": "Verbindung löschen",
      "domain": "Domain",
      "domainsAvailable": "{count} verfügbar",
      "invalidApiKey": "Ungültiger API-Schlüssel",
      "selectDomain": "Domäne auswählen"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Fehler beim Abrufen der Transaktionsdetails",
      "transactions": "Transaktionen"
    },
    "noShowSMS": {
      "smsWithImage": "Nichterscheinen-SMS mit Bild",
      "title": "SMS zur Überprüfung anpassen"
    },
    "optOut": {
      "addKeywords": "Bitte fügen Sie eines der folgenden Opt-out-Schlüsselwörter hinzu: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END oder QUIT.",
      "customizeTitle": "Opt-Out-Nachricht anpassen.",
      "disableConfirm": "Möchten Sie die Opt-Out-Nachricht wirklich deaktivieren?",
      "disableOptOut": "Opt-out deaktivieren",
      "disableTitle": "Opt-Out-Nachricht deaktivieren?",
      "optInConfirmClient": "Ich bestätige, dass SMS nur an die Kontakte gesendet werden, die sich angemeldet haben.",
      "quickTipMessage": "Die Starter-Nachricht, die Sie an eine Einzelperson hochladen, muss eines der nächsten normalen Opt-out-Schlüsselwörter einbeziehen: STOP, STOPALL, UNSUBSCRIBE, ABBRECHEN, ENDE, Oder QUIT.",
      "reallyDisableConfirm": "Sind Sie wirklich sicher, dass Sie die Abmelde-Nachricht deaktivieren möchten?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "POST-Text anfordern",
        "requestQueryParameters": "Abfrageparameter anfordern",
        "responseBody": "Antworttext"
      },
      "logs": "Protokolle",
      "logsPage": {
        "clearAll": "Alle löschen",
        "loadMore": "Mehr laden",
        "price": "Preis",
        "product": "Produkt",
        "tabsAriaLabel": "Tabs für Zahlungsprotokolle"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Fügen Sie allgemeinen Text hinzu am",
      "beginning": "Beginn",
      "complianceConfirm": "Ich bestätige, dass ich sicherstellen werde, dass alle von diesem Konto gesendeten SMS-Nachrichten in der aktuellen Richtlinie entsprechen.",
      "customizeTitle": "Allgemeinen Text anpassen",
      "disableConfirm": "Möchten Sie SenderID wirklich deaktivieren?",
      "disableSenderID": "SenderID deaktivieren",
      "disableTitle": "SenderID deaktivieren?",
      "end": "Ende",
      "pleaseAdd": "Bitte beziehen Sie {text} ein, wie im Kurztipp erwähnt.",
      "quickTipMessage": "Die erste Nachricht, die Sie an eine Einzelperson senden, muss die Absenderidentifikationsinformationen enthalten. Bitte fügen Sie {text} im allgemeinen Textfeld hinzu.",
      "reallyDisableConfirm": "Möchten Sie SendeID wirklich Deaktivieren ?",
      "senderID": "Absender-ID"
    },
    "shopify": {
      "adminApiAccessToken": "Admin API-Zugriffstoken",
      "apiTokenRequired": "API-Zugriffstoken ist erforderlich",
      "checkDocumentation": "Weitere Details finden Sie in dieser Dokumentation",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Zugriffstoken für die benutzerdefinierte App-API",
      "deleteWarning": "Durch das Löschen wird die bestehende Verbindung entfernt.",
      "existStoreAlertTitle": "Shopify-Store-Integration existiert bereits",
      "integration": "Shopify-Integration",
      "integrationHealth": "Integrationsgesundheit",
      "orders": "Bestellungen",
      "scopePermissionsWarning": "Bitte stellen Sie sicher, dass Ihrer App die mit einem roten Kreuz gekennzeichneten Berechtigungen erteilt wurden.",
      "scopes": "Umfang",
      "scopesDescription": "Für den Zugriff auf die Shopify-Informationen sind Autorisierungsbereiche erforderlich. Aufgrund der neuen Änderungen bei Shopify ist jetzt die Berechtigung read_customers Erforderlich, um volle Details von Kunden zu erhalten, da die Kundenstatistiken von Shopify geschützt sind.",
      "storeConnectedMessage": "Shopify-Shop bereits mit Unterkonto {locationName}verbunden",
      "storeNameHelp": "Der Name Ihres Archivs befindet sich in der URL Ihres Shopify-Kontos – nach https:// und vor .myshopify.",
      "storeNameLabel": "Name Ihres Shopify-Shops",
      "storeNamePlaceholder": "Shopname",
      "storeNameRequired": "Shopname ist erforderlich",
      "typeRemoveConfirm": "Geben Sie „ENTFERNEN“ ein, um die Aktion zu bestätigen",
      "webhooks": "Webhooks",
      "webhooksDescription": "Um alle Ereignisse von Shopify zu empfangen, müssen wir diese Shopify-Webhooks während des Integrationsprozesses registrieren. Diese Webhooks sind unerlässlich, um das ordnungsgemäße Funktionieren der Shopify-Funktionen sicherzustellen."
    },
    "slack": {
      "accountConnected": "Konto verbunden",
      "accountsConnected": "Konten verbunden",
      "accountsList": "Liste aller Slack-Konten",
      "added": "Hinzugefügt {date}.",
      "connectChannel": "Verbinden Sie Ihren Slack-Kanal",
      "description": "Lassen Sie sich sofortige Benachrichtigungen auf Ihrem Slack-Kanal zusenden. Klicken Sie auf „Verbinden“, um einen Slack-Kanal hinzuzufügen.",
      "manage": "Verwalten",
      "manageAccounts": "Slack-Konten verwalten",
      "noIntegrations": "Keine Slack-Integrationen gefunden."
    },
    "smtpService": {
      "addFirstService": "Fügen Sie Ihren ersten SMTP-Dienst hinzu.",
      "addService": "Dienstleistung hinzufügen",
      "bccEmails": "BCC-E-Mails",
      "cannotDeleteDefaultProvider": "Der Standard-Provider kann nicht gelöscht werden.",
      "contactDeveloper": "Kontaktieren Sie den Entwickler dieser App.",
      "customProvider": "Benutzerdefinierter Provider",
      "defaultProvider": "Standard-Provider",
      "defaultProviderUpdated": "Der Standard-Provider wurde aktualisiert!",
      "emailDomain": "Email / Domain",
      "emailService": "EMAIL Service",
      "enableReplyTracking": "Antwort-Tracking aktivieren",
      "forwardToAssignedUser": "An den zugewiesenen Benutzer erneut senden",
      "providerType": "Provider-Typ",
      "smtpConnectionIssue": "Es gibt ein Problem mit dieser SMTP-Verbindung. Bitte stellen Sie diese Integration erneut her.",
      "useLcEmailMessage": "Verwenden Sie LC Email, um E-Mails für Ihre Agentur und Ihre Kunde zu senden."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Auto Posten aktiviert",
      "dailyPostLimit": "Tägliches Beitragslimit",
      "directoriesDescription": "Wenn Sie eine neue Bewertung erhalten, teilen wir sie automatisch in über 80 Online-Verzeichnissen, die dazu beitragen, Ihre Marke und SEO zu stärken.",
      "directoriesTitle": "80+ Verzeichnisse und Websites",
      "fivePosts": "5 veröffentlichen",
      "fiveStars": "5 Sterne",
      "fourPosts": "4 veröffentlichen",
      "fourStars": "4 Sterne",
      "googlePlus": "Google+",
      "manageSettingsDescription": "Passen Sie individuell an, wie und wann Ihre Bewertungen automatisch in Ihren sozialen Netzwerken veröffentlicht werden.",
      "manageSettingsTitle": "Verwalten Sie Ihre Social-Media-Beitragseinstellungen",
      "postReviewsForRating": "Veröffentlichen Sie Rezensionen für diese Bewertung oder höher.",
      "searchEngines": "Suchmaschinen",
      "threePosts": "3 Beiträge",
      "threeStars": "3 Sterne",
      "title": "Beiträge in sozialen Netzwerken"
    },
    "tags": {
      "addNewTag": "Neues Schlüsselwort hinzufügen",
      "allTags": "Alle Schlüsselwörter",
      "deletedTags": "Gelöschte Tags",
      "here": "wiederaufnehmen.",
      "newTag": "Neues Schlüsselwort",
      "noTagsYet": "Noch keine Schlüsselwörter zum Anzeigen",
      "searchTags": "Schlüsselwörter suchen",
      "viewDeletedTags": "Sie können جلöschte Schlüsselwörter auf der Seite „Audit-Protokolle“ anzeigen und zurücksetzen."
    },
    "templateMessage": {
      "addEmailTemplate": "E-Mail-Vorlage hinzufügen (Short-Video)",
      "addTemplate": "Vorlage hochladen (Short-Video)",
      "addTextTemplate": "Textvorlage hinzufügen (Ausschnitt)",
      "body": "Body",
      "deleteTemplateConfirmation": "Möchten Sie diese Vorlage wirklich löschen?",
      "templatesCount": "{count} Vorlagen",
      "title": "Nachrichtenvorlagen (Ausschnitte)"
    },
    "unsubscribe": {
      "content": "Inhalt",
      "contentTooltip": "Der Medien dieser Nachricht wird automatisch zu allen E-Mails hinzugefügt.",
      "customizeTitle": "Abmelde-Inhalte anpassen",
      "disableConfirm": "Möchten Sie den Abmeldelink in E-Mails wirklich deaktivieren?",
      "disableTitle": "Link zum Abbestellen deaktivieren?",
      "disableUnsubscribe": "Deaktivieren Sie die Abmeldung",
      "pleaseAddTag": "Bitte fügen Sie das Tag /*unsubscribe*/ hinzu",
      "reallyDisableConfirm": "Möchten Sie den Abbestellen-Link aus E-Mails wirklich deaktivieren?",
      "subscribedConfirm": "Ich bestätige, dass E-Mails nur an Kontakte gesendet werden, die den Erhalt von E-Mails abonniert haben.",
      "subscribedConfirmClient": "Ich bestätige, dass ich sicherstellen werde, dass E-Mails nur an Kontakte gesendet werden, die den Empfang von E-Mails abonniert haben.",
      "suspensionWarning": "Nicht konforme Aktivitäten können zur Sperrung der E-Mail-Funktionen Ihres Kontos führen.",
      "tagRequirement": "Die erste E-Mail, die Sie an eine Einzelperson senden, muss das Tag /*unsubscribe*/ enthalten."
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "Dies ist die Standard-Voicemail-Nachricht für alle Twilio-Nummern an diesem Standort, es sei denn, diese wird angepasst unter",
      "forwardCallsToWebApp": "Anrufe an die Web-App weiterleiten",
      "forwardCallsToMobileApp": "Anrufe an die mobile App weiterleiten",
      "dedicatedNumberRequiredInfo": "Dies ist nur erforderlich, wenn der Benutzer eine feste Nummer benötigt. Nicht erforderlich für Voicemail oder zur Weiterleitung des Anrufs an den zugewiesenen Benutzer.",
      "voicemailMessageInfo": "Diese Voicemail-Nachricht wird anstelle der Nachricht des Telefonanbieters wiedergegeben. Wir empfehlen ein Timeout von 20 Sekunden oder weniger.",
      "noTimeout": "Kein Timeout",
      "10Secs": "10 Sek.",
      "20Secs": "20 Sek.",
      "voicemailMessageDuration": " Wir werden eine Sprachnachricht aufnehmen, falls der Anruf nicht innerhalb dieser Zeit beantwortet wird",
      "saveCallSettings": "Anrufeinstellungen speichern"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "Wenn dieses Schlüsselwort beim Kontakt vorhanden ist, werden diese Nachrichten NICHT an Eliza zugestellt",
      "sendToElizaNote": "Standardmäßig werden alle Unterhaltungen an Eliza übermittelt. Wenn dieses Schlüsselwort konfiguriert ist, <br />werden neue Unterhaltungen nur an Eliza gesendet, wenn dieses Schlüsselwort bei einem Kontakt vorhanden ist.<br /> Wenn sowohl das Eliza-Umgehungs-Schlüsselwort als auch das „An Eliza senden“-Schlüsselwort konfiguriert sind, wird nur letzteres berücksichtigt",
      "permissionNote": "Ihre Benutzerberechtigungen sind für diese Seite nicht aktiviert. <br />Bitte sprechen Sie mit Ihrem Administrator",
      "addFAQ": "FAQ hinzufügen"
    },
    "locationSettings": {
      "ownCardWarning": "Fügen Sie Ihre eigene Karte nicht zu Unterkonten hinzu!",
      "addClientCardWarning": "Bitte fügen Sie die Karte Ihres Kunden (des Unterkontos) hinzu und nicht Ihre eigene, da diese Karte verwendet wird, um Ihrem Kunden in Ihrem Namen Rechnungen zu stellen.",
      "stripeConnectMissing": "Stripe-Verbindung fehlt",
      "pleaseContactAgencyToAddPaymentMethods": "Bitte kontaktieren Sie die Agentur ({email}), um Zahlungsmethoden hinzuzufügen."
    },
    "integrations": {
      "connectWaveAccount": "Verbinden Sie das Wave-Konto Ihres Standorts",
      "connectXeroAccount": "Verbinden Sie das Xero-Konto Ihres Standorts"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "Die GBP-Anrufverfolgung ist auf einem anderen Unterkonto aktiviert. Die Anrufverfolgung kann jeweils für ein einzelnes Unterkonto aktiviert werden.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP-Anrufverfolgung ist auf einer anderen Seite aktiviert ({pageName}). Anrufverfolgung kann jeweils für ein einzelnes Unterkonto & eine einzelne Seite pro Standort aktiviert werden.",
      "gbpCallsProperlySetup": "GBP-Anrufe sind ordnungsgemäß eingerichtet und Anrufe kommen herein von",
      "tooManyEditsToPrimaryPhone": "Sie haben für dieses Geschäft zu viele Änderungen am Haupttelefon vorgenommen. Bitte versuchen Sie es später erneut.",
      "setupTwilioToStartCallTracking": "Richten Sie Twilio ein, um die Anrufverfolgung zu starten.",
      "twoSecondaryNumbersSetupAlready": "Sie haben bereits zwei Zweitnummern eingerichtet, daher ist ein Tausch der Nummern nicht möglich.",
      "yourAgentIDIs": "Ihre Agenten-ID ist"
    },
    "numberPool": {
      "title": "Was zu verfolgen ist",
      "tracking": {
        "percentComplete": "34 % abgeschlossen",
        "searchLower": "Suche"
      },
      "create": {
        "title": "Tracking-Nummer erstellen"
      }
    },
    "phoneNumbers": {
      "title": "Was zu verfolgen ist",
      "tracking": {
        "percentComplete": "34 % abgeschlossen",
        "heading": "Tracking-Nummer erstellen"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Gib einen Wert ein",
      "selectOption": "* Wähle eine Option"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* Mindestens ein {filterName} ist erforderlich",
      "select": "{filterName}auswählen"
    },
    "newEmailStats": {
      "timeStamp": "Zeitstempel"
    },
    "recordsNav": {
      "clickToReloadList": "Klicken Sie, um die Liste zu aktualisieren."
    },
    "reviewRequestActions": {
      "emailReviewReq": "E-Mail-Bewertungsanfrage",
      "smsReviewReq": "SMS-Bewertungsanfrage",
      "whatsappReviewReq": "WhatsApp-Bewertungsanfrage"
    },
    "smartListFilters": {
      "clearAllFilters": "Alle Filter zurücksetzen",
      "noneFound": "nichts gefunden",
      "saveChangesToList": "Filteränderungen in dieser intelligenten Liste speichern",
      "saveCombinationAsNew": "Speichern Sie die Integration von Filtern, Spalten und Sortierung als neue intelligente Liste",
      "saveCurrentAsNew": "Aktuelle Filter als neue intelligente Liste speichern",
      "searchAndAddFilter": "Filter suchen und hinzufügen",
      "searching": "wird gesucht...",
      "undoUnsavedChanges": "Nicht gespeicherte Änderungen rückgängig machen"
    },
    "smsStatsPanel": {
      "smsStats": "SMS-Statistiken"
    },
    "manageDuplicates": "Duplikate Verwalten",
    "emailAction": {
      "attachFiles": "Dateien anhängen",
      "customValues": "Benutzerdefinierte Werte",
      "triggerLinks": "Trigger-Links"
    },
    "atLeastOneRequired": "* Mindestens ein {filterName} ist erforderlich",
    "arrayInput": {
      "searchPlaceholder": "{filterName}suchen",
      "searching": "Suche erfolgt …"
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Fehler beim Abrufen der Schnappschuss-Inhalte",
      "overwriteAll": "Alles überschreiben",
      "skipAll": "Alles überspringen",
      "somethingWentWrongWhileFindingConflicts": "Bei der Ermittlung von Konflikten ist ein Fehler aufgetreten",
      "step": "Schritt"
    },
    "confirmOverwrite": {
      "confirmButton": "Überschreiben bestätigen",
      "description": "Diese Aktion ist unwiderruflich und kann die Einstellungen von Kampagnen, Interessenten, Funnels usw. ändern. Bitte bestätigen Sie Ihre Aktion, indem Sie Folgendes eingeben.",
      "title": "Sind Sie sicher, dass Sie die ausgewählten Daten überschreiben möchten?"
    },
    "conflicts": {
      "noConflictsDetected": "Keine Konflikte festgestellt",
      "overwrite": "Überschreiben"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Verknüpfte Assets gefunden",
      "checkingConflicts": "Auf Konflikte prüfen",
      "chooseSnapshot": "Schnappschuss auswählen",
      "copyingDataNotification": "Daten werden an ausgewählte Speicherorte kopiert. Bitte warten Sie …",
      "linkedLocations": "Verknüpfte Standorte",
      "noConflictsFound": "Keine Konflikte gefunden",
      "notAuthorizedMessage": "Diese Aktion kann nur von Administratoren der Agentur durchgeführt werden",
      "overwriteConflicts": "Konflikte überschreiben",
      "pickSnapshot": "Schnappschuss auswählen",
      "response": "Antwort",
      "selectAssetsToPush": "Zu übertragende Assets auswählen",
      "selectLocationsToUpdate": "Standorte zur Aktualisierung auswählen",
      "snapshotNotAuthorized": "Dieser Schnappschuss ist für diesen Standort nicht freigegeben",
      "snapshotNotSelected": "Schnappschuss nicht ausgewählt"
    },
    "share": {
      "agencyRestrictedLink": "Privatlink der Agentur",
      "deleteShareLink": "Link zum Teilen löschen",
      "editShareLink": "Link zum Teilen bearbeiten",
      "permanentLink": "Permanenter Link",
      "subaccountRestrictedLink": "Privatlink für Unterkonto"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Nach jeder Beziehungsnummer ein Komma (<span class='text-base font-bold'> , </span>) einfügen)",
      "addCommaAfterEachSubAccount": "(Nach jeder Unterkonto-ID ein Komma (<span class='text-base font-bold'> , </span>) einfügen)",
      "atLeast1EmailRequired": "Mindestens 1 E-Mail-Adresse ist erforderlich.",
      "emailShareLink": "E-Mail-Link zum Teilen",
      "enterOnePerLine": "(Bitte pro Zeile eintragen)",
      "errorGettingLink": "Beim Abruf des Links ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal!",
      "getAgencyRestrictedLink": "Privatlink für Agentur abrufen",
      "getLink": "Link abrufen",
      "getOneTimeLink": "Einmaligen Link zum Teilen abrufen",
      "getPermanentLink": "Dauerhaften Link abrufen",
      "getSubAccountRestrictedLink": "Privatlink für Unterkonto abrufen",
      "shareType": "Typ teilen",
      "title": "Schnappschuss teilen"
    },
    "snapshot": {
      "copySnapshotID": "Schnappschuss-ID kopieren",
      "deleteSnapshot": "Schnappschuss löschen",
      "editSnapshot": "Schnappschuss bearbeiten",
      "pushUpdate": "Aktualisierung an verknüpfte Konten senden",
      "refreshSnapshot": "Aktualisieren Sie den Schnappschuss"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Nach jeder Beziehungsnummer ein Komma einfügen)",
      "addCommaAfterEachSubAccount": "(Nach jeder Unterkonto-ID ein Komma einfügen)",
      "title": "Freigabelink aktualisieren"
    }
  },
  "socialMedia": {
    "engagement": "Engagement",
    "potentialReach": "Potenzielle Reichweite",
    "storiesCreated": "Erstellte Stories",
    "recentPosts": "Neueste Beiträge",
    "notConnected": "Nicht verbunden (Jetzt verbinden!)",
    "totalAudience": "Gesamtes Publikum",
    "activeAudience": "Aktive Zielgruppe",
    "socialMediaOverview": "Soziale Medien Übersicht"
  },
  "suspendModal": {
    "currentStatus": "Aktueller Abonnementstatus: Pausiert",
    "instructions": "Mit einigen einfachen Schritten können Sie dieses Unterkonto {action}",
    "nextBillingDate": "Nächstes Rechnungsdatum:",
    "noKeepCharging": "Nein, berechnen Sie den Kunden weiterhin.",
    "pauseSubscriptionQuestion": "Möchten Sie das Abonnement mit dem Unterkonto zusammen pausieren?",
    "resumeSubAccount": "Unterkonto wiederaufnehmen",
    "resuming": "Wird wieder aufgenommen …",
    "saasSubscriptionActive": "Dieses Unterkonto verfügt über ein aktives SaaS-Abonnement.",
    "saasSubscriptionResumed": "Das SaaS-Abonnement dieses Kontos wird fortgesetzt.",
    "yesPause": "Ja, Abonnement pausieren"
  },
  "table": {
    "perPageOptions": {
      "5": "5 je Seite",
      "10": "10 pro Seite",
      "15": "15 pro Seite",
      "20": "20 pro Seite",
      "25": "25 pro Seite",
      "50": "50 je Seite",
      "100": "100 pro Seite"
    },
    "filterPlaceholder": "Suchen...",
    "emptyText": "Keine Datensätze gefunden",
    "loading": "Wird geladen…",
    "showingEntries": "Anzeigen von {from} bis {to} von {total} Einträgen",
    "noEntriesToShow": "Keine Einträge zum Anzeigen"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Kontodaten werden geladen …",
      "toContinueWith": "um mit Nächste fortzufahren"
    },
    "switcherModal": {
      "comingSoon": "Demnächst verfügbar!",
      "multiLocationMessage": "Diese Funktion ist derzeit nur für Einzelkonten verfügbar. Wir arbeiten intensiv daran, dies bald auch für Konten mit mehreren Standorten anzubieten."
    },
    "importedMessage": "{productName} wurde importiert! Sie finden es in der Vorlagenbibliothek unter dem Tab {productName}.",
    "permissionErrorMsg": "Diese Option ist nur in höheren Plänen verfügbar. Jetzt upgraden und freischalten.",
    "errors": {
      "sourceDeleted": "Fehler: Die Quellvorlage wurde gelöscht. Sie ist nicht mehr verfügbar. Bitte überprüfen Sie den Status der Vorlage oder kontaktieren Sie die Quelle, um Hilfe zu erhalten.",
      "sourceDraft": "Fehler: Die Quellvorlage wurde in Entwürfe verschoben. Bitte überprüfen Sie den Status der Vorlage oder kontaktieren Sie die Quelle, um Hilfe zu erhalten.",
      "linkedDeleted": "Fehler: Die Quellvorlage, die mit der freigegebenen Vorlage verknüpft ist, wurde gelöscht. Bitte überprüfen Sie den Status der Vorlage oder kontaktieren Sie die Quelle, um Hilfe zu erhalten.",
      "fetchError": "Beim Abrufen der {productName}-Details ist ein Fehler aufgetreten. Bitte überprüfen Sie die URL oder versuchen Sie es erneut!",
      "sameAgency": "Die Vorlage kann nicht innerhalb derselben Agentur geteilt werden"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Die Aktion „Kontakt-Tag hinzufügen“ erfordert ein Tag.",
    "addNotesRequiresData": "Die Aktion „Notizen hinzufügen“ erfordert Notizdaten.",
    "addTaskRequiresFields": "Die Aktion „Aufgabe hinzufügen“ erfordert einen Titel und die Angabe „Fällig in einem Tag“.",
    "addToCampaignRequiresCampaign": "Das Hinzufügen zur Kampagne erfordert eine Kampagne.",
    "addToCustomAudienceRequires": "Die Aktion „Zur benutzerdefinierten Zielgruppe hinzufügen“ erfordert ein Werbekonto und eine benutzerdefinierte Zielgruppe.",
    "addTrigger": "Auslöser hinzufügen",
    "anyAction": "Jede beliebige Aktion",
    "anyCondition": "Jede Bedingung",
    "brokenCustomVariables": "Ein Feld bzw. einige Felder enthalten fehlerhafte benutzerdefinierte Variablen. Bitte korrigieren Sie diese vor dem Speichern.",
    "conditionCannotBeEmpty": "Status '{condition}' darf nicht leer sein",
    "confirmDeleteTrigger": "Sind Sie sicher, dass Sie diesen Auslöser löschen wollen?",
    "customDateFieldRequired": "Für den Auslöser „Benutzerdefinierte Datumserinnerung“ ist ein benutzerdefinierter Datumsfeldfilter erforderlich.",
    "detailPage": {
      "chooseTriggerPlaceholder": "Wählen Sie einen Auslöser",
      "lastUpdate": "Letzte Aktualisierung:",
      "loopIdentifiedWarning": "Dieser Auslöser wurde im Entwurf Reputationen gesperrt, weil er einen Loop verursacht. Um diesen Auslöser zu aktivieren, wenden Sie sich bitte an den Support.",
      "ruleNotActiveWarning": "Diese Regel wird nicht ausgeführt, bis Sie sie Auslöser.",
      "triggerCreation": "Erstellung von Auslösern:",
      "triggerDeletedPrompt": "Dieser Auslöser wurde gelöscht! Möchten Sie es wiederherstellen?",
      "triggerRunDailyTooltip": "Auslöser wird täglich um 8:00 Uhr ausgeführt",
      "whatTriggersRule": "Was sollte diese Regel auslösen?",
      "whichEventTriggersAutomation": "Welche Veranstaltung sollte diese Automatisierung auslösen?"
    },
    "dndContactRequiresState": "Die Kontaktaktion „DND“ erfordert, dass der Status „DND“ aktiviert ist.",
    "emptyConditionNotAllowed": "Ein leerer Status ist nicht erlaubt.",
    "emptyFieldNotAllowed": "Leere Felder sind nicht zulässig.",
    "executeWebhookRequiresUrl": "Für die Ausführung der Webhook-Aktion ist eine Webhook-URL erforderlich.",
    "fieldCannotBeEmpty": "{field} darf nicht leer sein",
    "fillRequiredFields": "Bitte füllen Sie alle erforderlichen Felder in den Aktivitäten aus.",
    "googleAdwordsRequiresConversion": "Die Aktion „Zu Google AdWords hinzufügen“ erfordert eine Conversion.",
    "googleAnalyticsRequiresFields": "Das Hinzufügen einer Aktion zu Google-Analytics erfordert eine id, eine Aktionstyp und eine Aktionskategorie",
    "membershipGrantOfferRequiresOffer": "Die Gewährung einer Mitgliedschaftszusage erfordert ein Angebot.",
    "membershipRemoveOfferRequiresOffer": "Die Aktion zum Entfernen der Mitgliedschaft erfordert ein Angebot.",
    "newBasicRule": "Neue Grundregel",
    "opportunitiesRequirePipeline": "Für die Aktion „Chancen“ müssen Sie eine Pipeline auswählen.",
    "opportunityLoopWarning": "Dieser Auslöser führt zu einer Endlosschleife bei der Opportunity-Erstellung. Bitte entfernen Sie die Option „Doppelte Verkaufschancen zulassen“ oder ändern Sie die Phase, auf die Sie sich beziehen.",
    "removeContactTagRequiresTag": "Kontakt Tag löschen. Für die Aktion ist ein Label erforderlich.",
    "removeFromCampaignRequiresCampaign": "Die Entfernung aus der Kampagne erfordert eine Kampagne.",
    "removeFromCustomAudienceRequires": "Die Aktion „Aus benutzerdefinierter Zielgruppe entfernen“ erfordert ein Werbekonto und eine benutzerdefinierte Zielgruppe.",
    "rulesBasedOn": "Regeln, die basieren auf",
    "selectUserForNotification": "Wählen Sie den Benutzer aus, dem eine Benachrichtigung gesendet werden soll.",
    "sendEmailRequiresFields": "Die Aktion zum Senden einer E-Mail erfordert die Angaben Von, An, Betreff und Nachricht.",
    "sendNotificationRequiresFields": "Für die Aktion „Benachrichtigung senden“ sind Titel, Nachrichtentext und Benutzertyp erforderlich.",
    "sendSmsRequiresFields": "Für die Aktion „SMS senden“ sind Anzahl und Nachricht erforderlich.",
    "stripeMinAmountUSD": "Die Menge muss mindestens 50 Cent USD betragen.",
    "stripeRequiresFields": "Für eine einmalige Abbuchung mit Stripe werden Kunden-ID, Betrag und Währung benötigt.",
    "thatWillFire": "das ausgelöst wird",
    "triggerCannotBeEmpty": "Der Auslöser darf nicht leer sein",
    "updateContactFieldRequires": "Das Feld „Kontakt aktualisieren“ sollte mindestens ein Feld enthalten."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "${amount} bezahlen und abonnieren",
      "commitment": "Keine Verpflichtung, jederzeit kündbar",
      "features": {
        "billedOnUsage": "Die Abrechnung erfolgt nutzungsbasiert, sobald das Limit überschritten wird",
        "externalAI": "Externe AI-Model-Aktivitäten ausgeschlossen – werden separat in Rechnung gestellt",
        "leadingPricing": "Branchenführende Preisgestaltung!",
        "monthlyPurchase": "Gültig für einen Kauf pro Monat",
        "premiumActions": "Gilt für Premium-Aktivitäten und Auslöser"
      },
      "planDetails": "Tarif-Einzelheiten",
      "subscribeAndSave": "Jetzt abonnieren und sparen!",
      "title": "${amount} für {executions} Ausführungen pro Monat"
    }
  },
  "appointmentWidget": {
    "movedMessage": "Diese Einstellung wurde auf die Kalenderseite verschoben.",
    "toNavigate": "zur Navigation. Diese Seite wird bald entfernt."
  },
  "attribution": {
    "description": "Die erste Interaktion ist schlichtweg der erste Kontaktpunkt eines Nutzers. Wenn also jemand Sie zuerst über eine bezahlte Suchanzeige (PPC) entdeckt hat, würde diesem Kanal die Konversion zugewiesen werden. Die letzte Interaktion wäre hingegen der letzte Kanal.",
    "firstInteraction": "Erste Nachricht",
    "lastInteraction": "Letzte Interaktion",
    "title": "Attribution"
  },
  "campaign": {
    "addEvent": "Veranstaltung hinzufügen",
    "a2p": {
      "address": {
        "chooseState": "Bundesland auswählen …",
        "city": "Stadt*",
        "postalCode": "Postleitzahl*",
        "streetAddress": "Anschrift*",
        "streetAddressHelper": "Es muss sich um eine gültige Adresse handeln, die mit Ihrem Unternehmen verknüpft ist.",
        "title": "Geschäftsadresse"
      },
      "addressError": {
        "title": "Adresseneinreichung fehlgeschlagen"
      },
      "authorizedRep": {
        "jobPosition": "Stellenbezeichnung*",
        "jobTitle": "Berufsbezeichnung*",
        "title": "Details zum bevollmächtigten Vertreter"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Einzelunternehmermarke",
          "point1": "Nur eine Rufnummer erlaubt",
          "point2": "EIN/SSN/DUNS nicht erforderlich"
        },
        "solePropCampaign": {
          "heading": "Einzelunternehmerkampagne",
          "point1": "Nur eine Nummer darf mit einer Sole Prop Kampagne verknüpft werden.",
          "point2": "Sobald genehmigt, wird Ihre Standardnummer automatisch verknüpft.",
          "infoText": "Sie können die Nummer auch nach der Genehmigung aktualisieren",
          "warningText": "Nur eine Nummer darf mit einer Einzelunternehmerkampagne verknüpft werden. Nach der Genehmigung wird Ihre Standardnummer automatisch verknüpft. Sie können die Nummer auch nach der Genehmigung aktualisieren."
        },
        "solePropSubtitle": "Details für Einzelunternehmermarke und -kampagnen",
        "standardBrand": {
          "heading": "4,41 $ – Einmalig",
          "point1": "EIN/SSN/DUNS erforderlich",
          "point2": "Mehr als eine Rufnummer erlaubt"
        },
        "standardCampaign": {
          "heading": "16,54 $ – einmalig",
          "point1": "Mehr als eine Nummer darf mit einer Standardkampagne verknüpft werden.",
          "point2": "EIN/SSN/DUNS erforderlich",
          "infoText": "Eine zusätzliche Kampagnengebühr von bis zu 12 $ pro Monat wird gemäß den TCR-Regeln angewendet."
        },
        "standardSubtitle": "Standarddetails für Marke und Kampagnen",
        "title": "Marken- und Kampagnendetails"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Kontaktinformationen",
          "contactInfoSubtitle": "Dies kann jede Person sein, die bei Bedarf Fragen zu dieser Marke beantworten kann. Bitte beachten Sie, dass Kontaktinformationen nicht markenübergreifend wiederverwendet werden können. Jede von Ihnen erstellte Marke muss über eindeutige Kontaktinformationen verfügen.",
          "emailHelper": "Verwenden Sie nicht dieselbe E-Mail-Adresse für mehr als 5 Marken.",
          "phoneNumberHelper": "Verwenden Sie nicht dieselbe Rufnummer für mehr als 5 Marken.",
          "profileName": "Firmenname oder Ihr Vor- und Nachname*",
          "profileNameHelper": "Verwenden Sie entweder den rechtlichen Namen der Organisation, die die Nachrichten versendet, oder Ihren eigenen Namen, falls diese Marke keine Organisation ist.",
          "nextLoading": "Nächste...",
          "invalidPhoneNumber": "Ungültige Telefonnummer",
          "phoneNumberWithCountryCode": "Telefonnummer (mit Ländervorwahl)*",
          "phoneNumberRequired": "Rufnummer ist erforderlich.",
          "emailRequired": "E-Mail ist erforderlich.",
          "profileNameRequired": "Der Profilname ist erforderlich."
        },
        "standard": {
          "businessType": "Unternehmenstyp*",
          "legalBusinessName": "Gesetzlicher Firmenname*",
          "legalBusinessNameHelper": "Geben Sie den genauen Firmennamen an, wie er bei der Regierung registriert und in Ihren Steuerunterlagen (CP 575) angegeben ist. Z. B. LeadConnector LLC statt LeadConnector.",
          "regionsOfOperations": "Geschäftsregionen*",
          "registrationNumber": "Unternehmensregisternummer*",
          "registrationNumberHelper": "Die Nummer, die zur Identifikation Ihres Unternehmens verwendet wird. Im Falle einer US-EIN muss es sich um eine 9-stellige Nummer handeln, z. B. 12-3456789.",
          "registrationType": "Unternehmensregistrierungs-ID-Typ*",
          "website": "Unternehmens-Website*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Schritt {currentStep} von {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Ihr Geschäftsprofil wurde erfolgreich übermittelt.",
        "startA2P": "A2P-Registrierung starten",
        "title": "Unternehmensprofil erfolgreich übermittelt",
        "tooltips": {
          "agency": "Agenturnutzer können mit der A2P-Registrierung beginnen.",
          "location": "Standortbenutzer können die A2P-Registrierung starten."
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Beispiel schließen",
          "optInKeywords": "Opt-in-Schlüsselwörter*",
          "optInKeywordsHelper": "Höchstlänge: 255 Zeichen.",
          "optInKeywordsPlaceholder": "Schlüsselwörter durch Komma getrennt, Beispiel: ABONNIEREN, START.",
          "optInMessage": "Opt-in-Nachricht*",
          "optInMessageInfo": "Muss den Firmennamen und das Opt-out-Schlüsselwort enthalten",
          "optInMessagePlaceholder": "Beispiel: Sie haben sich erfolgreich für den Empfang von Benachrichtigungen und Werbe-SMS von Name_des_Unternehmens angemeldet. Bitte antworten Sie mit STOPP, wenn Sie sich davon abmelden möchten.",
          "placeholder": "Beispiel: Endbenutzer melden sich an, indem sie unsere Website besuchen und dort ihre Details eingeben. Benutzer setzen ein Häkchen, um Benachrichtigungen und Werbenachrichten von uns zu erhalten und ihre Zustimmung zu erteilen. Endbenutzer können auch eine SMS mit dem Text START an +1 (213) 725-2867 senden.",
          "question": "Wie erteilen Endbenutzer ihre Einwilligung zum Empfang von Nachrichten?*",
          "seeExample": "Beispiel ansehen"
        },
        "messageDetails": {
          "embeddedLink": "Die Nachricht wird eine eingebettete Verknüpfung enthalten",
          "phoneNumbers": "Die Nachrichten werden Rufnummern enthalten",
          "sampleMessage1Placeholder": "Beispiel: Hallo John! Hier ist Jane von Name_des_Unternehmens. Hiermit bestätige ich unseren Termin am 20. Juli um 11:00 Uhr. Bitte kontaktieren Sie +1(213) 725-2867, falls Sie Ihren Termin verschieben müssen. Antworten Sie mit STOPP, um sich abzumelden.",
          "sampleMessage2Placeholder": "Beispiel: Hallo Brian! Hier ist Jane von company_name. Ich sehe, dass Sie unseren Termin nicht wahrnehmen konnten. Möchten Sie den Termin verschieben? - https://www.mycompany.com/book. Antworten Sie mit STOP, um sich abzumelden.",
          "sampleMessageInfo": "Muss den Namen des Leads, Ihren Namen, Ihren Firmennamen und die Opt-out-Möglichkeit enthalten",
          "subtitle": "Beispielnachrichten hinzufügen"
        },
        "useCaseDetails": {
          "explainInDetail": "Bitte erläutern Sie dies ausführlicher",
          "pickUseCase": "Kampagnenanwendungsfall auswählen",
          "solePropLabel": "Einzelunternehmer",
          "subtitle": "Geben Sie die Kampagnendetails und -beschreibung ein",
          "useCase": "Kampagnenanwendungsfall*",
          "useCaseDescription": "Beschreibung des Anwendungsfalls*",
          "useCaseDescriptionPlaceholder": "Beispiel: Diese Kampagne sendet Terminbestätigungs- und Erinnerungsnachrichten an unsere Kunden, sobald diese einen Termin über unsere Website gebucht und sich für den Erhalt von Werbe- und Benachrichtigungs-SMS von uns angemeldet haben."
        }
      },
      "einModal": {
        "disableNoEINText": "Nur Unternehmen mit einer gültigen Adresse in den USA und Kanada dürfen die A2P-Marke ohne Steuer-ID registrieren.",
        "hasEIN": "Ja, das Unternehmen, das ich registriere, hat eine Steuer-ID (z. B. EIN, CCN usw.).",
        "infoText": "Sie finden Ihre US-EIN auf Ihrem CP 575-Formular.",
        "noEIN": "Nein, das Unternehmen, das ich registriere, hat keine Steuer-ID (z. B. EIN, CCN usw.).",
        "question": "Hat das Unternehmen, das Sie registrieren, eine Steuer-ID (z. B. EIN, CCN usw.)?*",
        "title": "Ermittlung der A2P-Markenbedürfnisse"
      },
      "exampleModal": {
        "examples": "Beispiele"
      },
      "otpError": {
        "message": "Beim Senden des OTP ist ein Problem aufgetreten.",
        "title": "OTP konnte nicht erneut gesendet werden"
      },
      "otpSuccess": {
        "title": "Ihr OTP wurde gesendet."
      },
      "validation": {
        "cityRequired": "Stadt ist erforderlich.",
        "countryRequired": "Land ist erforderlich.",
        "invalidMobileNumber": "Ungültige Mobilrufnummer",
        "postalCodeRequired": "Postleitzahl ist erforderlich.",
        "stateRequired": "Bundesland ist erforderlich.",
        "streetAddressRequired": "Anschrift ist erforderlich."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Inhaber der Agentur",
      "agencyOwnerAndAdmins": "Agenturinhaber und Administratoren",
      "contactAgencyOwner": "Wenn Sie Unterstützung benötigen, wenden Sie sich bitte an Ihren",
      "firstPromoterAccessMessage": "Dieser FirstPromoter-Bericht ist nur zugänglich für die",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Es konnte kein Partner gefunden werden, der Ihren Filtern entspricht. Klicken Sie",
      "paymentDetailsAccessMessage": "Der Zugriff auf und die Bearbeitung dieses Zahlungsdetailabschnitts sind nur erlaubt für",
      "toApplyPartner": "um sich als Partner zu bewerben."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Dokument"
      },
      "loading": "Wird geladen",
      "legalBusinessNameHelper": "Geben Sie den genauen Firmennamen an, wie er bei der Regierung registriert und in Ihren Steuerunterlagen (CP 575) angegeben ist. Z. B. Leadconnector LLC statt Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Klicken Sie auf <span class='font-semibold'>„HighLevel öffnen“</span>, um die Desktop-App zu öffnen.<br>Funktioniert es nicht? Sie können <a href=\"/\" class='!text-blue-700 hover:underline'>HighLevel in Ihrem Browser nutzen</a>",
        "launchingTitle": "HighLevel Desktop starten",
        "launchButtonText": "HighLevel öffnen"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Klicken Sie auf <span class='font-semibold'>„LeadConnector öffnen“</span>, um die Desktop-App zu öffnen.<br>Funktioniert es nicht? Sie können <a href=\"/\" class='!text-blue-700 hover:underline'>LeadConnector in Ihrem Browser nutzen</a>",
        "launchingTitle": "LeadConnector Desktop starten",
        "launchButtonText": "LeadConnector öffnen"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Wählen Sie eine Aktion aus",
        "destination": "Ziel",
        "removeFromAllCampaigns": "Diese Aktion wird Leads aus allen Kampagnen außer der aktuellen Kampagne entfernen",
        "triggerLinks": "Trigger-Links"
      },
      "importTemplate": {
        "errorImporting": "Fehler beim Importieren der Vorlage!",
        "importTemplate": "Vorlage importieren",
        "importing": "Import erfolgt",
        "title": "{entityName}-Vorlage importieren",
        "unnamedEntity": "Unbenannte {entityName}-Kopie"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "unter",
          "confirmByTyping": "Bitte bestätigen Sie, indem Sie eingeben",
          "confirmWord": "BESTÄTIGEN",
          "existingNotMoved": "Falls ein Kunde bereits über eine Mailgun- oder SMTP-Konfiguration verfügt, wird er nicht migriert",
          "notNow": "Nicht jetzt",
          "pricingInfo": "LC Email ist günstiger als Mailgun und kostet etwa 0,68 $ für 1.000 E-Mails",
          "setAsDefault": "Legen Sie LC Email als Standardanbieter für Ihre Agentur und die Kunden fest, die noch nicht über Mailgun oder SMTP verfügen",
          "thisWill": "Dies wird:",
          "title": "Sie migrieren zu LeadConnector Email",
          "useLcEmail": "LC Email verwenden"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Medien hier ablegen",
        "editPost": "Beitrag bearbeiten",
        "enterText": "Hier Text eingeben",
        "exampleComment": "Sehr cool! Wir freuen uns darauf!",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#toll",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Bewertung erforderlich?",
        "network": "Netzwerk",
        "photo": "Foto",
        "previewPost": "Beitragsvorschau",
        "selectNetwork": "Soziales Netzwerk auswählen",
        "sizeExample": "245 kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "Sie haben einen Nummernpool mit {count} Nummern erstellt, um Besucher auf Ihrer Website zu verfolgen. <br />Ihre Anrufe werden weitergeleitet an",
          "createdSingle": "Sie haben {count} Nummer erstellt, um Besucher auf Ihrer Website zu verfolgen. <br />Ihre Anrufe werden weitergeleitet an",
          "percentComplete": "100 % abgeschlossen"
        },
        "create": {
          "correctErrors": "Korrigieren Sie die Fehler!",
          "forwardHelp": "Teilen Sie uns mit, welches Telefon klingeln soll, wenn der Kunde Ihre Tracking-Telefonnummer anruft. Dies ist üblicherweise Ihre primäre geschäftliche Rufnummer. Beispiel: 404-555-1212",
          "heading": "Nummernpools und Anrufweiterleitung",
          "nameHelp": "Wir verwenden „{name}“ als Bezeichnung dieser Tracking-Nummer in Ihrem Konto. Wählen Sie einen kurzen und einprägsamen Namen.",
          "newTrackingNumbers": "neue Tracking-Nummern.",
          "nextTracking": "Nächster Schritt: Tracking-Optionen",
          "percentComplete": "50 % abgeschlossen",
          "pleaseConfirm": "Bitte bestätigen Sie:",
          "poolSize": "Pool-Größe",
          "poolSizeError": "Geben Sie eine Poolgröße zwischen 4 und 30 Trackingnummern ein.",
          "poolSizeHelp": "Die Größe Ihres Nummernpools bestimmt, wie viele gleichzeitige Besucher wir auf Ihrer Website nachverfolgen können. Die Poolgröße sollte ein Viertel des stündlichen Spitzenverkehrs (laut Google Analytics) betragen, mit mindestens 4 Nummern.",
          "swappingHelp": "Teilen Sie uns mit, welche Rufnummer wir auf der Website austauschen sollen. Beispiel: 404-555-1212",
          "swappingNumber": "Tauschnummer",
          "validationError": "Bei der Validierung des Formulars ist ein Fehler aufgetreten"
        },
        "features": {
          "activateNumber": "Nummer aktivieren",
          "address": "{type}-Adresse",
          "addressHelp": "Für einige Länder ist eine Anschrift erforderlich. Bitte wenden Sie sich an den Support, falls Sie Hilfe beim Hinzufügen einer Adresse benötigen.",
          "heading": "Nummerneigenschaften",
          "leaveBlank": "Lassen Sie das Feld leer, um keine Nachricht zu senden",
          "recordingDescription": "Aktivieren Sie die Anrufaufzeichnung und spielen Sie dem Anrufer eine kurze Nachricht ab.",
          "recordingHelp": "Einige Rechtsordnungen verlangen die Zustimmung beider Parteien für die Gesprächsaufzeichnung. Um die Einhaltung der entsprechenden Gesetze zu unterstützen, können Sie Anrufern eine Begrüßung mit der Information vorspielen, dass der Anruf möglicherweise aufgezeichnet wird.",
          "whisperDescription": "Eine kurze Nachricht, die vor dem Anruf abgespielt wird. Der Anrufer hört diese Nachricht nicht."
        },
        "tracking": {
          "heading": "Tracking-Optionen",
          "nextCreatePool": "Nächster Schritt: Pool erstellen",
          "percentComplete": "34 % abgeschlossen",
          "searchLower": "Suche"
        },
        "whatToTrack": {
          "heading": "Was möchten Sie auf Ihrer Website nachverfolgen?",
          "trackCampaign": "Marketing-Kampagne verfolgen",
          "trackCampaignDescription": "Erstellen Sie eine Rufnummer, die alle Anrufer einer einzigen Marketingkampagne nachverfolgt.",
          "trackVisitor": "Besucheraktivität nachverfolgen",
          "trackVisitorDescription": "Erstellen Sie mehrere Nummern, die Anrufe mit Website-Besuchern, PPC-Schlüsselwörtern und anderen Kampagnenaspekten korrelieren."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "klicken Sie hier, um zu aktualisieren.",
      "issuesLoadingApp": "Falls Sie Probleme beim Laden der App haben,",
      "loadingFreshData": "Neue Daten werden geladen …",
      "loadingNewSubAccountData": "Neue Unterkontodaten werden geladen …"
    },
    "login": {
      "bySigningInYouAgree": "Durch Ihre Anmeldung stimmen Sie unseren <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Allgemeinen Geschäftsbedingungen</a> zu",
      "newPasswordSent": "Ein neues Passwort wird an Ihre E-Mail-Adresse gesendet."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "Von:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Partner-Abzeichen"
        },
        "checkout": {
          "cardInformation": "Karteninformationen",
          "cardNumberInvalid": "Ihre Kartennummer ist ungültig.",
          "commitment": "Verpflichtung",
          "consentOneTime": "Mit Ihrer Bestätigung gestatten Sie LeadConnector, Ihre Karte für diese Zahlung zu belasten.",
          "consentSubscription": "Indem Sie Ihr Abonnement bestätigen, erlauben Sie LeadConnector, Ihre Karte für diese Zahlung und zukünftige Zahlungen für dieses Abonnement zu belasten",
          "defaultIntervalCount": "1",
          "endingIn": "endet in",
          "errorImageAlt": "Symbol für Fehler",
          "intervalSuffix": "(s)",
          "month": "Monat",
          "pay": "Bezahlen",
          "payWithCard": "Mit Karte bezahlen",
          "paymentProcessing": "Die Zahlung wird gerade bearbeitet. Bitte laden Sie die Seite nicht neu und klicken Sie nicht auf die Zurück-Schaltfläche",
          "proceedWithExistingCard": "Mit vorhandener Karte fortfahren",
          "proceedWithNewCard": "Mit neuer Karte fortfahren",
          "prorationDetails": "Für den Zeitraum bis zum {billingEnd} werden Ihnen jetzt {days} Tage in Rechnung gestellt, und ab dem {billingDate} wird Ihnen der volle Betrag von ${amount}/Monat in Rechnung gestellt.",
          "prorationMessage": "Die anfänglichen Gebühren werden anteilig berechnet, und die reguläre Abrechnung beginnt am {billingDate}",
          "purchase": "Kauf",
          "subscribe": "Abonnieren",
          "subscribeTo": "Abonnieren Sie",
          "updateCardDetails": "Bitte aktualisieren Sie die Kartendetails",
          "zip": "zip"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Schritt {currentStep} von 8",
          "successDescription": "Ihre A2P-Marke und -Kampagne wurden eingereicht.",
          "successMessage": "Hinweis: Sie werden von TCR zur Überprüfung eine OTP-Nachricht auf die angegebene Mobilrufnummer erhalten. Bitte antworten Sie innerhalb von 24 Stunden nach Erhalt der SMS mit „Ja“.",
          "successWaitDays": "7 Tage",
          "successWaitPrefix": "Es könnte bis zu ",
          "successWaitSuffix": " dauern, bis Ihre Marke genehmigt wird und weitere 4–5 Wochen für die Genehmigung der Kampagne."
        },
        "reminder": {
          "noReplyYet": "Noch keine Antwort",
          "patientConfirmed": "Patient bestätigt"
        },
        "sendGrid": {
          "apiKeyRequired": "API-Schlüssel erforderlich"
        },
        "update": {
          "brandNameHelper": "Verwenden Sie den Firmennamen des Unternehmens, das die Nachrichten versendet.",
          "businessVerticals": "Geschäftsbereiche*",
          "resendOTP": "OTP erneut senden",
          "retryOTPTitle": "OTP-Verifizierung erneut versuchen"
        }
      },
      "addCustomEmailModal": {
        "title": "Benutzerdefinierte E-Mail hinzufügen"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Anbieter hinzufügen",
        "clickHereForInfo": "Klicken Sie hier, um weitere Informationen zu erhalten.",
        "clickHereToFindOut": "Klicken Sie hier, um mehr über sie zu erfahren.",
        "createProviderError": "Bei der Erstellung des Anbieters ist etwas schiefgelaufen!",
        "gmailLimitations": "Gmail hat einige Einschränkungen.",
        "needHelp": "Benötigen Sie Hilfe, um den SMTP-Host und die Port-Anzahl zu finden?",
        "port25NotSupported": "Port 25 wird nicht unterstützt! Bitte verwenden Sie stattdessen Port 2525",
        "providerExists": "Ein Anbieter mit dieser E-Mail-Adresse/diesem Benutzernamen existiert bereits.",
        "providerName": "Name des Anbieters",
        "selectProvider": "Anbieter auswählen",
        "smtpPortNumber": "SMTP-Portnummer",
        "smtpProvider": "SMTP-Anbieter",
        "smtpServer": "SMTP-Server",
        "username": "Benutzername",
        "usernameOrEmailRequired": "Benutzername oder E-Mail-Adresse ist erforderlich.",
        "verifySmtpAccount": "SMTP-Konto überprüfen"
      },
      "addTagModal": {
        "addTag": "Schlüsselwort hinzufügen",
        "editTag": "Schlüsselwort bearbeiten",
        "tagAlreadyExists": "Schlüsselwort {tag} existiert bereits"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "Dieser FirstPromoter-Bericht ist nur für <strong>Agenturinhaber und Administratoren</strong> zugänglich. Falls Sie Unterstützung benötigen, wenden Sie sich bitte an Ihren <strong>Agenturinhaber ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter-Dashboard",
        "noPartnersFound": "Es konnte kein Partner gefunden werden, der Ihren Filtern entspricht. Klicken Sie <a href='javascript:void(0);'>hier</a>, um sich als Partner zu bewerben.",
        "paymentDetailsAccessMessage": "Dieser Abschnitt für Zahlungsdetails ist nur für den <strong>Agenturinhaber</strong> zugänglich und bearbeitbar. Falls Sie Unterstützung benötigen, wenden Sie sich bitte an Ihren <strong>Agenturinhaber ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Termindetails"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Schnappschuss laden:",
        "loadSnapshotWarning": "Möchten Sie den mit diesem Plan verbundenen Schnappschuss laden? <br /> <strong class='text-danger'>Bestehende Daten können verloren gehen</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Passwort ändern",
          "confirmPassword": "Neues Kennwort bestätigen",
          "expired": "Ihr Link zum Zurücksetzen des Passworts ist abgelaufen.",
          "regenerateLink": "Link neu generieren",
          "success": "Passwort erfolgreich geändert",
          "title": "Neues Passwort festlegen",
          "passwordMismatch": "Kennwörter stimmen nicht überein"
        },
        "forgotPassword": {
          "contactAgency": "wenden Sie sich an Ihre Agentur.",
          "contactSupport": "kontaktieren Sie bitte telefonisch den HighLevel-Support (rund um die Uhr erreichbar)",
          "supportMessage": "Falls Sie keinen Zugriff auf diesen E-Mail-Account haben, bitte",
          "successMessage": "Ein Link zum Zurücksetzen des Kennworts wurde an Ihre E-Mail-Adresse gesendet.",
          "rateLimitError": "Zu viele Kennwort-Zurücksetzungsanfragen. Bitte versuchen Sie es später noch einmal."
        },
        "login": {
          "inactivityMsg": "Wir haben bemerkt, dass Sie eine Weile inaktiv waren, daher haben wir Sie zu Ihrer Sicherheit abgemeldet.",
          "loginButton": "Login",
          "resetPasswordMsg": "Ein Link zum Zurücksetzen des Passworts wird an Ihre E-Mail-Adresse gesendet.",
          "signInWithGoogle": "Mit Google anmelden",
          "contactHighLevelSupport": " kontaktieren Sie bitte telefonisch den HighLevel-Support (rund um die Uhr erreichbar)"
        },
        "logout": {
          "loggingOut": "Abmelden..."
        },
        "otp": {
          "enterBackupCode": "Geben Sie Ihren Backup-Code ein",
          "resend": "Erneut senden",
          "resendIn": "Erneut senden in",
          "sendToPhone": "Code an Telefon senden",
          "sending": "Wird gesendet",
          "useAuthenticator": "Authenticator-App verwenden",
          "useBackupCode": "Backup-Code verwenden",
          "verifyButton": "Mit Backup-Code überprüfen"
        },
        "sso": {
          "agreeTerms": "Durch Ihre Anmeldung stimmen Sie unseren <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Allgemeinen Geschäftsbedingungen</a> zu.",
          "and": ", und",
          "loginDifferentMethod": "Melden Sie sich mit einer anderen Methode an",
          "loginSuccessRedirecting": "Anmeldung erfolgreich, Weiterleitung läuft...",
          "processing": "Ihre Anfrage wird bearbeitet …",
          "redirecting": "Weiterleitung läuft …",
          "redirectingToDashboard": "Weiterleitung zum Dashboard...",
          "signedIn": "Angemeldet",
          "signingIn": "Anmeldung läuft ...",
          "testFailedRedirecting": "Test fehlgeschlagen, Weiterleitung läuft …",
          "testSuccessRedirecting": "Test erfolgreich, Weiterleitung läuft …"
        }
      },
      "businessDetailModal": {
        "businessAddress": "Geschäftsadresse: {address}",
        "businessDetailsText": "Die folgenden Unternehmensdetails werden an Google Local Services Ads für die Integration von „Mit Google reservieren“ übermittelt. Bitte überprüfen und bestätigen. Oder {link}, um Ihr Unternehmensprofil zu aktualisieren.",
        "businessInfoRequired": "Die oben aufgeführten Unternehmensinformationen sind für die Integration erforderlich. {link}, um die fehlenden oder ungültigen Unternehmensdetails zu aktualisieren.",
        "businessName": "Firmenname: {name}",
        "businessNiche": "Geschäftsbereich: {niche}",
        "city": "Stadt: {city}",
        "confirmDetails": "Hiermit bestätige ich die Richtigkeit der oben genannten Details",
        "country": "Land: {country}",
        "mustConfirmDetails": "Sie müssen die oben genannten Angaben bestätigen.",
        "phoneNumber": "Rufnummer: {phone}",
        "state": "Bundesland: {state}",
        "zipCode": "Postleitzahl: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Stunden Hinzufügen",
        "applyAll": "Alle anwenden"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Nehmen Sie den Anruf entgegen und geben Sie diesen Verifizierungscode ein:",
          "leadConnectorCalling": "LeadConnector ruft an …",
          "title": "Anrufer-ID per Spracheingabe hinzufügen",
          "waitingForVerification": "Warten auf Bestätigung …"
        },
        "callerIdVerificationStatus": {
          "failed": "Anrufer-ID-Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
          "success": "Sie haben <strong>{contact}</strong> erfolgreich verifiziert."
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Vorhandene Nummer(n) hinzufügen",
          "areaCode": "Vorwahl:",
          "checkAvailability": "Verfügbarkeit prüfen",
          "checkingAvailability": "Nummernverfügbarkeit wird überprüft.",
          "chooseAreaCode": "Wählen Sie eine Ortsvorwahl",
          "choosePhoneNumbers": "Wählen Sie Rufnummer(n) aus",
          "goBack": "Zurück",
          "localNumbers": "Lokal(e) {type}",
          "nextNumberFeatures": "Nächster Schritt: Nummerneigenschaften",
          "noExistingNumbers": "Es sind keine Nummern zum Hinzufügen verfügbar",
          "noNumbersAvailable": "Keine Nummern verfügbar",
          "notEnoughNumbers": "Nicht genügend Nummern verfügbar",
          "numbersAvailable": "Verfügbare Nummern",
          "numbersDifferentArea": "Nummern in einem anderen Vorwahlbereich",
          "numbersLocalTo": "Lokale Nummern für <strong>{number}</strong>",
          "problemChecking": "Es gab ein Problem bei der Überprüfung der Nummernverfügbarkeit. Bitte überprüfen Sie die Netzwerkverbindung oder kontaktieren Sie den Support.",
          "somethingWentWrong": "Etwas ist schiefgelaufen. Bitte überprüfen Sie Ihre Twilio-Konto-Zugangsdaten und kontaktieren Sie den Support, falls das Problem weiterhin besteht.",
          "tollFreeNumbers": "Gebührenfreie Rufnummern (2,00 $ Aufpreis pro Nummer und Monat)",
          "percentageComplete": "67% abgeschlossen"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "Ich verstehe die Konsequenzen. Bitte Pool löschen",
          "confirmText": "Bitte geben Sie zur Bestätigung <b>{name}</b> ein",
          "title": "NumberPool löschen – <strong>{name}</strong>",
          "warning": "Diese Aktion kann nicht rückgängig gemacht werden. Dadurch werden die Nummern dauerhaft aus Ihrem Twilio-Konto und der Nummernpool aus unserer Datenbank gelöscht. Falls Sie den Nummernpool löschen möchten, weil Sie auf ein Problem gestoßen sind, wenden Sie sich bitte an unser Support-Team."
        },
        "editNumberFormatModal": {
          "description": "Sie können das Styling von Tauschnummern und Poolnummern nach Ihren Wünschen aktualisieren. Stellen Sie sicher, dass die Tauschnummern auf der Website in dem gleichen Format angezeigt werden.",
          "title": "Nummernformatierung aktualisieren – <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Gruppen-ID hinzufügen/bearbeiten",
          "callConnectTooltip": "Diese Funktion erfordert, dass der Anrufempfänger eine Taste drückt, damit der Anruf verbunden wird. Dies führt zu einer höheren Genauigkeit bei der Anrufberichterstattung.",
          "createGroupIdDescription": "Erstellen oder fügen Sie eine eindeutige Gruppen-ID hinzu, um mehrere Nummernpools mit einem einzigen JavaScript-Snippet zu verwenden.",
          "enableCallConnect": "Anrufverbindungsfunktion aktivieren",
          "groupId": "Gruppen-ID",
          "outboundCallTimeout": "Timeout für ausgehende Anrufe",
          "passCallerID": "Angerufene Nummer als Anrufer-ID weitergeben",
          "passCallerIDTooltip": "Standardmäßig überträgt das System die Nummer des Anrufers, aber falls Sie möchten, dass die Anrufer-ID stattdessen die Nummer ist, die der Anrufer gewählt hat, aktivieren Sie diese Funktion",
          "selectCallerID": "Anrufer-ID auswählen",
          "timeDuration": "Dauer in Sekunden",
          "titleNumber": "Nummer – <strong>{number}</strong>",
          "updateWhisperWarning": "Aktualisieren Sie die Whispernachricht, da diese Funktion erfordert, dass der Empfänger eine Taste drückt, um den Anruf zu verbinden.",
          "useVerifiedNumber": "Verwenden Sie Ihre verifizierte Nummer als Anrufer-ID für ausgehende Anrufe",
          "useVerifiedNumberTooltip": "Nur für verifizierte Telefonnummern. Sie können eine Telefonnummer unter „Einstellungen“ > „Telefonnummern“ > „Verifizierte Anrufer-ID hinzufügen“ verifizieren"
        },
        "emailOTPModal": {
          "confirmCode": "Code bestätigen",
          "resendCode": "Falls Sie den Code nicht erhalten haben, klicken Sie hier, um ihn erneut zu senden",
          "unexpectedIssue": "Ein unerwartetes Problem ist aufgetreten"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Benutzerdefinierte Feldinformationen",
          "customFieldTooltip": "Tooltip für benutzerdefinierte Felder: {options}",
          "field": "{companyName} Feld",
          "trackingParameters": "Tracking-Parameter",
          "zipCode": "Postleitzahl"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Tauschnummern hinzufügen",
          "addingSnippets": "JavaScript-Snippets werden hinzugefügt",
          "groupSnippet": "„{id}“ Snippets gruppieren",
          "normalSnippet": "Normales Snippet",
          "noswapDescription": "Falls Sie nicht möchten, dass wir die Nummer an einer bestimmten Stelle austauschen, fügen Sie die Klasse „noswap\" hinzu.",
          "notReplacing": "An bestimmter Stelle nicht austauschen",
          "requiredSteps": "Erforderliche Schritte",
          "snippetsDescription": "Kopieren Sie das unten stehende Snippet und fügen Sie es direkt über dem schließenden Body-Tag jeder Seite ein, auf der Sie die Nummern austauschen möchten.",
          "swappingDescription": "Verwenden Sie die unten stehenden Nummern, um den Rufnummern-Austausch zu aktivieren. Wählen Sie eine lokale oder internationale Nummer oder sogar beide aus."
        },
        "newPhoneNumberModal": {
          "areaCode": "Vorwahl",
          "availableNumbers": "Verfügbare Nummern",
          "bundle": "Paket",
          "chooseAddress": "Adresse wählen …",
          "chooseBundle": "Paket wählen …",
          "createRegulatory": "Erstellen Sie hier ein(e) Regulierungspaket/-Adresse.",
          "monthlyFee": "Monatliche Gebühr",
          "noNumbersFound": "Es wurden keine Nummern gefunden. Bitte versuchen Sie es mit einer anderen Vorwahl.",
          "selectAddress": "Bitte wählen Sie „Adresse“ aus, um die Nummer zu kaufen.",
          "selectBundle": "Bitte wählen Sie „Paket“ aus, um die Nummer zu kaufen.",
          "title": "Rufnummer hinzufügen",
          "upgradeAccount": "Bitte nehmen Sie ein Upgrade für Ihr Twilio-Konto vor. Nur Konten mit Upgrade können Rufnummern kaufen und Anrufe tätigen",
          "cardAuthenticationFailed": "Kartenauthentifizierung fehlgeschlagen!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "Sie müssen den Nutzungsbedingungen und der Datenschutzrichtlinie zustimmen.",
          "clickingProceed": "Durch Klicken auf „Fortfahren“ wird die LSA-Verknüpfungsseite in einem neuen Tab geöffnet",
          "configureCalendar": "Konfigurieren Sie mindestens einen Kalender, um mit der Google Buchungs-Integration fortzufahren",
          "configureCalendarBtn": "Kalender konfigurieren",
          "linkOneAccount": "Stellen Sie sicher, dass Sie nur ein Konto verknüpfen. Kontaktieren Sie den Support, wenn Sie die Seite im Screenshot oben nicht sehen können.",
          "readInstructions": "Ich habe die oben genannten Anweisungen durchgelesen"
        },
        "updateTrackingModal": {
          "title": "Tracking-Option aktualisieren"
        },
        "usageSummary": {
          "agencyOnlyVisible": "(Dies ist nur für Agentur-Administratoren sichtbar)",
          "updatedEvery24Hours": "(alle 24 Stunden aktualisiert)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Kalender wurde nicht zur Synchronisierung ausgewählt",
          "check": "Überprüfen Sie {email}",
          "checkForConflicts": "Auf Konflikte prüfen",
          "checkForConflictsTooltip": "Stellen Sie den/die Kalender so ein, dass nach Konflikten gesucht wird, um Doppelbuchungen zu vermeiden.",
          "contactCreationAllowed": "Kontakterstellung erlaubt",
          "googleCalendar": "Logo für Google Kalender",
          "noGoogleAccounts": "Es wurden noch keine Google-/Outlook-Konten in den Integrationseinstellungen hinzugefügt",
          "noGoogleAccountsTeamMember": "Es wurden keine Google-/Outlook-Konten für dieses Teammitglied am aktuellen Standort hinzugefügt. Bitten Sie Ihr Teammitglied, sich über sein Konto anzumelden und die Google-Verbindung über seine Integrationseinstellungen hinzuzufügen.",
          "outlookCalendar": "Outlook-Benutzerkalender",
          "primaryCalendarTooltip": "Legen Sie den Kalender fest, dem Sie neue Ereignisse hinzufügen möchten, sobald diese geplant sind.",
          "runTriggerAllowed": "Trigger auslösen erlaubt"
        },
        "warningModal": {
          "contactAgency": "Bitte wenden Sie sich an Ihre Agentur, um die E-Mail-Einstellungen zu ändern.",
          "title": "Warnung"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Schnellerer ganztägiger Chat-Support",
            "faster247Ticket": "Schnellerer ganztägiger Ticket-Support und kürzere Reaktionszeiten"
          },
          "highlight": {
            "description": "Sie möchten schneller werden. Das verstehen wir. Wenn Sie eine Frage oder ein Anliegen haben, brauchen Sie so schnell wie möglich eine Antwort! Mit dem Upgrade auf vorrangigen Support überspringen Sie die Warteschlange und Ihre Anfragen werden automatisch vorrangig bearbeitet.",
            "heading": "Sind Sie bereit für diese VIP-Behandlung?"
          },
          "name": "Vorrangiger Support",
          "success": {
            "description": "Der vorrangige Support wurde für Ihr Konto aktiviert. Sie müssen also nicht mehr auf Hilfe warten.",
            "heading": "Sie sind jetzt ein vorrangiger Kunde!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "{entityName}klonen",
        "cloning": "Klonen...",
        "cloningLimit": "Das Klonen ist auf jeweils 3 Standorte beschränkt",
        "error": "Fehler beim Klonen des Funnels!",
        "locationsLabel": "Wählen Sie Standorte aus",
        "nameLabel": "Name für das geklonte {entityName}",
        "namePlaceholder": "Geben Sie einen Namen für den geklonten {entityName}ein",
        "selectUpTo": "Wählen Sie bis zu {maxSelectableLocations} Standorte aus",
        "title": "Klonen {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "Mit CNAM erscheint Ihr Firmenname als Anrufer-ID, wodurch Ihre Anrufe sofort erkennbar sind und das Vertrauen gestärkt wird. Lassen Sie Ihre Kunden wissen, dass Sie es sind – und zwar jedes Mal.",
          "title": "Heben Sie Ihre Anrufe von der Masse ab!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Bestätigen und registrieren",
          "description": "Lassen Sie Ihren Firmennamen für Anrufempfänger anzeigen, um das Vertrauen zu stärken und die Annahmequote zu erhöhen.",
          "title": "Mit CNAM steigern Sie das Vertrauen in Ihre Anrufe",
          "warning": "Die Anzeige des Firmennamens ist nicht garantiert, insbesondere auf Mobilgeräten."
        },
        "submitted": {
          "checkStatus": "CNAM-Status überprüfen",
          "description": "Ihr Firmenname sollte Kontakten in etwa 3–5 Tagen angezeigt werden.",
          "subtitle": "Ihre CNAM-Anfrage wurde jetzt übermittelt.",
          "title": "Herzlichen Glückwunsch!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Löschen bestätigen",
        "confirmation": "Bestätigung"
      },
      "createAddress": {
        "successTitle": "Adresse wurde übermittelt",
        "underReview": "Die eingereichte Adresse wird geprüft"
      },
      "createEndUser": {
        "dateFormat": "Das Datumsformat sollte JJJJ-MM-TT sein.",
        "phoneExample": " Beispiel: +14155552671",
        "title": "Unternehmensangaben:"
      },
      "customValueModal": {
        "changingNameWarning": "Eine Namensänderung beeinflusst den Feldschlüssel nicht.",
        "editCustomValue": "Benutzerdefinierten Wert bearbeiten",
        "fieldKeyCreatedWarning": "Der Feldschlüssel wird anhand des Namens erstellt und kann später nicht mehr geändert werden.",
        "nameRequired": "Das Feld „Name“ ist ein Pflichtfeld",
        "nameValidation": "Der Name muss aus alphanumerischen Zeichen bestehen und mindestens ein Zeichen enthalten",
        "valueRequired": "Das Feld „Wert“ ist ein Pflichtfeld"
      },
      "details": {
        "addressName": "Adressname",
        "addressTitle": "Adressdetails",
        "bundleName": "Paketname",
        "bundleTitle": "Details zum Regulierungspaket",
        "countryFlag": "Flagge von {country}",
        "id": "ID",
        "organisation": "Unternehmen/Organisation",
        "rejectionReason": "Ablehnungsgrund",
        "status": {
          "approved": "Genehmigt",
          "notValidated": "Nicht validiert",
          "rejected": "Abgelehnt",
          "validated": "Bestätigt"
        },
        "typeOfNumber": "Nummerntyp"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Niederlassung auswählen",
        "whichOffice": "Welche Niederlassung möchten Sie mit diesem Konto verknüpfen?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Erstellung von Kontakten zulassen:",
        "allowTrigger": "Auslöser erlauben:",
        "doNotSync": "Neue Ereignisse nicht mit dem primären Kalender synchronisieren",
        "primaryCalendarTooltip": "Sie können nur einen Kalender mit Schreibzugriff auswählen, den Sie nicht zur Konfliktprüfung ausgewählt haben.",
        "selectDefaultCalendar": "Standardkalender auswählen",
        "whichCalendar": "Welchen Kalender sollen wir zum Synchronisieren (Lesen und Schreiben) von Ereignissen verwenden?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Diese Orte auf Konflikte überprüfen",
        "howToCheckConflicts": "Wie sollten wir Konflikte überprüfen?"
      },
      "ejectModal": {
        "agencyClosing": "Das HighLevel-Konto der Agentur Elite Marketing wird geschlossen. Um Ihr Konto zu behalten, wenden Sie sich bitte an {userName}, damit Ihr Konto direkt zu HighLevel migriert wird.",
        "cancelWarning": "Bitte beachten Sie, dass Ihr Konto am 30. Juni 2025 offiziell gekündigt wird und wir Ihre Daten nach diesem Datum nicht mehr wiederherstellen können, falls die Übertragung bis dahin nicht vollständig abgeschlossen wurde.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "Falls Sie Fragen haben, kontaktieren Sie uns bitte unter",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "Um Sie während dieses kostenlosen Übergangs zu unterstützen, gewähren wir Ihnen {months} freien Zugang zu Ihrem neuen Abonnement.",
        "intro": "Aufgrund wiederholter Verstöße gegen die Nutzungsbedingungen von HighLevel wurde die Elite Marketing Authority (EMA) dauerhaft von der HighLevel-Plattform entfernt.",
        "platformCommitment": "Als Plattform, die die Services von EMA unterstützt, setzt sich HighLevel dafür ein, eine sichere, konforme und vertrauenswürdige Umgebung für alle Benutzer bereitzustellen. Um Unterbrechungen Ihres Kontos zu vermeiden, helfen wir Ihnen bei einem nahtlosen Übergang – entweder zu einem anderen White-Label-Anbieter oder direkt zu HighLevel.",
        "questions": "Falls Sie Fragen haben,",
        "retainAccess": "Um weiterhin Zugriff auf Ihre bestehenden Daten und Tools zu haben, klicken Sie auf die Schaltfläche unten und folgen Sie den Anweisungen, um die Übertragung zu starten.",
        "speakWithTeam": "um mit unserem Team zu sprechen.",
        "startTransfer": "Starten Sie Ihre kostenfreie Übertragung",
        "title": "Hinweis für Kunden von Elite Marketing",
        "viewFaqs": "Häufig gestellte Fragen finden Sie hier:",
        "whiteLabel": "Falls Sie HighLevel lieber über einen anderen White-Label-Anbieter nutzen möchten, kommen wir dieser Änderung gerne über unser Support-Ticketsystem nach, nachdem Sie Ihr Konto direkt zu HighLevel übertragen haben."
      },
      "emailTemplate": {
        "createdOn": "Erstellt am",
        "updatedOn": "Aktualisiert am"
      },
      "error": {
        "title": "Einreichung des Regulierungspakets ist fehlgeschlagen"
      },
      "errors": {
        "funnel": {
          "multiplePages": "Mehrere Seiten haben diese URL. Ändern Sie den Pfad dieser Seite, damit sie funktioniert.",
          "urlNotFound": "Leider konnten wir die von Ihnen gesuchte URL nicht finden"
        },
        "productRebilling": {
          "requestFailed": "Anfrage ist fehlgeschlagen"
        },
        "template": {
          "categoryNotFound": "Leider konnten wir die von Ihnen gesuchte Kategorie nicht finden.",
          "internalError": "Interner Fehler"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "Für das Unterkonto, das Sie übertragen möchten, ist HIPAA-Compliance aktiviert. Daher kann es nicht an eine Nicht-HIPAA-Agentur übertragen werden."
          },
          "limitExceeded": {
            "message": "Die Agentur, auf die Sie das Unterkonto übertragen möchten, hat ihr Nutzungslimit erreicht und kann keine weiteren Unterkonten mehr annehmen.  Bitten Sie die Agentur, entweder ein nicht genutztes Unterkonto zu löschen oder auf einen höherwertigen Agenturplan aufzurüsten, um dieses Unterkonto anzunehmen."
          },
          "pendingRequest": {
            "heading": "Für dieses Unterkonto steht bereits ein Übertragungsantrag aus.",
            "message": "Bitte annullieren Sie den bestehenden Übertragungsantrag für dieses Unterkonto, bevor Sie einen neuen erstellen."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Können Sie die gesuchte Seite nicht finden? Bitte gehen Sie zu Ihren Facebook-Einstellungen und stellen Sie sicher, dass alle Seiten ausgewählt sind.",
        "instagramAvailable": "Instagram ist für dieses Konto verfügbar!",
        "noPages": "Sie haben keine Seiten unter diesem Konto.",
        "title": "Wählen Sie aus, welche Facebook-Seite Sie mit diesem Standort verknüpfen möchten"
      },
      "googleLocationSelect": {
        "closeButton": "Schließen!",
        "enableCallTracking": "GBP-Anrufverfolgung aktivieren",
        "noBusinesses": "Sie haben keine verbundenen Unternehmen in diesem Konto."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "Effizienter",
          "faster": "Schneller",
          "itsText": "Es ist",
          "smoother": "Reibungsloser",
          "title": "Wir haben unsere Importfunktion ganz neu gestaltet!",
          "warningMessage": "Durch Aktivieren der neuen Importfunktion wird Labs für dieses Unterkonto aktiviert und die Beta-Funktion eingeschaltet."
        },
        "validateEmails": "E-Mails validieren?"
      },
      "initBundle": {
        "numberType": "Art der Nummern, die Sie verwenden wollten",
        "numberTypes": {
          "local": "Lokale Nummern",
          "mobile": "Mobilrufnummer",
          "tollfree": "Gebührenfrei"
        },
        "selectCountry": "Wählen Sie Ihr Land aus",
        "selectUserType": "Wählen Sie den Benutzertyp aus",
        "userTypes": {
          "business": "Geschäftlich",
          "individual": "Einzelperson"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Kredit zuletzt hinzugefügt am:",
        "currentBalance": "Aktuelles Guthaben",
        "debitBalance": "– Sollguthaben",
        "depositComplimentaryCreditsOf": "Kostenlose Gutschriften einzahlen in Höhe von",
        "manageBalance": "Guthaben verwalten",
        "mustBeValidInteger": "Muss eine gültige Ganzzahl sein",
        "nextDate": "Nächstes Datum:",
        "perMonth": "pro Monat",
        "remainingWalletBalance": "Verbleibendes Wallet-Guthaben von diesem Unterkonto",
        "rolloverCredits": "Gutschriften auf den nächsten Monat übertragen",
        "toManageMonthlyCredits": "Um monatliche Gutschriften zu verwalten,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Neues Abonnement hinzufügen"
      },
      "manualActions": {
        "confirmDelete": "Möchten Sie diese Aktion wirklich löschen?",
        "confirmDeleteAll": "Möchten Sie wirklich alle manuellen Aktionen auf dieser Seite löschen?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Generieren Sie ein sicheres Passwort",
          "sendEmailNotification": "Senden Sie außerdem eine E-Mail-Benachrichtigung."
        }
      },
      "modal": {
        "description": "Zu Compliance-Zwecken müssen Sie einige einfache Schritte durchführen, um die Telefonsysteme verwenden zu können",
        "submit": "Absenden",
        "title": "LeadConnector-Telefonservice"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Besucher der Startseite",
          "launched": "Gelauncht",
          "newNotification": "Neue Benachrichtigung",
          "startMessage": "Steigern Sie Ihre Konversionsrate, indem Sie Ihre erste Benachrichtigung erstellen",
          "types": {
            "combination": "Kombination"
          }
        },
        "page": {
          "createTitle": "Neue Benachrichtigung erstellen",
          "steps": {
            "display": "Anzeigen",
            "track": "Nachverfolgen"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Zusätzliche Informationen",
          "calendarEvent": "Kalenderereignis",
          "hideAssignedTo": "„Zugewiesen an“ ausblenden",
          "hideTags": "Schlüsselwörter ausblenden"
        },
        "filters": {
          "dateAddedAsc": "↑ Hinzugefügt am (aufsteigend)",
          "dateAddedDesc": "↓ Hinzugefügt am (absteigend)",
          "orderBy": "OrderBy"
        },
        "getStarted": "Los geht's!",
        "noPipelines": "Es gibt noch keine Pipelines. Erstellen Sie eine neue Pipeline, um"
      },
      "pages": {
        "pageMoved": {
          "title": "Online-Einträge wurden verschoben"
        }
      },
      "recentlyVisited": {
        "prices": "{count} Preise"
      },
      "reminders": {
        "appointmentReminders": "Terminerinnerungen",
        "apptTime": "Terminzeit",
        "defaultDateRange": "So., 1. Apr. 2018–Mo., 30. Apr. 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "Ausstehend",
        "rebillingOnHoldWarning": "Dieses Konto hat bereits ausstehende Neuberechnungseinstellungen. Ein SaaS-Plan kann nur angehängt werden, nachdem der Kunde eine Zahlungsmethode hinzugefügt hat.",
        "subscriptionId": "Abonnement-ID:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Bestätigen und weiter",
        "documents": {
          "acceptedDocuments": "Akzeptierte Dokumente",
          "acceptedDocumentsLabel": "Akzeptierte Dokumente:",
          "additionalInfo": "Zusätzliche Angaben:",
          "createAddressLink": "Adresse erstellen.",
          "createAddressPrompt": "Bitte erstellen Sie zuerst eine Adresse und fahren Sie dann mit der Paketerstellung fort.",
          "documentInfo": "PNG, JPG, PDF bis zu 5 MB",
          "documentType": "Dokumenttyp",
          "option": "Option {number}",
          "selectAddress": "Adresse auswählen:",
          "selectDocumentType": "Dokumenttyp auswählen:",
          "selectFile": "Datei auswählen",
          "title": "Erforderliche Dokumente:",
          "updateDocuments": "Dokumente aktualisieren"
        },
        "everythingIn": "Alles in <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "Kreditkarte hier hinzufügen",
          "message": "Bitte bitten Sie Ihren Kunden,",
          "title": "Es muss zuerst eine Zahlungsmethode für den Standort hinzugefügt werden."
        },
        "noSaasPlan": {
          "linkText": "erstellen Sie hier Ihre SaaS-Pläne.",
          "message": "Bitte",
          "title": "Sie haben keinen SaaS-Plan konfiguriert."
        },
        "saasModeSetupPendingWarning": "Der SaaS-Plan wird aktiviert, nachdem der Kunde eine Zahlungsmethode hinzugefügt hat. Bis dahin wird sein Kontozugriff eingeschränkt.",
        "skipForNow": "Vorerst überspringen",
        "skipPlan": "Plan überspringen",
        "success": {
          "title": "Regulationspaket wurde übermittelt",
          "underReview": "Paket eingereicht, wird geprüft"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "Mit dieser Option wird Ihrem Konto eine neue Adresse hinzugefügt",
          "label": "Adresspaket"
        },
        "regulatoryBundle": {
          "description": "Diese Option hilft Ihnen, ein neues Regulierungspaket zu erstellen",
          "label": "Regulierungspaket"
        },
        "title": "Wählen Sie, welches Paket Sie hinzufügen möchten"
      },
      "settings": {
        "billing": "Abrechnung",
        "calendars": "Kalender",
        "customEmails": "Benutzerdefinierte E-Mails",
        "domains": "Domains",
        "domainsAndUrlRedirects": "Domains & URL-Weiterleitungen",
        "facebookFormFieldsMapping": "Zuordnung von Facebook-Formularfeldern",
        "groups": "Gruppen",
        "integrations": "Integrationen",
        "labs": "Labs",
        "media": "Medien",
        "noShowSMS": "SMS bei Nichterscheinen",
        "pipelines": "Pipelines",
        "profile": "Profil",
        "smtpAndMailGunService": "SMTP- und Mailgun-Dienst",
        "templates": "Vorlagen",
        "urlRedirects": "URL-Weiterleitungen"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Ihre Anrufe sind jetzt verifiziert!"
        },
        "modal": {
          "andThe": " und der ",
          "certification": "Ich bestätige, dass das zugehörige Geschäftsprofil der Urheber der Anrufe ist, und erkläre mich bereit, an Rückverfolgungsmaßnahmen mitzuwirken, einschließlich solcher, die eingeleitet werden von dem",
          "failedTitle": "Einreichung fehlgeschlagen",
          "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 um 19:47:14",
          "linkInfo": {
            "description": "Alle derzeit verfügbaren Nummern und zukünftig gekaufte Nummern werden automatisch mit SHAKEN/STIR registriert.",
            "title": "Alle Nummern werden automatisch verknüpft"
          },
          "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
          "subtitle": "Geben Sie die Details und die Beschreibung ein",
          "successMessage": "Ihr Antrag auf SHAKEN/STIR-Registrierung wurde übermittelt. Die Genehmigung kann <b>3–4 Tage</b> dauern. Der Status wird in Kürze aktualisiert.",
          "successTitle": "Vertrauenswürdiges Anrufen mit SHAKEN/STIR ist aktiviert.",
          "title": "Vertrauenswürdiges Anrufen mit SHAKEN/STIR aktivieren",
          "tracebackGroup": "USTelecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Möchten Sie einen Schritt weiter gehen? Mit CNAM können Sie bei Anrufen Ihren Firmennamen anzeigen lassen.",
          "registerCnam": "Für CNAM registrieren",
          "title": "Kundenvertrauen aufbauen und Anrufannahmeraten erhöhen"
        },
        "successMessage": "Ihr Antrag auf SHAKEN/STIR-Registrierung wurde übermittelt. Die Genehmigung kann bis zu <b>3-4 Tage</b> dauern. Der Status wird in Kürze aktualisiert."
      },
      "shopify": {
        "selectLocation": "Wählen Sie den Standort aus, den Sie mit diesem Shopify-Shop verknüpfen möchten"
      },
      "signup": {
        "accountType": "Kontotyp",
        "agencyProAccount": "Agency-Pro-Konto (497 $/Monat)",
        "agencyTestAccount": "Agentur-Testkonto",
        "freeTrialMessage": "Sichern Sie sich jetzt eine 14-tägige <strong>kostenlose</strong> Testphase.",
        "freelancerAccount": "Freelancer-Konto (297 $/Monat)",
        "getStartedForFree": "Kostenlos starten!",
        "pickPassword": "Wählen Sie ein Passwort",
        "signUp": "Registrieren",
        "starterAccount": "Starter-Konto (97 $/Monat)",
        "termsAndConditions": "Mit Ihrer Registrierung stimmen Sie unseren <a href='https://www.gohighlevel.com/privacy' target='_blank'>Allgemeinen Geschäftsbedingungen</a> zu.",
        "yourCompanyName": "Ihr Firmenname",
        "yourFullName": "Ihr vollständiger Name"
      },
      "standardPlan": {
        "description": "Wir haben die folgenden Pläne für Standard-Marken-Registrierungen.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN erforderlich für die Registrierung",
            "moreThan1Phone": "Mehr als eine Rufnummer erlaubt"
          },
          "highVolume": {
            "heading": "Hohes Volumen Standard",
            "point3": "Bis zu 600.000 Segmente pro Tag",
            "infoText": "Für die Registrierung von Marken-Boards und Kampagnen wird eine einmalige Gebühr von 20,95 USD erhoben. Zusätzliche Kampagnengebühr von bis zu 2,25 USD je Monat wird gemäß den TCR-Regeln erhoben.",
            "point2": "Senden Sie bis zu 3.000 Segmente pro Tag",
            "point1": "EIN erforderlich für die Registrierung"
          },
          "lowVolume": {
            "heading": "Niedriges Volumen Standard",
            "recommended": "Empfohlen",
            "point3": "Bis zu 6.000 Segmente pro Tag",
            "infoText": "Für die Registrierung von Marken-Boards und Kampagnen wird eine einmalige Gebühr von 20,95 USD erhoben. Eine zusätzliche Kampagne Gebühr von bis zu 2,25 USD je Monat wird gemäß den TCR-Regeln erhoben.",
            "point2": "Senden Sie bis zu 3.000 Segmente pro Tag",
            "point1": "EIN erforderlich für die Registrierung"
          }
        },
        "title": "Wählen Sie Ihren Standard-Markenplan"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Buchungsdetails",
          "form": "Formular",
          "quiz": "Quiz",
          "submissionDetail": "Details zur Einreichung",
          "survey": "Umfrage"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Nur Agentur-Admins/-Benutzer haben Zugriff auf dieses Unterkonto. Derzeit haben Sie und andere Kontoadministratoren/-benutzer keinen Zugriff auf dieses Unterkonto.",
          "heading": "Dieses Unterkonto wurde pausiert."
        },
        "temporarily": {
          "description": "Alle Ihre Daten sind sicher und alle Auslöser/Kampagnen usw. werden nach der Aktivierung wieder funktionieren.",
          "heading": " Ihr Konto wurde vorübergehend gesperrt."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Nur auf nicht zugewiesene Kontakte anwenden",
          "splitTraffic": "Traffic aufteilen",
          "trafficWeightage": "Traffic-Gewichtung",
          "userRequired": "Benutzer muss ausgewählt werden",
          "weightage": "Gewichtung"
        },
        "birthdayFilters": {
          "afterDays": "Nach Anzahl von Tagen",
          "beforeDays": "Vor Anzahl von Tagen",
          "dayIs": "Tag ist",
          "daysInNumber": "Tage als Zahl",
          "hasTag": "Hat Schlüsselwort",
          "monthIs": "Monat ist",
          "selectDay": "Tag auswählen",
          "selectMonth": "Monat auswählen"
        },
        "botConversation": {
          "enterTimeout": "Timeout eingeben (Stunden)",
          "selectEliza": "Eliza auswählen",
          "selectThankyouTemplate": "Dankeschön-Vorlage auswählen",
          "selectWelcomeTemplate": "Willkommens-Vorlage auswählen"
        },
        "contactField": {
          "addField": "Feld hinzufügen",
          "defineFilters": "Filter definieren"
        },
        "copyModal": {
          "title": "Auslöser kopieren"
        },
        "detailModal": {
          "actionsPerform": "Welche Aktionen sollten wir durchführen?",
          "campaignNameRequired": "Das Feld „Kampagnenname“ ist ein Pflichtfeld",
          "campaignsDeprecation": "Kampagnen werden nicht mehr unterstützt. Um einen reibungslosen Übergang zu gewährleisten, konvertieren Sie bitte Ihre bestehenden Kampagnen in Workflows.",
          "folderName": "Ordnername",
          "mustSelectFolder": "Sie müssen einen Ordner auswählen.",
          "newFolderName": "Neuer Ordnername",
          "selectFolder": "Ordner auswählen",
          "triggerNameRequired": "Das Feld „Trigger-Name“ ist erforderlich.",
          "triggersDeprecation": "Auslöser werden nicht mehr unterstützt. Um einen reibungslosen Übergang zu gewährleisten, konvertieren Sie bitte Ihre bestehenden Auslöser in Workflows.",
          "triggerName": "Auslöser-Name"
        },
        "dnd": {
          "disableAll": "DND für alle Kanäle deaktivieren",
          "disableSpecific": "DND für bestimmte Kanäle deaktivieren",
          "enableAll": "DND für alle Kanäle aktivieren",
          "enableSpecific": "Aktivieren Sie DND für bestimmte Kanäle",
          "selectAction": "Aktion auswählen"
        },
        "email": {
          "sendTestEmail": "Test-E-Mail senden",
          "smtpWarning": "SMTP-Anbieter haben einige Einschränkungen. Klicken Sie hier, um mehr zu erfahren."
        },
        "facebook": {
          "avatarAlt": "Facebook-Avatar",
          "selectCustomAudience": "Benutzerdefinierte Zielgruppe auswählen"
        },
        "googleAds": {
          "conversionName": "Konversionsname",
          "conversionTooltip": "Die Konversionsquelle sollte „Import von Klicks“ und die Kategorie „Importierter Lead“ oder „Lead“ sein",
          "noConversions": "Keine Konversionen gefunden",
          "selectConversion": "Konversion auswählen"
        },
        "googleAnalytics": {
          "eventAction": "Event-Aktion",
          "eventActionRequired": "Event-Aktion ist erforderlich.",
          "eventCategory": "Event-Kategorie",
          "eventCategoryRequired": "Event-Kategorie ist erforderlich.",
          "eventLabel": "Event-Label",
          "eventValue": "Ereigniswert",
          "hitType": "Treffertyp",
          "hitTypeRequired": "Treffertyp ist erforderlich.",
          "trackingId": "Tracking-ID",
          "trackingIdRequired": "Tracking-ID ist erforderlich."
        },
        "membershipOffer": {
          "selectOffer": "Angebot auswählen"
        },
        "notification": {
          "selectRedirectPage": "Weiterleitungsseite auswählen",
          "selectUser": "Benutzer auswählen",
          "selectUserType": "Benutzertyp auswählen"
        },
        "sms": {
          "sendTestSMS": "Test-SMS senden"
        },
        "stripeCharge": {
          "customerId": "Stripe-Kunden-ID",
          "enterAmount": "Betrag eingeben",
          "selectCurrency": "Währung auswählen"
        },
        "webhook": {
          "webhookUrl": "Webhook-URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Aktivitätsdatum",
            "balance": "Guthaben",
            "id": "ID"
          }
        },
        "upgradeBanner": {
          "subtitle": "Agenturen mit dem Pro Plan erzielen etwa 363 $ pro Monat, indem sie ihren Kunden ihre Telefonkosten in Rechnung stellen",
          "title": "Möchten Sie dies Ihren Kunden in Rechnung stellen?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Ihr Profil konnte nicht übermittelt werden."
        },
        "success": {
          "message": "Ihre A2P-Marke und -Kampagne wurde eingereicht.<br/><br/><b>Hinweis:</b> Sie <b>erhalten von TCR eine Verifizierungs-SMS mit einem Einmalpasswort (OTP) an Ihre angegebene Mobilrufnummer</b>. Bitte <b>antworten Sie innerhalb von 24 Stunden nach Erhalt der SMS mit „Yes“</b> ."
        }
      },
      "usageLimit": {
        "contactLimit": "Kontaktlimit",
        "maxContactsAllowed": "Max. zulässige Kontakte im Unterkonto",
        "maxUsersAllowed": "Max. zulässige Benutzer im Unterkonto",
        "unlimited": "Unbegrenzt",
        "usageLimits": "Nutzungslimits",
        "userLimit": "Benutzerlimit",
        "userLimitHelpMessage": "Nur Benutzer auf Unterkontoebene zählen zu diesem Limit. Sie können weiterhin so viele Agenturbenutzer zu den Unterkonten hinzufügen, wie Sie benötigen"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "Ich bin einverstanden mit der Aktivierung von Einträgen ohne Upselling für diesen Kunden und nehme zur Kenntnis, dass mir Kosten in Rechnung gestellt werden in Höhe von",
          "deployDirectly": "Einträge direkt bereitstellen",
          "deployDirectlyDesc": "Verwenden Sie diese Option, falls Sie Einträge als Teil Ihres Angebots anbieten oder falls Sie Ihrem Kunden extern eine Rechnung stellen möchten",
          "minimumCommitment": "mit einer Mindestbindungsdauer von einem Monat.",
          "offerListings": "Einträge anbieten",
          "resellListings": "Einträge wiederverkaufen",
          "subscribedInfo": "{withoutUpsell} Ohne Upsell, {withUpsell} Mit Upsell und {withSaas} Mit SaaS-Paket",
          "subscriptionCreated": "Abonnement wurde erstellt. Bitte warten …",
          "subscriptionCreating": "Das Abonnement wird erstellt.<br/>Bitte laden Sie die Seite nicht neu und klicken Sie nicht auf die Zurück-Schaltfläche",
          "unableToCreate": "Es kann kein Abonnement erstellt werden. Bitte kontaktieren Sie den Support.",
          "unavailabilityForAgencyAdmin": "Yext ist in diesem Land nicht verfügbar. Wenn Sie glauben, dass dies ein Fehler ist, bitten wir Sie, dies auf unserer Roadmap anzufordern unter",
          "yourResellOffer": "Ihr Wiederverkaufsangebot"
        }
      },
      "selectCountry": "Wählen Sie Ihr Land aus",
      "documents": {
        "additionalInfo": "Zusätzliche Informationen",
        "createAddressLink": "Anschrift erstellen.",
        "createAddressPrompt": "Bitte erzeugen Sie zuerst eine Anschrift und fahren Sie dann mit der Erstellung des Bundles fort.",
        "selectAddress": "Adresse auswählen:"
      }
    },
    "triggers": {
      "emptyTrigger": "Leerer Auslöser"
    },
    "util": {
      "addFiles": "+ Dateien hinzufügen",
      "fillValues": "Werte ausfüllen",
      "image": "img",
      "ok": "Okay",
      "pleaseTypeOrCancel": "Bitte geben Sie {consentString} oben ein oder brechen Sie diese Aktion ab.",
      "pressEnterToAddCustomOption": "Drücken Sie die Eingabetaste, um eine benutzerdefinierte Option hinzuzufügen",
      "required": "* erforderlich",
      "unsaved": "Nicht gespeichert"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "Um den Workflow für einen Standort zu aktivieren, gehen Sie zur Registerkarte „Konten“, klicken Sie rechts neben einem Unterkonto auf das Symbol mit den drei Punkten und wählen Sie <strong>„Workflow-Builder aktivieren“</strong>. Dieser Prozess ist nur vorübergehend, da Workflows nächste Woche an allen Standorten gelauncht werden."
      },
      "faq": "FAQ",
      "gotIt": "Verstanden",
      "workflowIsLive": "Workflow ist in Ihrem Konto aktiv!"
    },
    "action": {
      "stats": {
        "bounced": "Unzustellbar",
        "clicked": "Geklickt",
        "delivered": "Zugestellt",
        "opened": "Geöffnet",
        "replied": "Beantwortet",
        "unsubscribed": "Abgemeldet",
        "total": "Gesamt",
        "failed": "Fehlgeschlagen"
      },
      "actions": {
        "edit": "Bearbeiten",
        "send": "Senden",
        "remove": "Entfernen"
      },
      "timing": {
        "days": "Tage",
        "immediately": "Sofort",
        "before": "Vorher",
        "after": "Nach",
        "minutes": "Minuten",
        "hours": "Stunden"
      },
      "labels": {
        "template": "Vorlage",
        "manual": "Manuell"
      },
      "details": {
        "hideDetail": "Detail ausblenden",
        "showDetail": "Details anzeigen"
      },
      "queue": {
        "people": "Volk",
        "person": "Einzelperson",
        "queued": "Warteschlange"
      },
      "tooltips": {
        "clickedHelp": "Die Genauigkeit der Klickverfolgung kann je nach E-Mail-Client und Benutzereinstellungen variieren.",
        "statsAccuracy": "Die Genauigkeit der E-Mail-Statistiken kann je nach E-Mail-Client und Benutzereinstellungen variieren."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Sind Sie sicher, dass Sie diese Massendatenanfrage wirklich löschen möchten?",
        "startImmediately": "Beginnen Sie sofort"
      },
      "modal": {
        "contactTypes": {
          "all": "Alle",
          "leads": "Interessenten",
          "customers": "Kunden"
        },
        "buttons": {
          "cancel": "Abbrechen",
          "update": "Aktualisieren",
          "add": "Hinzufügen"
        },
        "labels": {
          "name": "Name",
          "contactType": "Kontakttyp",
          "campaign": "Kampagne",
          "scheduledDate": "Geplanter Termin",
          "tag": "Tag"
        },
        "placeholders": {
          "tags": "Schlüsselwörter",
          "selectCampaign": "Kampagne auswählen",
          "pickType": "Typ auswählen"
        },
        "sections": {
          "bulkRequest": "Massendaten-Anfrage",
          "whoShouldRun": "Für wen sollte es laufen?"
        },
        "titleAdd": "Massedatenanfrage hinzufügen",
        "titleEdit": "Massedatenanfrage bearbeiten",
        "validation": {
          "scheduledDateRequired": "Geplanter Tag ist Erforderlich"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Mehr anzeigen"
    },
    "list": {
      "confirmDeleteFolder": "Löschen des Ordners bestätigen",
      "delete": "Löschen",
      "confirmDelete": "Sind Sie sicher, dass Sie diese Kampagne löschen möchten?",
      "moveToFolder": "In den Ordner verschieben",
      "pleaseRename": "Bitte umbenennen",
      "removeFromFolder": "Aus dem Ordner entfernen"
    },
    "copy": {
      "title": "Kampagne kopieren",
      "newCampaignName": "Neuer Kampagnenname",
      "locations": "Standorte"
    }
  },
  "compliance": {
    "findOutMore": "Mehr erfahren",
    "gdprDescription": "Wir nehmen den Schutz Ihrer personenbezogenen Daten und der personenbezogenen Daten Ihrer Kunden sehr ernst. Wir behandeln diese Daten vertraulich und in Übereinstimmung mit den gesetzlichen Datenschutzbestimmungen und dieser Datenschutzerklärung",
    "gdprTitle": "DSGVO-Konformität",
    "hipaaDescription": "Aktivieren Sie Sicherheitsupgrades, um sicherzustellen, dass die Daten in Ihrem HighLevel-Konto geschützt sind und den HIPAA-Anforderungen entsprechen",
    "hipaaTitle": "HIPAA-Konformität"
  },
  "customValues": {
    "key": "Schlüssel",
    "selectedItemsCountSingular": "{count} Zeile ausgewählt",
    "selectedItemsCountPlural": "{count} Zeilen ausgewählt"
  },
  "facebookAdFields": {
    "checkIcon": "Formularfelder wurden zugeordnet",
    "errorMessage": "Das Zugriffstoken der Seite ist entweder abgelaufen oder verfügt nicht über ausreichende Berechtigungen. Bitte stellen Sie sicher, dass Sie Administratorzugang zu den Seiten haben."
  },
  "fbLeadSync": {
    "confirmTitle": "Bestätigen Sie die Facebook-Interessenten-Synchronisierung?",
    "impactMessage": "Sie sollten die Auswirkungen der Facebook-Leads-Synchronisierung verstehen, bevor Sie fortfahren:",
    "observations": "1. Facebook-Leads werden synchronisiert und für jeden in den letzten {days} Tagen generierten Lead, der nicht in Ihrer Kontaktliste existiert, werden neue Kontakte erstellt. <br>2. Wenn Sie fehlende Leads manuell per CSV-Datei aus dem Facebook-Werbeanzeigenmanager exportiert haben, deaktivieren Sie bitte „Doppelte Kontakte zulassen“, um zu verhindern, dass bei der Synchronisation doppelte Kontakte erstellt werden. <br>3. Wenn Sie Workflows haben, die bei einer <b>Kontakterstellung</b> oder einem eingereichten <b>Facebook-Lead-Formular</b> ausgelöst werden, werden diese für jeden neu erstellten Kontakt ausgelöst. <br>4. Bestehende Kontakte, die über Facebook-Leads erstellt wurden, sind davon nicht betroffen. <br>5. Die Erstellungszeit des Kontakts im Datensatz wird die aktuelle Zeit sein. <br>6. Die Synchronisierung kann bis zu einer Stunde dauern, abhängig von der Anzahl der Leads, die noch synchronisiert werden müssen. <br>",
    "proceedQuestion": "Möchten Sie mit der Facebook-Lead-Synchronisierung fortfahren?"
  },
  "integrationAI": {
    "accountDisconnected": "Konto wurde getrennt!",
    "appNotFound": "App-Konfiguration nicht gefunden. Fallbackdaten werden verwendet.",
    "checkingConnection": "Verbindungsstatus wird geprüft …",
    "connecting": "Verbindung wird hergestellt …",
    "disconnectApp": "App trennen",
    "disconnecting": "Wird getrennt …",
    "loadingAppInfo": "App-Informationen werden geladen …",
    "refreshConnection": "Verbindung aktualisieren",
    "refreshing": "Wird aktualisiert …",
    "svgNotAvailable": "SVG nicht verfügbar"
  },
  "phoneSystem": {
    "additionalSettings": "Zusätzliche Einstellungen",
    "messaging": "Messaging",
    "messagingAnalytics": "Messaging-Statistiken",
    "regulatoryBundles": "Regulierungspakete",
    "title": "Telefonsystem",
    "trustCenter": "Trust-Center",
    "voice": "Sprache"
  },
  "demo": {
    "draggable": {
      "title": "Test eines Widgets mit Ziehfunktion",
      "usingVue3": "Verwendung von Vue 3-kompatiblem Draggable",
      "description": "Diese Komponente verwendet nun die überarbeitete, mit Vue 3 kompatible, verschiebbare Komponente.",
      "buttons": {
        "resetAllLists": "Alle Listen zurücksetzen",
        "clearLog": "Protokoll löschen",
        "stopLoading": "Laden stoppen",
        "simulateLoading": "Laden simulieren",
        "refreshData": "Daten aktualisieren"
      },
      "examples": {
        "basicDraggable": "Einfach verschiebbar",
        "draggableWithElement": "Verschiebbar mit Element",
        "draggableWithTransitionGroup": "Verschiebbar mit Übergangsgruppe",
        "draggableWithMoveFunction": "Verschiebbar mit Schrittfunktion"
      },
      "eventLog": "Veranstaltungs-Log",
      "handle": "Handle",
      "name": "Name",
      "cannotMove": "(kann nicht verschoben werden)"
    },
    "tableDemo": {
      "title": "Demo von Vue 3 UIBTable",
      "basicControls": "Grundlegende Steuerungen",
      "labels": {
        "filter": "Filter:",
        "sortBy": "Sortieren nach:",
        "sortDirection": "Filterrichtung:",
        "perPage": "Pro Seite:",
        "tableStyling": "Tabellen-Styling:"
      },
      "placeholders": {
        "typeToSearch": "Suchbegriff eingeben..."
      },
      "checkboxLabels": {
        "striped": "Gestreift",
        "bordered": "Umrandet",
        "hover": "Hover",
        "small": "Klein",
        "responsive": "Reaktionsfähig"
      },
      "fields": {
        "id": "ID",
        "name": "Name",
        "email": "E-Mail",
        "status": "Status",
        "created": "Erstellt",
        "actions": "Aktionen"
      },
      "statuses": {
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "pending": "Anhängig",
        "banned": "Gesperrt"
      },
      "modal": {
        "title": "Artikeldetails",
        "close": "Schließen"
      },
      "messages": {
        "confirmDelete": "Sind Sie sicher, dass Sie {name} löschen möchten?",
        "editItem": "Objekt {id} bearbeiten",
        "showingItems": "{count} von {total} Artikeln werden angezeigt"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Speichern und weiter",
      "everythingIn": "Alles in <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "hier Kreditkarte hinzufügen",
        "message": "Bitte bitten Sie Ihren Kunden, zu",
        "title": "Es muss zuerst eine Zahlungsmethode für den Standort hinzugefügt werden."
      },
      "noSaasPlan": {
        "linkText": "erzeugen Sie hier Ihre SaaS-Pläne.",
        "message": "Bitte",
        "title": "Sie haben keinen SaaS-Plan konfiguriert."
      },
      "saasModeSetupPendingWarning": "Der SaaS-Plan wird aktiviert, nachdem der Kunde eine Zahlungsmethode hinzugefügt hat. Bis dahin wird der Login auf ihr Konto privat sein.",
      "skipForNow": "Jetzt überspringen",
      "skipPlan": "Zeitplan überspringen"
    }
  },
  "isv": {
    "business_registration_id_type": "Unternehmensregistrierungs-ID-Typ",
    "business_registration_number": "Unternehmensregisternummer",
    "business_website": "Unternehmenswebsite",
    "enter_your_business_registration_id_type": "Wählen Sie den Unternehmensregistrierungs-ID-Typ",
    "name_of_other_registration_id_type": "Name des sonstigen Registrierungs-ID-Typs",
    "pick_business_industry": "Wählen Sie Branche aus",
    "pick_business_registration_id_type": "Unternehmensregistrierungs-ID-Typ auswählen",
    "emailWithStar": "E-Mail*",
    "businessIndustry": "Unternehmen Branche*",
    "businessType": "Unternehmenstyp*",
    "regionsOfOperations": "Geschäftsregionen der Operations*",
    "registrationNumber": "Unternehmensregisternummer*",
    "registrationNumberHelper": "Die Identifikationsnummer Ihres Unternehmens. Im Falle einer US-EIN muss es sich um eine 9-stellige Nummer handeln, z. B. 12-3456789.",
    "businessWebsiteWithStar": "Unternehmens-Website*",
    "businessTypeWithStar": "Unternehmensart",
    "businessWebsite": "Unternehmenswebsite"
  },
  "aiProductRebilling": {
    "enableRebilling": "Neuberechnung aktivieren",
    "ratesMayDiffer": "Die Preise können je nach Region variieren. Die angezeigten Berechnungen basieren auf den Tarifen für das Vereinigte Königreich,",
    "supportDoc": "Support-Dokumentation",
    "cancel": "Stornieren",
    "profit": "Gewinn",
    "chargedToCustomer": "Dem Kunden in Rechnung gestellt:",
    "enabling": "Aktivieren...",
    "forMore": "für mehr Details.",
    "rebillAmount": "Erneuter Abrechnungsbetrag",
    "tenDollarsWillGive": "Für 10 USD erhalten Sie ungefähr",
    "yourCost": "Ihre Kosten",
    "clientBillingPage": "Abrechnungsseite des Unternehmens des Kunden",
    "needStripeConnection": "Um das Rebilling zu aktivieren, müssen Sie Ihr Stripe-Konto verbinden",
    "per1000Words": "pro 1000 Wörter",
    "perImage": "pro Bild",
    "perReviewResponse": "gemäß der Antwort auf die Rezension",
    "perFunnel": "pro Funnel",
    "minimumBetween": "Der Minimalwert muss zwischen {min} und {max}liegen.",
    "images": "Bilder",
    "reviewResponse": "Bewertungsantwort",
    "funnel": "Funnel",
    "pleaseCheckSupport": "Bitte überprüfen Sie"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP erfolgreich.",
      "message": "OTP-Erfolgsmeldung"
    },
    "otpError": {
      "title": "OTP-Fehler",
      "message": "OTP-Fehlermeldung"
    },
    "businessProfileError": {
      "title": "Fehler im Geschäftsprofil",
      "message": "Fehlermeldung im Business-Profil"
    },
    "addressError": {
      "title": "Adressfehler",
      "status": "Fehlerstatus der Adresse"
    },
    "profileError": {
      "title": "A2P-Profilfehler",
      "message": "A2P-Profil-Fehlermeldung"
    },
    "address": {
      "country": "Land",
      "state": "Land",
      "chooseCountry": "Land auswählen …",
      "statePlaceholder": "Bundesland eingeben",
      "chooseState": "Bundesland auswählen …",
      "city": "Stadt*",
      "postalCode": "Postleitzahl*",
      "streetAddress": "Anschrift*",
      "streetAddressHelper": "Es muss eine gültige Anschrift sein, die mit Ihrem Unternehmen verknüpft ist.",
      "title": "Geschäftsadresse"
    },
    "validation": {
      "brandNameRequired": "Der Markenname ist erforderlich.",
      "businessVerticalRequired": "Geschäftsbereich ist erforderlich.",
      "cityRequired": "Die Stadt ist erforderlich.",
      "countryRequired": "Land ist erforderlich.",
      "invalidMobileNumber": "Ungültige Mobilnummer.",
      "mobileNumberRequired": "Mobilrufnummer ist erforderlich.",
      "postalCodeRequired": "Postleitzahl / PLZ ist erforderlich.",
      "stateRequired": "Bundesland ist erforderlich.",
      "streetAddressRequired": "Anschrift ist erforderlich."
    },
    "authorizedRep": {
      "email": "E-Mail*",
      "firstName": "Vorname*",
      "jobPosition": "Stellenbezeichnung*",
      "jobTitle": "Berufsbezeichnung*",
      "jobTitlePlaceholder": "Geben Sie die Stellenbezeichnung ein",
      "lastName": "Nachname*",
      "phoneNumber": "Telefonnummer*",
      "phoneNumberPlaceholder": "Rufnummer eingeben",
      "pickJobPosition": "Jobposition auswählen",
      "title": "Details zum bevollmächtigten Vertreter"
    },
    "registration": {
      "stepProgress": "Schritt {currentStep} von 8",
      "successTitle": "Ihre A2P-Marke und -Kampagne wurden eingereicht.",
      "successWaitDays": "7 Tage",
      "successWaitPrefix": "Es könnte dauern bis zu ",
      "successWaitSuffix": " für Ihre Marken-Boards Genehmigung und weitere 4-5 Wochen für die Kampagne Genehmigung.",
      "otpNote": "Hinweis: Sie werden von TCR zur Überprüfung eine OTP-Nachricht auf die angegebene Mobilrufnummer erhalten. Bitte antworten Sie innerhalb von 24 Stunden nach Erhalt der SMS mit „Yes“."
    },
    "update": {
      "brandDetailsTitle": "Aktualisieren Sie die Markendetails",
      "brandName": "Markenname*",
      "brandNameHelper": "Verwenden Sie entweder den rechtlichen Namen der Organisation, die die Nachrichten sendet, oder Ihren eigenen Namen, wenn diese Marke nicht für eine Organisation bestimmt ist.",
      "businessVerticals": "Unternehmen Branche*",
      "chooseVertical": "Bereich auswählen …",
      "mobileNumber": "Mobilrufnummer für die OTP-Verifizierung (mit Ländervorwahl)*",
      "mobileNumberHelper": "Bitte geben Sie eine Mobilrufnummer an, auf die Sie Zugriff haben, damit Sie die OTP-Verifizierung vornehmen können. Nur US-/kanadische Nummern werden akzeptiert. Sie dürfen keine CPaaS-Rufnummer verwenden, wie zum Beispiel eine, die von LeadConnector bezogen wurde. Sie können dieselbe Mobilrufnummer nicht verwenden, um mehr als 3 Einzelunternehmermarken zu registrieren. Dieses Limit wird durch TCR verwaltet.",
      "updateButton": "Aktualisieren",
      "retryOTPTitle": "OTP erneut senden",
      "retryOTPMessage": "Klicken Sie auf die Schaltfläche unten, um die OTP-Verifizierungsnachricht erneut zu senden.",
      "sending": "Wird gesendet …",
      "resendOTP": "OTP erneut senden"
    },
    "einModal": {
      "title": "Haben Sie eine EIN?",
      "question": "Haben Sie eine Arbeitgeber-Identifikationsnummer (EIN)?",
      "hasEIN": "Ja, ich habe eine EIN",
      "noEIN": "Nein, ich habe keine EIN",
      "disableNoEINText": "EIN ist für Standorte außerhalb der USA/CA erforderlich",
      "infoText": "Eine EIN ist für Unternehmen in den Vereinigten Staaten und Kanada erforderlich."
    },
    "brandDetails": {
      "brandHeading": "Markendetails",
      "brandName": "Markenname*",
      "brandNameHelper": "Verwenden Sie entweder den offiziellen Namen des Unternehmens, von dem die Nachrichten versendet werden, oder Ihren eigenen Namen, falls es sich bei dieser Marke nicht um ein Unternehmen handelt.",
      "businessIndustry": "Unternehmensbranche*",
      "chooseVertical": "Geschäftsbereich auswählen …",
      "mobileNumber": "Mobilrufnummer für die OTP-Verifizierung (mit Ländervorwahl)*",
      "mobileNumberHelper": "Bitte geben Sie eine Mobilrufnummer an, auf die Sie Zugriff haben, damit Sie die OTP-Verifizierung vornehmen können. Nur US-/kanadische Nummern werden akzeptiert. Sie dürfen keine CPaaS-Rufnummer verwenden, wie zum Beispiel eine, die von LeadConnector bezogen wurde. Sie können dieselbe Mobilrufnummer nicht verwenden, um mehr als 3 Einzelunternehmermarken zu registrieren. Dieses Limit wird durch TCR verwaltet.",
      "solePropBrand": {
        "heading": "Einzelunternehmermarke",
        "point1": "Nur eine Rufnummer erlaubt",
        "point2": "EIN/SSN/DUNS nicht erforderlich",
        "subheading": "Registrierung der Marke Sole Prop"
      },
      "solePropCampaign": {
        "heading": "Einzelunternehmerkampagne",
        "point1": "Nur eine Nummer darf mit einer Sole Prop Kampagne verknüpft werden.",
        "point2": "Sobald genehmigt, wird Ihre Standardnummer automatisch verknüpft.",
        "infoText": "Sie können die Nummer auch nach der Genehmigung aktualisieren",
        "warningText": "Nur eine Nummer darf mit einer Einzelkampagne verknüpft werden. Sobald angenommen, wird Ihre Standardanzahl automatisch verknüpft. Sie können die Anzahl auch nach der Genehmigung aktualisieren.",
        "subheading": "Registrierung der Einzelunternehmer-Kampagne"
      },
      "solePropSubtitle": "Einzelunternehmermarken- und Kampagnendetails",
      "standardBrand": {
        "heading": "4,41 USD – Einmalig",
        "point1": "EIN/SSN/DUNS erforderlich",
        "point2": "Mehr als eine Rufnummer erlaubt",
        "subheading": "Standard-Markenregistrierung"
      },
      "standardCampaign": {
        "heading": "16,54 USD - einmalig",
        "point1": "Mehr als eine Nummer darf mit einer Standardkampagne verknüpft werden.",
        "point2": "EIN/SSN/DUNS erforderlich",
        "infoText": "Zusätzliche Kampagnengebühr von bis zu 12 USD je Monat wird gemäß den TCR-Regeln angewendet.",
        "subheading": "Standard-Kampagnenregistrierung"
      },
      "standardSubtitle": "Standardmarken- und Kampagnendetails",
      "title": "Marken- und Kampagnendetails"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Details zum Anwendungsfall einer Kampagne",
        "subtitle": "Bitte geben Sie die Kampagnendetails und die Beschreibung ein.",
        "useCase": "Kampagnenanwendungsfall*",
        "pickUseCase": "Anwendungsfall der Auswahlkampagne",
        "useCaseDescription": "Beschreibung des Anwendungsfalls*",
        "explainInDetail": "Bitte erläutern Sie dies ausführlich.",
        "useCaseDescriptionPlaceholder": "Beispiel: Diese Kampagne sendet Terminbestätigungs- und Erinnerungsnachrichten an unsere Kunden, sobald diese einen Termin über unsere Website gebucht und sich für den Erhalt von Werbe- und Benachrichtigungs-SMS von uns angemeldet haben.",
        "useCaseDescriptionHelper": "Bitte geben Sie eine ausführliche Beschreibung, wie Sie diese Kampagne verwenden werden.",
        "solePropLabel": "Einzelunternehmer",
        "seeExamples": "Beispiele ansehen",
        "closeExamples": "Beispiele schließen"
      }
    }
  },
  "opportunities": {
    "email": "E-Mail",
    "phone": "Telefon",
    "status": "Status",
    "contactType": "Kontakttyp",
    "bulkOperation": "Massenvorgang",
    "contactName": "Kontaktname",
    "unassigned": "Nicht zugewiesen",
    "abandoned": "Nicht abgeschlossen",
    "addOpportunityName": "Name der Opportunity hinzufügen",
    "companyName": "Unternehmensname",
    "contactInfo": "Kontaktdaten",
    "enterValue": "Geben Sie einen Wert ein",
    "lost": "Verpasst",
    "open": "Offen",
    "opportunityInfo": "Informationen zur Gelegenheit",
    "opportunityName": "Name der Opportunity",
    "opportunitySource": "Quelle der Opportunity",
    "owner": "Eigentümer",
    "pipeline": "Pipeline",
    "selectPipeline": "Funnel auswählen",
    "selectStage": "Phase auswählen",
    "stage": "Schritt",
    "won": "Gewonnen",
    "createdOn": "Erstellt An",
    "goToContactDetail": "Gehen Sie zur Kontaktdetailseite",
    "leadValue": "Leitwert",
    "removeOwner": "Eigentümer entfernen",
    "createdBy": "Erstellt von",
    "notAllowedToChange": "Sie dürfen diesen Kontakt nicht ändern.",
    "opportunityAlreadyExists": "Für diesen Kontakt existiert bereits eine Gelegenheit in der ausgewählten Pipeline.",
    "filters": {
      "all": "Alle",
      "statuses": {
        "all": "Alle",
        "open": "Öffnen",
        "won": "Gewonnen",
        "lost": "Verloren",
        "abandoned": "Abgebrochen"
      },
      "search": "Suchen",
      "status": "Status",
      "campaign": "Kampagne",
      "owner": "Eigentümer",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Hinzugefügt am (aufsteigend)",
      "dateAddedDesc": "↓ Hinzugefügt am (absteigend)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Notiz",
      "task": "Aufgabe",
      "companyName": "Unternehmensname",
      "additionalInfo": "Zusätzliche Informationen",
      "calendarEvent": "Kalenderveranstaltung",
      "hideAssignedTo": "„Zugewiesen an“ ausblenden",
      "hideTags": "Tags ausblenden"
    },
    "buttons": {
      "new": "Neu"
    },
    "dragActions": {
      "abandoned": "Abgebrochen",
      "lost": "Verloren",
      "won": "Gewonnen"
    },
    "getStarted": "loszulegen!",
    "noPipelines": "Hoppla – es scheint keine Pipelines zu geben! Erstellen Sie eine neue Pipeline, um",
    "addTask": "Aufgabe hinzufügen",
    "tasksCount": "{count} Aktivitäten"
  },
  "appointmentDetails": "Termindetails",
  "cloneFunnel": {
    "cloneButton": "{entityName} klonen",
    "cloning": "Klonen...",
    "cloningLimit": "Das Klonen ist auf 3 Standorte beschränkt",
    "error": "Fehler beim Klonen des Funnels!",
    "locationsLabel": "Wählen Sie Standorte aus",
    "nameLabel": "Name für das geklonte {entityName}",
    "namePlaceholder": "Geben Sie einen Namen für den geklonten {entityName}ein",
    "selectUpTo": "Wählen Sie bis zu {maxSelectableLocations} Standorte aus",
    "title": "{entityName} klonen"
  },
  "errors": "Fehler",
  "renderEmailAddress": "E-Mail-Adresse rendern",
  "noPaymentMethodWarning": "Warnung: Keine Zahlungsmethode",
  "pageDetail": "Seitendetail",
  "activityHistory": "Aktivitätsverlauf",
  "uiAlert": "UI-Benachrichtigung",
  "eventModals": {
    "wait": {
      "save": "Speichern",
      "days": "Tage",
      "fri": "Fr",
      "mon": "Mo",
      "sat": "Sa",
      "sun": "So",
      "thu": "Do",
      "tue": "Di",
      "wed": "Mi",
      "wait": "Warten",
      "minutes": "Minuten",
      "hours": "Stunden",
      "title": "Warteereignis bearbeiten",
      "whichDaysResume": "Welche Tage sollten wir fortsetzen?",
      "pickDayError": "Bitte wählen Sie mindestens einen Tag aus",
      "whatTimeResume": "Um wie viel Uhr sollten wir fortfahren?"
    },
    "sms": {
      "send": "Senden",
      "name": "Name",
      "attachFile": "Datei anhängen",
      "learnMore": "Mehr erfahren",
      "sendTest": "Test senden",
      "title": "{eventType} -Ereignis bearbeiten",
      "titleTemplate": "Bearbeiten Sie die Vorlage {eventType}",
      "nameRequired": "Name ist erforderlich",
      "pickTemplate": "Vorlage auswählen",
      "appCharacters": "App-Zeichen",
      "numSegments": "Anzahl Segmente",
      "approximateCost": "Ungefähre Kosten",
      "costEstimateNote": "Kostenschätzungshinweis",
      "urlAttachmentAutocompleteToken": "URL-Anhang",
      "addFileUrl": "Datei-URL hinzufügen",
      "urlImageAlt": "Bild-URL",
      "fileImageAlt": "Dateibild",
      "enterMessage": "Geben Sie eine Nachricht ein",
      "mobilePhonePlaceholder": "Mobiltelefon",
      "unsupportedContentType": "Nicht unterstützter Inhaltstyp: {fileType}",
      "urlAttachmentWarning": "{count} URL-Anhang{plural} nicht geladen. Möchten Sie fortfahren?",
      "provideMobileNumber": "Bitte geben Sie die Mobilnummer an."
    },
    "email": {
      "text": "Text",
      "checkLinks": "Bitte überprüfen Sie die Links, bei denen Sie einen benutzerdefinierten Wert haben. Zwischen {{ und custom_values befindet sich ein zusätzliches '%20'.",
      "errorOccurred": "Es ist fehlgeschlagen, bitte erneut versuchen.",
      "insertToAddress": "Bitte geben Sie eine Empfängeradresse ein."
    },
    "voicemail": {
      "save": "Speichern",
      "dropFile": "Legen Sie die Datei hier ab oder klicken Sie, um sie hochzuladen.",
      "faq": "FAQ",
      "title": "Voicemail-Ereignis bearbeiten",
      "voicemailFile": "Voicemail-Datei",
      "warning": "Warnung: Voicemail-Dateien müssen im MP3-, WAV- oder GSM-Format vorliegen.",
      "unsupportedFormat": "Das Dateiformat wird nicht unterstützt. Bitte verwenden Sie MP3, WAV oder GSM."
    },
    "call": {
      "title": "Anrufereignis bearbeiten",
      "save": "Speichern",
      "name": "Name",
      "nameRequired": "Name ist erforderlich",
      "callWhisper": "Whisper-Anruf",
      "whisperMessage": "Whispernachricht",
      "thisIsTheMessage": "Dies ist die Nachricht, die dem Agenten vorgespielt wird, bevor der Anruf verbunden wird.",
      "callTimeoutS": "Anruf-Timeout (s)",
      "timeoutSeconds": "Timeout (Sekunden)",
      "disableVoicemailDetect": "Voicemail-Erkennung deaktivieren",
      "callWillPatchInstantly": "Der Anruf wird sofort verbunden, ohne dass die Voicemail erkannt wird."
    }
  },
  "emailTemplate": {
    "createdOn": "Erstellt am",
    "updatedOn": "Aktualisiert am"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Mehr erfahren",
      "description": "CNAM-Beschreibung"
    },
    "submitted": {
      "checkStatus": "CNAM-Status überprüfen",
      "description": "Ihr Anzeigename in WhatsApp Business sollte in etwa 3-5 Tagen den entsprechenden Kontakten angezeigt werden.",
      "subtitle": "Ihre CNAM-Anfrage wurde jetzt übermittelt.",
      "title": "Herzlichen Glückwunsch!"
    },
    "registration": {
      "confirm": "Bestätigen",
      "learnMore": "Mehr erfahren",
      "characterLimit": "{count}/15",
      "title": "CNAM-Registrierung",
      "description": "Geben Sie Ihren Firmennamen ein (max. 15 Zeichen)",
      "warning": "Warnung: Ihr Firmenname wird auf der Anrufer-ID angezeigt. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Aktualisierungsfehler",
      "message": "Aktualisierungs-Fehlermeldung"
    },
    "success": {
      "message": "Ihre A2P-Marken-Boards und Kampagne wurden eingereicht.<br/><br/><b>Nachricht:</b> Sie werden <b>eine OTP-Nachricht auf Ihre ausgestellte Mobil Anzahl von TCR erben, um diese zu überprüfen</b>. Bitte <b>senden Sie innerhalb von 24 Stunden nach Empfang der SMS eine Antwort mit 'Ja'</b>.",
      "title": "Ihre A2P-Marke und -Kampagne wurden eingereicht. Die Genehmigung Ihrer Marke kann bis zu <b>7 Tage</b> dauern, die Genehmigung der Kampagne weitere 4–5 Wochen."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Fehler im regulatorischen Bündel",
      "status": "Regulatorisches Paket Fehlerstatus"
    },
    "createAddress": {
      "successMessage": "Ihre A2P-Marke und -Kampagne wurden eingereicht.",
      "successTitle": "Anschrift erfolgreich übermittelt",
      "underReview": "Die eingereichte Anschrift wird geprüft"
    },
    "createEndUser": {
      "dateFormat": "Das Datumsformat sollte YYYY-MM-DD sein.",
      "phoneExample": " Model: +14155552671",
      "title": "Geschäftliche Angaben:"
    },
    "success": {
      "title": "Regulatorisches Paket erfolgreich übermittelt.",
      "underReview": "Paket übermittelt und unter Bewertung",
      "message": "Ihr Antrag auf SHAKEN/STIR-Registrierung wurde übermittelt. Die Genehmigung kann bis zu <b>3-4 Tage</b> dauern. Der Status wird in Kürze aktualisiert."
    },
    "documents": {
      "additionalInfo": "Zusätzliche Informationen",
      "createAddressLink": "Anschrift erzeugen.",
      "createAddressPrompt": "Bitte erzeugen Sie zuerst eine Anschrift und fahren Sie dann mit der Erstellung des Bundles fort.",
      "selectAddress": "Anschrift auswählen:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "Mit dieser Option wird Ihrem Konto eine neue Adresse hinzugefügt",
        "label": "Adresspaket"
      },
      "regulatoryBundle": {
        "description": "Diese Option hilft Sie, ein neues Regulierungspaket zu Erzeugen",
        "label": "Regulatorisches Bundle"
      },
      "title": "Wählen Sie, welches Paket Sie hinzufügen möchten"
    },
    "modal": {
      "back": "Zurück",
      "next": "Weiter",
      "submit": "Absenden",
      "title": "Neues Regulatorisches Bundle",
      "description": "Erstellen Sie ein neues regulatorisches Bündel für Ihren Standort"
    }
  },
  "reminder": {
    "phone": "Rufnummer",
    "noReplyYet": "Noch keine Antwort erhalten"
  },
  "sendGrid": {
    "apiKey": "SendGrid-API-Schlüssel",
    "save": "SendGrid speichern",
    "apiKeyRequired": "SendGrid-API-Schlüssel erforderlich"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Upgrade",
      "subtitle": "Agenturen mit Pro-Tarif verdienen etwa 363 US-Dollar pro Monat, indem sie die Telefonkosten an ihre Kunden weiterrechnen.",
      "title": "Möchten Sie dies Ihren Kunden erneut in Rechnung stellen?"
    }
  },
  "emailField": {
    "label": "E-Mail",
    "placeholder": "E-Mail",
    "tooltip": {
      "primary": "Primäre",
      "emails": "E-Mails"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Schnappschuss laden:",
    "loadSnapshotWarning": "Möchten Sie den mit diesem Plan verbundenen Schnappschuss laden? <br /> <strong class='text-danger'>Vorhandene Daten können verloren gehen</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Nur Agenturansicht-Administratoren/-Benutzer haben Login auf dieses Konto. Derzeit haben Sie und andere Kontoadministratoren/Benutzer keinen Login auf dieses Unterkonto.",
      "heading": "Dieses Unterkonto wurde gesperrt."
    },
    "temporarily": {
      "description": "Alle Ihre Daten sind sicher und alle Auslöser/Kampagnen usw. werden nach der Aktivierung wieder funktionieren.",
      "heading": " Ihr Konto wurde vorübergehend gesperrt."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Üblicher Unternehmensname",
    "title": "Anrufer-ID aktualisieren"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Büro auswählen",
    "whichOffice": "Welche Niederlassung möchten Sie mit diesem Konto verknüpfen?",
    "connect": "Verbinden!"
  },
  "phoneField": {
    "label": "Telefon",
    "placeholder": "Telefonnummer",
    "tooltip": {
      "invalidNumber": "Ungültige Telefonnummer",
      "notSmsCapable": "Diese {type} -Nummer ist nicht SMS-fähig."
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Buchungsdetails",
      "form": "Formular",
      "quiz": "Quiz",
      "submissionDetail": "Details zur Einreichung",
      "survey": "Umfrage"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Ihr Antrag auf SHAKEN/STIR-Registrierung wurde übermittelt. Die Genehmigung kann bis zu <b>3-4 Tage</b> dauern. Der Status wird in Kürze aktualisiert.",
      "title": "SHAKEN/STIR Trusted Calling ist aktiviert."
    },
    "modal": {
      "andThe": " und die ",
      "businessProfile": "Unternehmensprofil",
      "certification": "Ich bestätige, dass das zugehörige Geschäftsprofil der Urheber der Anrufe ist, und erkläre mich bereit, an Rückverfolgungsmaßnahmen mitzuwirken, einschließlich solcher, die von der/dem [Name der Organisation] eingeleitet werden.",
      "failedTitle": "Einreichung fehlgeschlagen",
      "friendlyName": "Friendly Name",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 um 19:47:14",
      "linkInfo": {
        "description": "Alle derzeit verfügbaren Nummern und zukünftig gekaufte Nummern werden automatisch bei SHAKEN/STIR registriert.",
        "title": "Alle Nummern werden automatisch verknüpft"
      },
      "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
      "subtitle": "Geben Sie die Details und die Beschreibung ein",
      "successMessage": "Ihr Antrag auf SHAKEN/STIR-Registrierung wurde übermittelt. Die Genehmigung kann bis zu <b>3-4 Tage</b> dauern. Der Status wird in Kürze aktualisiert.",
      "successTitle": "SHAKEN/STIR Trusted Calling ist aktiviert.",
      "title": "SHAKEN/STIR Trusted Calling aktivieren",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Melden Sie sich für CNAM an, um Ihren Firmennamen auf der Anrufer-ID anzuzeigen",
      "registerCnam": "Registrieren Sie CNAM"
    }
  },
  "task": {
    "2day": "2 Tage",
    "3day": "3 Tage",
    "4day": "4 Tage",
    "5day": "5 Tage",
    "addTask": "Aufgabe hinzufügen",
    "countTasks": "{count} Aktivitäten"
  },
  "updatedProductsModal": {
    "title": "Aktualisierte Produkte",
    "copyDirectSaleLink": "Direktverkaufslink kopieren",
    "setupFeeInstruction": "Die Einrichtungsgebühr kann im Stripe-Dashboard konfiguriert werden. ",
    "doNotDeleteWarning": "Produkte oder Preise dürfen nicht aus dem Stripe-Dashboard gelöscht werden. Dies wird die Integration stören."
  },
  "termsOfService": {
    "privacyLink": "Datenschutzrichtlinie",
    "accept": "Akzeptieren",
    "termsLink": "Nutzungsbedingungen",
    "updateMessage": "Wir haben unsere Nutzungsbedingungen und unsere Datenschutzrichtlinie aktualisiert. Bitte überprüfen und akzeptieren Sie, um fortzufahren.",
    "agreementPrefix": "Indem Sie fortfahren, stimmen Sie unseren ",
    "agreementConjunction": " und "
  },
  "callerIdVerificationModal": {
    "answerCall": "Nehmen Sie den Anruf entgegen und geben Sie diesen Verifizierungscode ein:",
    "leadConnectorCalling": "Lead Connector ruft an...",
    "title": "Eine Anrufer-ID per Sprache hinzufügen",
    "waitingForVerification": "Bitte warten Sie auf die Verifizierung..."
  },
  "emailOTPModal": {
    "confirmCode": "Code bestätigen",
    "resendCode": "Falls Sie den Code nicht erhalten haben, klicken Sie hier, um ihn erneut zu senden."
  },
  "survey": {
    "copy": {
      "cancel": "Stornieren",
      "location": "Ort",
      "copy": "Kopieren",
      "newSurveyName": "Neuer Umfrage Name",
      "title": "Umfrage kopieren",
      "locationRequired": "Standort ist erforderlich"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Produktname",
    "planDetails": "Tarif-Einzelheiten",
    "title": "Beschreibung des Produkts",
    "planId": "Plan-ID",
    "copiedToClipboard": "In die Zwischenablage kopiert"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "Effizienter",
      "faster": "Schneller",
      "itsText": "Es ist",
      "smoother": "Reibungsloser",
      "title": "Wir haben unsere Importfunktion ganz neu gestaltet!",
      "warningMessage": "Durch Aktivieren der neuen Importfunktion wird Labs für dieses Unterkonto aktiviert und die Beta-Funktion eingeschaltet.",
      "tryNow": "Jetzt ausprobieren"
    },
    "validateEmails": "E-Mails validieren?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel-Preis",
      "howDoesItWork": "Wie funktioniert das?",
      "payNow": "Jetzt bezahlen",
      "priceError": "Der Preis muss größer oder gleich dem HighLevel-Preis sein",
      "saving": "Speichern",
      "yourPrice": "Ihr Preis",
      "yourProfit": "Ihr Gewinn",
      "subscriptionCreating": "Das Abonnement wird erstellt.<br/>Bitte laden Sie die Seite nicht neu und klicken Sie nicht auf die Zurück-Schaltfläche",
      "subscriptionCreated": "Abonnement erfolgreich erstellt. Bitte warten …",
      "unableToCreate": "Es kann kein Abonnement erstellt werden, bitte den Support kontaktieren",
      "perMonth": "pro Monat",
      "agreeToEnable": "Ich bin einverstanden mit der Aktivierung von Listings für diesen Kunden ohne Upselling und nehme zur Kenntnis, dass mir Kosten in Rechnung gestellt werden",
      "deployDirectly": "Listings direkt bereitstellen",
      "deployDirectlyDesc": "Verwenden Sie diese Option, falls Sie Listings als Teil Ihres Angebots anbieten oder falls Sie Ihrem Kunden eine externe Rechnung stellen möchten",
      "minimumCommitment": "mit einer Mindestbindungsdauer von 1 Monat.",
      "offerListings": "Angebotsübersichten",
      "resellListings": "Listings wiederverkaufen",
      "subscribedInfo": "{withoutUpsell} ohne Upsell, {withUpsell} mit Upsell und {withSaas} mit SaaS-Bundle",
      "yourResellOffer": "Ihr Wiederverkaufsangebot"
    }
  }
}
